(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $670431cece713cbd$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $670431cece713cbd$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $670431cece713cbd$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $670431cece713cbd$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ function $685ec1f5000467c6$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


var $c201f6852eb68a0f$var$extendStatics = function extendStatics1(d, b) {
    $c201f6852eb68a0f$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $c201f6852eb68a0f$var$extendStatics(d, b);
};
function $c201f6852eb68a0f$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $c201f6852eb68a0f$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $c201f6852eb68a0f$export$18ce0697a983be9b = function __assign1() {
    $c201f6852eb68a0f$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c201f6852eb68a0f$export$18ce0697a983be9b.apply(this, arguments);
};
function $c201f6852eb68a0f$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $c201f6852eb68a0f$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $685ec1f5000467c6$export$71511d61b312f219)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $c201f6852eb68a0f$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $c201f6852eb68a0f$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $685ec1f5000467c6$export$71511d61b312f219)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $c201f6852eb68a0f$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $c201f6852eb68a0f$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $685ec1f5000467c6$export$71511d61b312f219)(x)) === "symbol" ? x : "".concat(x);
}
function $c201f6852eb68a0f$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $685ec1f5000467c6$export$71511d61b312f219)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $c201f6852eb68a0f$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $685ec1f5000467c6$export$71511d61b312f219)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $c201f6852eb68a0f$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $c201f6852eb68a0f$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $c201f6852eb68a0f$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $c201f6852eb68a0f$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $c201f6852eb68a0f$export$45d3717a4c69092e(o, m, p);
}
function $c201f6852eb68a0f$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $c201f6852eb68a0f$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $c201f6852eb68a0f$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($c201f6852eb68a0f$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $c201f6852eb68a0f$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $c201f6852eb68a0f$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $c201f6852eb68a0f$export$10c90e4f7922046c(v) {
    return this instanceof $c201f6852eb68a0f$export$10c90e4f7922046c ? (this.v = v, this) : new $c201f6852eb68a0f$export$10c90e4f7922046c(v);
}
function $c201f6852eb68a0f$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $c201f6852eb68a0f$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $c201f6852eb68a0f$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $c201f6852eb68a0f$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $c201f6852eb68a0f$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $c201f6852eb68a0f$export$19a8beecd37a4c45 === "function" ? $c201f6852eb68a0f$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $c201f6852eb68a0f$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $c201f6852eb68a0f$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $c201f6852eb68a0f$var$ownKeys = function ownKeys1(o) {
    $c201f6852eb68a0f$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $c201f6852eb68a0f$var$ownKeys(o);
};
function $c201f6852eb68a0f$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $c201f6852eb68a0f$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $c201f6852eb68a0f$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $c201f6852eb68a0f$var$__setModuleDefault(result, mod);
    return result;
}
function $c201f6852eb68a0f$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
}
function $c201f6852eb68a0f$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $c201f6852eb68a0f$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $c201f6852eb68a0f$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $685ec1f5000467c6$export$71511d61b312f219)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $c201f6852eb68a0f$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $685ec1f5000467c6$export$71511d61b312f219)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $c201f6852eb68a0f$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $c201f6852eb68a0f$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $c201f6852eb68a0f$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $c201f6852eb68a0f$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $c201f6852eb68a0f$export$2e2bcd8739ae039 = {
    __extends: $c201f6852eb68a0f$export$a8ba968b8961cb8a,
    __assign: $c201f6852eb68a0f$export$18ce0697a983be9b,
    __rest: $c201f6852eb68a0f$export$3c9a16f847548506,
    __decorate: $c201f6852eb68a0f$export$29e00dfd3077644b,
    __param: $c201f6852eb68a0f$export$d5ad3fd78186038f,
    __esDecorate: $c201f6852eb68a0f$export$3a84e1ae4e97e9b0,
    __runInitializers: $c201f6852eb68a0f$export$d831c04e792af3d,
    __propKey: $c201f6852eb68a0f$export$6a2a36740a146cb8,
    __setFunctionName: $c201f6852eb68a0f$export$d1a06452d3489bc7,
    __metadata: $c201f6852eb68a0f$export$f1db080c865becb9,
    __awaiter: $c201f6852eb68a0f$export$1050f835b63b671e,
    __generator: $c201f6852eb68a0f$export$67ebef60e6f28a6,
    __createBinding: $c201f6852eb68a0f$export$45d3717a4c69092e,
    __exportStar: $c201f6852eb68a0f$export$f33643c0debef087,
    __values: $c201f6852eb68a0f$export$19a8beecd37a4c45,
    __read: $c201f6852eb68a0f$export$8d051b38c9118094,
    __spread: $c201f6852eb68a0f$export$afc72e2116322959,
    __spreadArrays: $c201f6852eb68a0f$export$6388937ca91ccae8,
    __spreadArray: $c201f6852eb68a0f$export$1216008129fb82ed,
    __await: $c201f6852eb68a0f$export$10c90e4f7922046c,
    __asyncGenerator: $c201f6852eb68a0f$export$e427f37a30a4de9b,
    __asyncDelegator: $c201f6852eb68a0f$export$bbd80228419bb833,
    __asyncValues: $c201f6852eb68a0f$export$e3b29a3d6162315f,
    __makeTemplateObject: $c201f6852eb68a0f$export$4fb47efe1390b86f,
    __importStar: $c201f6852eb68a0f$export$c21735bcef00d192,
    __importDefault: $c201f6852eb68a0f$export$da59b14a69baef04,
    __classPrivateFieldGet: $c201f6852eb68a0f$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $c201f6852eb68a0f$export$d40a35129aaff81f,
    __classPrivateFieldIn: $c201f6852eb68a0f$export$81fdc39f203e4e04,
    __addDisposableResource: $c201f6852eb68a0f$export$88ac25d8e944e405,
    __disposeResources: $c201f6852eb68a0f$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $c201f6852eb68a0f$export$889dfb5d17574b0b
};


var $eec3d7233e50cb35$exports = {};

!function(t, n) {
    $eec3d7233e50cb35$exports = n();
}(undefined, function() {
    function t(t, n) {
        for(var r = 0; r < n.length; r++){
            var i = n[r];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, "symbol" == (0, $685ec1f5000467c6$export$71511d61b312f219)(e = function(t, n) {
                if ("object" != (typeof t === "undefined" ? "undefined" : (0, $685ec1f5000467c6$export$71511d61b312f219)(t)) || null === t) return t;
                var r = t[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var i = r.call(t, "string");
                    if ("object" != (typeof i === "undefined" ? "undefined" : (0, $685ec1f5000467c6$export$71511d61b312f219)(i))) return i;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(t);
            }(i.key)) ? e : String(e), i);
        }
        var e;
    }
    function n(n, r, i) {
        return r && t(n.prototype, r), i && t(n, i), Object.defineProperty(n, "prototype", {
            writable: !1
        }), n;
    }
    function r() {
        return r = Object.assign ? Object.assign.bind() : function r(t) {
            for(var n = 1; n < arguments.length; n++){
                var _$r = arguments[n];
                for(var i in _$r)Object.prototype.hasOwnProperty.call(_$r, i) && (t[i] = _$r[i]);
            }
            return t;
        }, r.apply(this, arguments);
    }
    function i(t, n) {
        t.prototype = Object.create(n.prototype), t.prototype.constructor = t, o(t, n);
    }
    function e(t) {
        return e = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function e(t) {
            return t.__proto__ || Object.getPrototypeOf(t);
        }, e(t);
    }
    function o(t, n) {
        return o = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function o(t, n) {
            return t.__proto__ = n, t;
        }, o(t, n);
    }
    function u() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
        } catch (t) {
            return !1;
        }
    }
    function s(t, n, r) {
        return s = u() ? Reflect.construct.bind() : function s(t, n, r) {
            var i = [
                null
            ];
            i.push.apply(i, n);
            var e = new (Function.bind.apply(t, i));
            return r && o(e, r.prototype), e;
        }, s.apply(null, arguments);
    }
    function f(t) {
        var n = "function" == typeof Map ? new Map : void 0;
        return f = function f(t) {
            if (null === t || -1 === Function.toString.call(t).indexOf("[native code]")) return t;
            if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== n) {
                if (n.has(t)) return n.get(t);
                n.set(t, r);
            }
            function r() {
                return s(t, arguments, e(this).constructor);
            }
            return r.prototype = Object.create(t.prototype, {
                constructor: {
                    value: r,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                }
            }), o(r, t);
        }, f(t);
    }
    function c(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
    }
    var a, h = function h() {
        this.before = void 0, this.beforeLeave = void 0, this.leave = void 0, this.afterLeave = void 0, this.beforeEnter = void 0, this.enter = void 0, this.afterEnter = void 0, this.after = void 0;
    };
    !function(t) {
        t[t.off = 0] = "off", t[t.error = 1] = "error", t[t.warning = 2] = "warning", t[t.info = 3] = "info", t[t.debug = 4] = "debug";
    }(a || (a = {}));
    var v = a.off, d = /*#__PURE__*/ function() {
        function t(t) {
            this.t = void 0, this.t = t;
        }
        t.getLevel = function() {
            return v;
        }, t.setLevel = function(t) {
            return v = a[t];
        };
        var n = t.prototype;
        return n.error = function() {
            this.i(console.error, a.error, [].slice.call(arguments));
        }, n.warn = function() {
            this.i(console.warn, a.warning, [].slice.call(arguments));
        }, n.info = function() {
            this.i(console.info, a.info, [].slice.call(arguments));
        }, n.debug = function() {
            this.i(console.log, a.debug, [].slice.call(arguments));
        }, n.i = function(n, r, i) {
            r <= t.getLevel() && n.apply(console, [
                "[" + this.t + "] "
            ].concat(i));
        }, t;
    }();
    function l(t) {
        return t.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
    }
    function p(t) {
        return t && t.sensitive ? "" : "i";
    }
    var m = {
        container: "container",
        history: "history",
        namespace: "namespace",
        prefix: "data-barba",
        prevent: "prevent",
        wrapper: "wrapper"
    }, w = /*#__PURE__*/ function() {
        function t() {
            this.o = m, this.u = void 0, this.h = {
                after: null,
                before: null,
                parent: null
            };
        }
        var n = t.prototype;
        return n.toString = function(t) {
            return t.outerHTML;
        }, n.toDocument = function(t) {
            return this.u || (this.u = new DOMParser), this.u.parseFromString(t, "text/html");
        }, n.toElement = function(t) {
            var n = document.createElement("div");
            return n.innerHTML = t, n;
        }, n.getHtml = function(t) {
            return void 0 === t && (t = document), this.toString(t.documentElement);
        }, n.getWrapper = function(t) {
            return void 0 === t && (t = document), t.querySelector("[" + this.o.prefix + '="' + this.o.wrapper + '"]');
        }, n.getContainer = function(t) {
            return void 0 === t && (t = document), t.querySelector("[" + this.o.prefix + '="' + this.o.container + '"]');
        }, n.removeContainer = function(t) {
            document.body.contains(t) && (this.v(t), t.parentNode.removeChild(t));
        }, n.addContainer = function(t, n) {
            var r = this.getContainer() || this.h.before;
            r ? this.l(t, r) : this.h.after ? this.h.after.parentNode.insertBefore(t, this.h.after) : this.h.parent ? this.h.parent.appendChild(t) : n.appendChild(t);
        }, n.getSibling = function() {
            return this.h;
        }, n.getNamespace = function(t) {
            void 0 === t && (t = document);
            var n = t.querySelector("[" + this.o.prefix + "-" + this.o.namespace + "]");
            return n ? n.getAttribute(this.o.prefix + "-" + this.o.namespace) : null;
        }, n.getHref = function(t) {
            if (t.tagName && "a" === t.tagName.toLowerCase()) {
                if ("string" == typeof t.href) return t.href;
                var n = t.getAttribute("href") || t.getAttribute("xlink:href");
                if (n) return this.resolveUrl(n.baseVal || n);
            }
            return null;
        }, n.resolveUrl = function() {
            var _$t = [].slice.call(arguments).length;
            if (0 === _$t) throw new Error("resolveUrl requires at least one argument; got none.");
            var n = document.createElement("base");
            if (n.href = arguments[0], 1 === _$t) return n.href;
            var r = document.getElementsByTagName("head")[0];
            r.insertBefore(n, r.firstChild);
            for(var i, e = document.createElement("a"), o = 1; o < _$t; o++)e.href = arguments[o], n.href = i = e.href;
            return r.removeChild(n), i;
        }, n.l = function(t, n) {
            n.parentNode.insertBefore(t, n.nextSibling);
        }, n.v = function(t) {
            return this.h = {
                after: t.nextElementSibling,
                before: t.previousElementSibling,
                parent: t.parentElement
            }, this.h;
        }, t;
    }(), b = new w, y = /*#__PURE__*/ function() {
        function t() {
            this.p = void 0, this.m = [], this.P = -1;
        }
        var i = t.prototype;
        return i.init = function(t, n) {
            this.p = "barba";
            var r = {
                data: {},
                ns: n,
                scroll: {
                    x: window.scrollX,
                    y: window.scrollY
                },
                url: t
            };
            this.P = 0, this.m.push(r);
            var i = {
                from: this.p,
                index: this.P,
                states: [].concat(this.m)
            };
            window.history && window.history.replaceState(i, "", t);
        }, i.change = function(t, n, r) {
            if (r && r.state) {
                var i = r.state, e = i.index;
                n = this.g(this.P - e), this.replace(i.states), this.P = e;
            } else this.add(t, n);
            return n;
        }, i.add = function(t, n, r, i) {
            var e = null != r ? r : this.R(n), o = {
                data: null != i ? i : {},
                ns: "tmp",
                scroll: {
                    x: window.scrollX,
                    y: window.scrollY
                },
                url: t
            };
            switch(e){
                case "push":
                    this.P = this.size, this.m.push(o);
                    break;
                case "replace":
                    this.set(this.P, o);
            }
            var u = {
                from: this.p,
                index: this.P,
                states: [].concat(this.m)
            };
            switch(e){
                case "push":
                    window.history && window.history.pushState(u, "", t);
                    break;
                case "replace":
                    window.history && window.history.replaceState(u, "", t);
            }
        }, i.store = function(t, n) {
            var i = n || this.P, e = this.get(i);
            e.data = r({}, e.data, t), this.set(i, e);
            var o = {
                from: this.p,
                index: this.P,
                states: [].concat(this.m)
            };
            window.history.replaceState(o, "");
        }, i.update = function(t, n) {
            var i = n || this.P, e = r({}, this.get(i), t);
            this.set(i, e);
        }, i.remove = function(t) {
            t ? this.m.splice(t, 1) : this.m.pop(), this.P--;
        }, i.clear = function() {
            this.m = [], this.P = -1;
        }, i.replace = function(t) {
            this.m = t;
        }, i.get = function(t) {
            return this.m[t];
        }, i.set = function(t, n) {
            return this.m[t] = n;
        }, i.R = function(t) {
            var _$n = "push", r = t, i = m.prefix + "-" + m.history;
            return r.hasAttribute && r.hasAttribute(i) && (_$n = r.getAttribute(i)), _$n;
        }, i.g = function(t) {
            return Math.abs(t) > 1 ? t > 0 ? "forward" : "back" : 0 === t ? "popstate" : t > 0 ? "back" : "forward";
        }, n(t, [
            {
                key: "current",
                get: function get() {
                    return this.m[this.P];
                }
            },
            {
                key: "previous",
                get: function get() {
                    return this.P < 1 ? null : this.m[this.P - 1];
                }
            },
            {
                key: "size",
                get: function get() {
                    return this.m.length;
                }
            }
        ]), t;
    }(), P = new y, g = function g(t, n) {
        try {
            var r = function() {
                if (!n.next.html) return Promise.resolve(t).then(function(t) {
                    var r = n.next;
                    if (t) {
                        var i = b.toElement(t.html);
                        r.namespace = b.getNamespace(i), r.container = b.getContainer(i), r.url = t.url, r.html = t.html, P.update({
                            ns: r.namespace
                        });
                        var e = b.toDocument(t.html);
                        document.title = e.title;
                    }
                });
            }();
            return Promise.resolve(r && r.then ? r.then(function() {}) : void 0);
        } catch (t) {
            return Promise.reject(t);
        }
    }, E = function t(n, r, i) {
        return n instanceof RegExp ? function(t, n) {
            if (!n) return t;
            for(var _$r = /\((?:\?<(.*?)>)?(?!\?)/g, _$i = 0, e = _$r.exec(t.source); e;)n.push({
                name: e[1] || _$i++,
                prefix: "",
                suffix: "",
                modifier: "",
                pattern: ""
            }), e = _$r.exec(t.source);
            return t;
        }(n, r) : Array.isArray(n) ? function(n, r, i) {
            var e = n.map(function(n) {
                return t(n, r, i).source;
            });
            return new RegExp("(?:".concat(e.join("|"), ")"), p(i));
        }(n, r, i) : function(t, n, r) {
            return function(t, n, r) {
                void 0 === r && (r = {});
                for(var _$i = r.strict, e = void 0 !== _$i && _$i, o = r.start, u = void 0 === o || o, s = r.end, _$f = void 0 === s || s, c = r.encode, a = void 0 === c ? function a(t) {
                    return t;
                } : c, h = r.delimiter, v = void 0 === h ? "/#?" : h, d = r.endsWith, m = "[".concat(l(void 0 === d ? "" : d), "]|$"), w = "[".concat(l(v), "]"), b = u ? "^" : "", y = 0, P = t; y < P.length; y++){
                    var g = P[y];
                    if ("string" == typeof g) b += l(a(g));
                    else {
                        var E = l(a(g.prefix)), x = l(a(g.suffix));
                        if (g.pattern) {
                            if (n && n.push(g), E || x) {
                                if ("+" === g.modifier || "*" === g.modifier) {
                                    var R = "*" === g.modifier ? "?" : "";
                                    b += "(?:".concat(E, "((?:").concat(g.pattern, ")(?:").concat(x).concat(E, "(?:").concat(g.pattern, "))*)").concat(x, ")").concat(R);
                                } else b += "(?:".concat(E, "(").concat(g.pattern, ")").concat(x, ")").concat(g.modifier);
                            } else b += "+" === g.modifier || "*" === g.modifier ? "((?:".concat(g.pattern, ")").concat(g.modifier, ")") : "(".concat(g.pattern, ")").concat(g.modifier);
                        } else b += "(?:".concat(E).concat(x, ")").concat(g.modifier);
                    }
                }
                if (_$f) e || (b += "".concat(w, "?")), b += r.endsWith ? "(?=".concat(m, ")") : "$";
                else {
                    var k = t[t.length - 1], O = "string" == typeof k ? w.indexOf(k[k.length - 1]) > -1 : void 0 === k;
                    e || (b += "(?:".concat(w, "(?=").concat(m, "))?")), O || (b += "(?=".concat(w, "|").concat(m, ")"));
                }
                return new RegExp(b, p(r));
            }(function(t, n) {
                void 0 === n && (n = {});
                for(var _$r = function(t) {
                    for(var _$n = [], _$r = 0; _$r < t.length;){
                        var _$i = t[_$r];
                        if ("*" !== _$i && "+" !== _$i && "?" !== _$i) {
                            if ("\\" !== _$i) {
                                if ("{" !== _$i) {
                                    if ("}" !== _$i) {
                                        if (":" !== _$i) {
                                            if ("(" !== _$i) _$n.push({
                                                type: "CHAR",
                                                index: _$r,
                                                value: t[_$r++]
                                            });
                                            else {
                                                var e = 1, o = "";
                                                if ("?" === t[s = _$r + 1]) throw new TypeError('Pattern cannot start with "?" at '.concat(s));
                                                for(; s < t.length;)if ("\\" !== t[s]) {
                                                    if (")" === t[s]) {
                                                        if (0 == --e) {
                                                            s++;
                                                            break;
                                                        }
                                                    } else if ("(" === t[s] && (e++, "?" !== t[s + 1])) throw new TypeError("Capturing groups are not allowed at ".concat(s));
                                                    o += t[s++];
                                                } else o += t[s++] + t[s++];
                                                if (e) throw new TypeError("Unbalanced pattern at ".concat(_$r));
                                                if (!o) throw new TypeError("Missing pattern at ".concat(_$r));
                                                _$n.push({
                                                    type: "PATTERN",
                                                    index: _$r,
                                                    value: o
                                                }), _$r = s;
                                            }
                                        } else {
                                            for(var u = "", s = _$r + 1; s < t.length;){
                                                var _$f = t.charCodeAt(s);
                                                if (!(_$f >= 48 && _$f <= 57 || _$f >= 65 && _$f <= 90 || _$f >= 97 && _$f <= 122 || 95 === _$f)) break;
                                                u += t[s++];
                                            }
                                            if (!u) throw new TypeError("Missing parameter name at ".concat(_$r));
                                            _$n.push({
                                                type: "NAME",
                                                index: _$r,
                                                value: u
                                            }), _$r = s;
                                        }
                                    } else _$n.push({
                                        type: "CLOSE",
                                        index: _$r,
                                        value: t[_$r++]
                                    });
                                } else _$n.push({
                                    type: "OPEN",
                                    index: _$r,
                                    value: t[_$r++]
                                });
                            } else _$n.push({
                                type: "ESCAPED_CHAR",
                                index: _$r++,
                                value: t[_$r++]
                            });
                        } else _$n.push({
                            type: "MODIFIER",
                            index: _$r,
                            value: t[_$r++]
                        });
                    }
                    return _$n.push({
                        type: "END",
                        index: _$r,
                        value: ""
                    }), _$n;
                }(t), _$i = n.prefixes, e = void 0 === _$i ? "./" : _$i, o = "[^".concat(l(n.delimiter || "/#?"), "]+?"), u = [], s = 0, _$f = 0, c = "", a = function a(t) {
                    if (_$f < _$r.length && _$r[_$f].type === t) return _$r[_$f++].value;
                }, h = function h(t) {
                    var _$n = a(t);
                    if (void 0 !== _$n) return _$n;
                    var _$i = _$r[_$f], e = _$i.index;
                    throw new TypeError("Unexpected ".concat(_$i.type, " at ").concat(e, ", expected ").concat(t));
                }, v = function v() {
                    for(var _$t, _$n = ""; _$t = a("CHAR") || a("ESCAPED_CHAR");)_$n += _$t;
                    return _$n;
                }; _$f < _$r.length;){
                    var d = a("CHAR"), p = a("NAME"), m = a("PATTERN");
                    if (p || m) -1 === e.indexOf(b = d || "") && (c += b, b = ""), c && (u.push(c), c = ""), u.push({
                        name: p || s++,
                        prefix: b,
                        suffix: "",
                        pattern: m || o,
                        modifier: a("MODIFIER") || ""
                    });
                    else {
                        var w = d || a("ESCAPED_CHAR");
                        if (w) c += w;
                        else if (c && (u.push(c), c = ""), a("OPEN")) {
                            var b = v(), y = a("NAME") || "", P = a("PATTERN") || "", g = v();
                            h("CLOSE"), u.push({
                                name: y || (P ? s++ : ""),
                                pattern: y && !P ? o : P,
                                prefix: b,
                                suffix: g,
                                modifier: a("MODIFIER") || ""
                            });
                        } else h("END");
                    }
                }
                return u;
            }(t, r), n, r);
        }(n, r, i);
    }, x = {
        __proto__: null,
        update: g,
        nextTick: function nextTick() {
            return new Promise(function(t) {
                window.requestAnimationFrame(t);
            });
        },
        pathToRegexp: E
    }, R = function R() {
        return window.location.origin;
    }, k = function k(t) {
        return void 0 === t && (t = window.location.href), O(t).port;
    }, O = function O(t) {
        var n, r = t.match(/:\d+/);
        if (null === r) /^http/.test(t) && (n = 80), /^https/.test(t) && (n = 443);
        else {
            var i = r[0].substring(1);
            n = parseInt(i, 10);
        }
        var e, o = t.replace(R(), ""), u = {}, s = o.indexOf("#");
        s >= 0 && (e = o.slice(s + 1), o = o.slice(0, s));
        var _$f = o.indexOf("?");
        return _$f >= 0 && (u = T(o.slice(_$f + 1)), o = o.slice(0, _$f)), {
            hash: e,
            path: o,
            port: n,
            query: u
        };
    }, T = function T(t) {
        return t.split("&").reduce(function(t, n) {
            var r = n.split("=");
            return t[r[0]] = r[1], t;
        }, {});
    }, A = function A(t) {
        return void 0 === t && (t = window.location.href), t.replace(/(\/#.*|\/|#.*)$/, "");
    }, j = {
        __proto__: null,
        getHref: function getHref() {
            return window.location.href;
        },
        getAbsoluteHref: function getAbsoluteHref(t, n) {
            return void 0 === n && (n = document.baseURI), new URL(t, n).href;
        },
        getOrigin: R,
        getPort: k,
        getPath: function getPath(t) {
            return void 0 === t && (t = window.location.href), O(t).path;
        },
        getQuery: function getQuery(t, n) {
            return void 0 === n && (n = !1), n ? JSON.stringify(O(t).query) : O(t).query;
        },
        getHash: function getHash(t) {
            return O(t).hash;
        },
        parse: O,
        parseQuery: T,
        clean: A
    };
    function M(t, n, i, e, o) {
        return void 0 === n && (n = 2e3), new Promise(function(u, s) {
            var _$f = new XMLHttpRequest;
            _$f.onreadystatechange = function() {
                if (_$f.readyState === XMLHttpRequest.DONE) {
                    if (200 === _$f.status) {
                        var _$n = "" !== _$f.responseURL && _$f.responseURL !== t ? _$f.responseURL : t;
                        u({
                            html: _$f.responseText,
                            url: r({
                                href: _$n
                            }, O(_$n))
                        }), e.update(t, {
                            status: "fulfilled",
                            target: _$n
                        });
                    } else if (_$f.status) {
                        var _$o = {
                            status: _$f.status,
                            statusText: _$f.statusText
                        };
                        i(t, _$o), s(_$o), e.update(t, {
                            status: "rejected"
                        });
                    }
                }
            }, _$f.ontimeout = function() {
                var r = new Error("Timeout error [" + n + "]");
                i(t, r), s(r), e.update(t, {
                    status: "rejected"
                });
            }, _$f.onerror = function() {
                var _$n = new Error("Fetch error");
                i(t, _$n), s(_$n), e.update(t, {
                    status: "rejected"
                });
            }, _$f.open("GET", t), _$f.timeout = n, _$f.setRequestHeader("Accept", "text/html,application/xhtml+xml,application/xml"), _$f.setRequestHeader("x-barba", "yes"), o.all().forEach(function(t, n) {
                _$f.setRequestHeader(n, t);
            }), _$f.send();
        });
    }
    function N(t) {
        return !!t && ("object" == (typeof t === "undefined" ? "undefined" : (0, $685ec1f5000467c6$export$71511d61b312f219)(t)) || "function" == typeof t) && "function" == typeof t.then;
    }
    function S(t, n) {
        return void 0 === n && (n = {}), function() {
            var r = arguments, i = !1, e = new Promise(function(e, o) {
                n.async = function() {
                    return i = !0, function(t, n) {
                        t ? o(t) : e(n);
                    };
                };
                var u = t.apply(n, [].slice.call(r));
                i || (N(u) ? u.then(e, o) : e(u));
            });
            return e;
        };
    }
    var C = /*#__PURE__*/ function(t) {
        function n() {
            var _$n;
            return (_$n = t.call(this) || this).logger = new d("@barba/core"), _$n.all = [
                "ready",
                "page",
                "reset",
                "currentAdded",
                "currentRemoved",
                "nextAdded",
                "nextRemoved",
                "beforeOnce",
                "once",
                "afterOnce",
                "before",
                "beforeLeave",
                "leave",
                "afterLeave",
                "beforeEnter",
                "enter",
                "afterEnter",
                "after"
            ], _$n.registered = new Map, _$n.init(), _$n;
        }
        i(n, t);
        var r = n.prototype;
        return r.init = function() {
            var _$t = this;
            this.registered.clear(), this.all.forEach(function(n) {
                _$t[n] || (_$t[n] = function(r, i) {
                    _$t.registered.has(n) || _$t.registered.set(n, new Set), _$t.registered.get(n).add({
                        ctx: i || {},
                        fn: r
                    });
                });
            });
        }, r["do"] = function(t) {
            var _$n = arguments, r = this;
            if (this.registered.has(t)) {
                var _$i = Promise.resolve();
                return this.registered.get(t).forEach(function(t) {
                    _$i = _$i.then(function() {
                        return S(t.fn, t.ctx).apply(void 0, [].slice.call(_$n, 1));
                    });
                }), _$i["catch"](function(n) {
                    r.logger.debug("Hook error [" + t + "]"), r.logger.error(n);
                });
            }
            return Promise.resolve();
        }, r.clear = function() {
            var _$t = this;
            this.all.forEach(function(n) {
                delete _$t[n];
            }), this.init();
        }, r.help = function() {
            this.logger.info("Available hooks: " + this.all.join(","));
            var _$t = [];
            this.registered.forEach(function(n, r) {
                return _$t.push(r);
            }), this.logger.info("Registered hooks: " + _$t.join(","));
        }, n;
    }(h), L = new C, H = /*#__PURE__*/ function() {
        function t(t) {
            if (this.k = void 0, this.O = [], "boolean" == typeof t) this.k = t;
            else {
                var n = Array.isArray(t) ? t : [
                    t
                ];
                this.O = n.map(function(t) {
                    return E(t);
                });
            }
        }
        return t.prototype.checkHref = function(t) {
            if ("boolean" == typeof this.k) return this.k;
            var n = O(t).path;
            return this.O.some(function(t) {
                return null !== t.exec(n);
            });
        }, t;
    }(), _ = /*#__PURE__*/ function(t) {
        function n(n) {
            var r;
            return (r = t.call(this, n) || this).T = new Map, r;
        }
        i(n, t);
        var e = n.prototype;
        return e.set = function(t, n, r, i, e) {
            return this.T.set(t, {
                action: r,
                request: n,
                status: i,
                target: null != e ? e : t
            }), {
                action: r,
                request: n,
                status: i,
                target: e
            };
        }, e.get = function(t) {
            return this.T.get(t);
        }, e.getRequest = function(t) {
            return this.T.get(t).request;
        }, e.getAction = function(t) {
            return this.T.get(t).action;
        }, e.getStatus = function(t) {
            return this.T.get(t).status;
        }, e.getTarget = function(t) {
            return this.T.get(t).target;
        }, e.has = function(t) {
            return !this.checkHref(t) && this.T.has(t);
        }, e["delete"] = function(t) {
            return this.T["delete"](t);
        }, e.update = function(t, n) {
            var _$i = r({}, this.T.get(t), n);
            return this.T.set(t, _$i), _$i;
        }, n;
    }(H), D = /*#__PURE__*/ function() {
        function t() {
            this.A = new Map;
        }
        var n = t.prototype;
        return n.set = function(t, n) {
            return this.A.set(t, n), {
                name: n
            };
        }, n.get = function(t) {
            return this.A.get(t);
        }, n.all = function() {
            return this.A;
        }, n.has = function(t) {
            return this.A.has(t);
        }, n["delete"] = function(t) {
            return this.A["delete"](t);
        }, n.clear = function() {
            return this.A.clear();
        }, t;
    }(), B = function B() {
        return !window.history.pushState;
    }, q = function q(t) {
        return !t.el || !t.href;
    }, F = function F(t) {
        var n = t.event;
        return n.which > 1 || n.metaKey || n.ctrlKey || n.shiftKey || n.altKey;
    }, I = function I(t) {
        var n = t.el;
        return n.hasAttribute("target") && "_blank" === n.target;
    }, U = function U(t) {
        var n = t.el;
        return void 0 !== n.protocol && window.location.protocol !== n.protocol || void 0 !== n.hostname && window.location.hostname !== n.hostname;
    }, $ = function $(t) {
        var n = t.el;
        return void 0 !== n.port && k() !== k(n.href);
    }, Q = function Q(t) {
        var n = t.el;
        return n.getAttribute && "string" == typeof n.getAttribute("download");
    }, X = function X(t) {
        return t.el.hasAttribute(m.prefix + "-" + m.prevent);
    }, z = function z(t) {
        return Boolean(t.el.closest("[" + m.prefix + "-" + m.prevent + '="all"]'));
    }, G = function G(t) {
        var n = t.href;
        return A(n) === A() && k(n) === k();
    }, J = /*#__PURE__*/ function(t) {
        function n(n) {
            var r;
            return (r = t.call(this, n) || this).suite = [], r.tests = new Map, r.init(), r;
        }
        i(n, t);
        var r = n.prototype;
        return r.init = function() {
            this.add("pushState", B), this.add("exists", q), this.add("newTab", F), this.add("blank", I), this.add("corsDomain", U), this.add("corsPort", $), this.add("download", Q), this.add("preventSelf", X), this.add("preventAll", z), this.add("sameUrl", G, !1);
        }, r.add = function(t, n, r) {
            void 0 === r && (r = !0), this.tests.set(t, n), r && this.suite.push(t);
        }, r.run = function(t, n, r, i) {
            return this.tests.get(t)({
                el: n,
                event: r,
                href: i
            });
        }, r.checkLink = function(t, n, r) {
            var _$i = this;
            return this.suite.some(function(e) {
                return _$i.run(e, t, n, r);
            });
        }, n;
    }(H), W = /*#__PURE__*/ function(t) {
        function n(r, i) {
            var e;
            return void 0 === i && (i = "Barba error"), (e = t.call.apply(t, [
                this
            ].concat([].slice.call(arguments, 2))) || this).error = void 0, e.label = void 0, e.error = r, e.label = i, Error.captureStackTrace && Error.captureStackTrace(c(e), n), e.name = "BarbaError", e;
        }
        return i(n, t), n;
    }(/*#__PURE__*/ f(Error)), K = /*#__PURE__*/ function() {
        function t(t) {
            void 0 === t && (t = []), this.logger = new d("@barba/core"), this.all = [], this.page = [], this.once = [], this.j = [
                {
                    name: "namespace",
                    type: "strings"
                },
                {
                    name: "custom",
                    type: "function"
                }
            ], t && (this.all = this.all.concat(t)), this.update();
        }
        var n = t.prototype;
        return n.add = function(t, n) {
            "rule" === t ? this.j.splice(n.position || 0, 0, n.value) : this.all.push(n), this.update();
        }, n.resolve = function(t, n) {
            var r = this;
            void 0 === n && (n = {});
            var i = n.once ? this.once : this.page;
            i = i.filter(n.self ? function(t) {
                return t.name && "self" === t.name;
            } : function(t) {
                return !t.name || "self" !== t.name;
            });
            var e = new Map, o = i.find(function(i) {
                var o = !0, u = {};
                return n.self && "self" === i.name ? (e.set(i, u), !0) : (r.j.reverse().forEach(function(n) {
                    o && (o = r.M(i, n, t, u), i.from && i.to && (o = r.M(i, n, t, u, "from") && r.M(i, n, t, u, "to")), i.from && !i.to && (o = r.M(i, n, t, u, "from")), !i.from && i.to && (o = r.M(i, n, t, u, "to")));
                }), e.set(i, u), o);
            }), u = e.get(o), s = [];
            if (s.push(n.once ? "once" : "page"), n.self && s.push("self"), u) {
                var _$f, c = [
                    o
                ];
                Object.keys(u).length > 0 && c.push(u), (_$f = this.logger).info.apply(_$f, [
                    "Transition found [" + s.join(",") + "]"
                ].concat(c));
            } else this.logger.info("No transition found [" + s.join(",") + "]");
            return o;
        }, n.update = function() {
            var _$t = this;
            this.all = this.all.map(function(n) {
                return _$t.N(n);
            }).sort(function(t, n) {
                return t.priority - n.priority;
            }).reverse().map(function(t) {
                return delete t.priority, t;
            }), this.page = this.all.filter(function(t) {
                return void 0 !== t.leave || void 0 !== t.enter;
            }), this.once = this.all.filter(function(t) {
                return void 0 !== t.once;
            });
        }, n.M = function(t, n, r, i, e) {
            var o = !0, u = !1, s = t, _$f = n.name, c = _$f, a = _$f, h = _$f, v = e ? s[e] : s, d = "to" === e ? r.next : r.current;
            if (e ? v && v[_$f] : v[_$f]) {
                switch(n.type){
                    case "strings":
                    default:
                        var l = Array.isArray(v[c]) ? v[c] : [
                            v[c]
                        ];
                        d[c] && -1 !== l.indexOf(d[c]) && (u = !0), -1 === l.indexOf(d[c]) && (o = !1);
                        break;
                    case "object":
                        var p = Array.isArray(v[a]) ? v[a] : [
                            v[a]
                        ];
                        d[a] ? (d[a].name && -1 !== p.indexOf(d[a].name) && (u = !0), -1 === p.indexOf(d[a].name) && (o = !1)) : o = !1;
                        break;
                    case "function":
                        v[h](r) ? u = !0 : o = !1;
                }
                u && (e ? (i[e] = i[e] || {}, i[e][_$f] = s[e][_$f]) : i[_$f] = s[_$f]);
            }
            return o;
        }, n.S = function(t, n, r) {
            var i = 0;
            return (t[n] || t.from && t.from[n] || t.to && t.to[n]) && (i += Math.pow(10, r), t.from && t.from[n] && (i += 1), t.to && t.to[n] && (i += 2)), i;
        }, n.N = function(t) {
            var n = this;
            t.priority = 0;
            var r = 0;
            return this.j.forEach(function(i, e) {
                r += n.S(t, i.name, e + 1);
            }), t.priority = r, t;
        }, t;
    }();
    function V(t, n) {
        try {
            var r = t();
        } catch (t) {
            return n(t);
        }
        return r && r.then ? r.then(void 0, n) : r;
    }
    var Y = /*#__PURE__*/ function() {
        function t(t) {
            void 0 === t && (t = []), this.logger = new d("@barba/core"), this.store = void 0, this.C = !1, this.store = new K(t);
        }
        var r = t.prototype;
        return r.get = function(t, n) {
            return this.store.resolve(t, n);
        }, r.doOnce = function(t) {
            var _$n = t.data, r = t.transition;
            try {
                var i = function i() {
                    e.C = !1;
                }, e = this, o = r || {};
                e.C = !0;
                var u = V(function() {
                    return Promise.resolve(e.L("beforeOnce", _$n, o)).then(function() {
                        return Promise.resolve(e.once(_$n, o)).then(function() {
                            return Promise.resolve(e.L("afterOnce", _$n, o)).then(function() {});
                        });
                    });
                }, function(t) {
                    e.C = !1, e.logger.debug("Transition error [before/after/once]"), e.logger.error(t);
                });
                return Promise.resolve(u && u.then ? u.then(i) : i());
            } catch (t) {
                return Promise.reject(t);
            }
        }, r.doPage = function(t) {
            var _$n = t.data, r = t.transition, i = t.page, e = t.wrapper;
            try {
                var o = function o(t) {
                    u.C = !1;
                }, u = this, s = r || {}, _$f = !0 === s.sync || !1;
                u.C = !0;
                var c = V(function() {
                    function t() {
                        return Promise.resolve(u.L("before", _$n, s)).then(function() {
                            function t(t) {
                                return Promise.resolve(u.remove(_$n)).then(function() {
                                    return Promise.resolve(u.L("after", _$n, s)).then(function() {});
                                });
                            }
                            var r = function() {
                                if (_$f) return V(function() {
                                    return Promise.resolve(u.add(_$n, e)).then(function() {
                                        return Promise.resolve(u.L("beforeLeave", _$n, s)).then(function() {
                                            return Promise.resolve(u.L("beforeEnter", _$n, s)).then(function() {
                                                return Promise.resolve(Promise.all([
                                                    u.leave(_$n, s),
                                                    u.enter(_$n, s)
                                                ])).then(function() {
                                                    return Promise.resolve(u.L("afterLeave", _$n, s)).then(function() {
                                                        return Promise.resolve(u.L("afterEnter", _$n, s)).then(function() {});
                                                    });
                                                });
                                            });
                                        });
                                    });
                                }, function(t) {
                                    if (u.H(t)) throw new W(t, "Transition error [sync]");
                                });
                                var _$t = function t(t) {
                                    return V(function() {
                                        var _$t = function() {
                                            if (!1 !== r) return Promise.resolve(u.add(_$n, e)).then(function() {
                                                return Promise.resolve(u.L("beforeEnter", _$n, s)).then(function() {
                                                    return Promise.resolve(u.enter(_$n, s, r)).then(function() {
                                                        return Promise.resolve(u.L("afterEnter", _$n, s)).then(function() {});
                                                    });
                                                });
                                            });
                                        }();
                                        if (_$t && _$t.then) return _$t.then(function() {});
                                    }, function(t) {
                                        if (u.H(t)) throw new W(t, "Transition error [before/after/enter]");
                                    });
                                }, r = !1, o = V(function() {
                                    return Promise.resolve(u.L("beforeLeave", _$n, s)).then(function() {
                                        return Promise.resolve(Promise.all([
                                            u.leave(_$n, s),
                                            g(i, _$n)
                                        ]).then(function(t) {
                                            return t[0];
                                        })).then(function(t) {
                                            return r = t, Promise.resolve(u.L("afterLeave", _$n, s)).then(function() {});
                                        });
                                    });
                                }, function(t) {
                                    if (u.H(t)) throw new W(t, "Transition error [before/after/leave]");
                                });
                                return o && o.then ? o.then(_$t) : _$t();
                            }();
                            return r && r.then ? r.then(t) : t();
                        });
                    }
                    var r = function() {
                        if (_$f) return Promise.resolve(g(i, _$n)).then(function() {});
                    }();
                    return r && r.then ? r.then(t) : t();
                }, function(t) {
                    if (u.C = !1, t.name && "BarbaError" === t.name) throw u.logger.debug(t.label), u.logger.error(t.error), t;
                    throw u.logger.debug("Transition error [page]"), u.logger.error(t), t;
                });
                return Promise.resolve(c && c.then ? c.then(o) : o());
            } catch (t) {
                return Promise.reject(t);
            }
        }, r.once = function(t, n) {
            try {
                return Promise.resolve(L["do"]("once", t, n)).then(function() {
                    return n.once ? S(n.once, n)(t) : Promise.resolve();
                });
            } catch (t) {
                return Promise.reject(t);
            }
        }, r.leave = function(t, n) {
            try {
                return Promise.resolve(L["do"]("leave", t, n)).then(function() {
                    return n.leave ? S(n.leave, n)(t) : Promise.resolve();
                });
            } catch (t) {
                return Promise.reject(t);
            }
        }, r.enter = function(t, n, r) {
            try {
                return Promise.resolve(L["do"]("enter", t, n)).then(function() {
                    return n.enter ? S(n.enter, n)(t, r) : Promise.resolve();
                });
            } catch (t) {
                return Promise.reject(t);
            }
        }, r.add = function(t, n) {
            try {
                return b.addContainer(t.next.container, n), L["do"]("nextAdded", t), Promise.resolve();
            } catch (t) {
                return Promise.reject(t);
            }
        }, r.remove = function(t) {
            try {
                return b.removeContainer(t.current.container), L["do"]("currentRemoved", t), Promise.resolve();
            } catch (t) {
                return Promise.reject(t);
            }
        }, r.H = function(t) {
            return t.message ? !/Timeout error|Fetch error/.test(t.message) : !t.status;
        }, r.L = function(t, n, r) {
            try {
                return Promise.resolve(L["do"](t, n, r)).then(function() {
                    return r[t] ? S(r[t], r)(n) : Promise.resolve();
                });
            } catch (t) {
                return Promise.reject(t);
            }
        }, n(t, [
            {
                key: "isRunning",
                get: function get() {
                    return this.C;
                },
                set: function set(t) {
                    this.C = t;
                }
            },
            {
                key: "hasOnce",
                get: function get() {
                    return this.store.once.length > 0;
                }
            },
            {
                key: "hasSelf",
                get: function get() {
                    return this.store.all.some(function(t) {
                        return "self" === t.name;
                    });
                }
            },
            {
                key: "shouldWait",
                get: function get() {
                    return this.store.all.some(function(t) {
                        return t.to && !t.to.route || t.sync;
                    });
                }
            }
        ]), t;
    }(), Z = /*#__PURE__*/ function() {
        function t(t) {
            var n = this;
            this.names = [
                "beforeLeave",
                "afterLeave",
                "beforeEnter",
                "afterEnter"
            ], this.byNamespace = new Map, 0 !== t.length && (t.forEach(function(t) {
                n.byNamespace.set(t.namespace, t);
            }), this.names.forEach(function(t) {
                L[t](n._(t));
            }));
        }
        return t.prototype._ = function(t) {
            var n = this;
            return function(r) {
                var i = t.match(/enter/i) ? r.next : r.current, e = n.byNamespace.get(i.namespace);
                return e && e[t] ? S(e[t], e)(r) : Promise.resolve();
            };
        }, t;
    }();
    Element.prototype.matches || (Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector), Element.prototype.closest || (Element.prototype.closest = function(t) {
        var n = this;
        do {
            if (n.matches(t)) return n;
            n = n.parentElement || n.parentNode;
        }while (null !== n && 1 === n.nodeType);
        return null;
    });
    var tt = {
        container: null,
        html: "",
        namespace: "",
        url: {
            hash: "",
            href: "",
            path: "",
            port: null,
            query: {}
        }
    }, nt = /*#__PURE__*/ function() {
        function t() {
            this.version = "2.10.3", this.schemaPage = tt, this.Logger = d, this.logger = new d("@barba/core"), this.plugins = [], this.timeout = void 0, this.cacheIgnore = void 0, this.cacheFirstPage = void 0, this.prefetchIgnore = void 0, this.preventRunning = void 0, this.hooks = L, this.cache = void 0, this.headers = void 0, this.prevent = void 0, this.transitions = void 0, this.views = void 0, this.dom = b, this.helpers = x, this.history = P, this.request = M, this.url = j, this.D = void 0, this.B = void 0, this.q = void 0, this.F = void 0;
        }
        var i = t.prototype;
        return i.use = function(t, n) {
            var r = this.plugins;
            r.indexOf(t) > -1 ? this.logger.warn("Plugin [" + t.name + "] already installed.") : "function" == typeof t.install ? (t.install(this, n), r.push(t)) : this.logger.warn("Plugin [" + t.name + '] has no "install" method.');
        }, i.init = function(t) {
            var _$n = void 0 === t ? {} : t, i = _$n.transitions, e = void 0 === i ? [] : i, o = _$n.views, u = void 0 === o ? [] : o, s = _$n.schema, _$f = void 0 === s ? m : s, c = _$n.requestError, a = _$n.timeout, h = void 0 === a ? 2e3 : a, v = _$n.cacheIgnore, l = void 0 !== v && v, p = _$n.cacheFirstPage, w = void 0 !== p && p, b = _$n.prefetchIgnore, y = void 0 !== b && b, P = _$n.preventRunning, g = void 0 !== P && P, E = _$n.prevent, x = void 0 === E ? null : E, R = _$n.debug, k = _$n.logLevel;
            if (d.setLevel(!0 === (void 0 !== R && R) ? "debug" : void 0 === k ? "off" : k), this.logger.info(this.version), Object.keys(_$f).forEach(function(t) {
                m[t] && (m[t] = _$f[t]);
            }), this.B = c, this.timeout = h, this.cacheIgnore = l, this.cacheFirstPage = w, this.prefetchIgnore = y, this.preventRunning = g, this.q = this.dom.getWrapper(), !this.q) throw new Error("[@barba/core] No Barba wrapper found");
            this.I();
            var O = this.data.current;
            if (!O.container) throw new Error("[@barba/core] No Barba container found");
            if (this.cache = new _(l), this.headers = new D, this.prevent = new J(y), this.transitions = new Y(e), this.views = new Z(u), null !== x) {
                if ("function" != typeof x) throw new Error("[@barba/core] Prevent should be a function");
                this.prevent.add("preventCustom", x);
            }
            this.history.init(O.url.href, O.namespace), w && this.cache.set(O.url.href, Promise.resolve({
                html: O.html,
                url: O.url
            }), "init", "fulfilled"), this.U = this.U.bind(this), this.$ = this.$.bind(this), this.X = this.X.bind(this), this.G(), this.plugins.forEach(function(t) {
                return t.init();
            });
            var T = this.data;
            T.trigger = "barba", T.next = T.current, T.current = r({}, this.schemaPage), this.hooks["do"]("ready", T), this.once(T), this.I();
        }, i.destroy = function() {
            this.I(), this.J(), this.history.clear(), this.hooks.clear(), this.plugins = [];
        }, i.force = function(t) {
            window.location.assign(t);
        }, i.go = function(t, n, r) {
            var i;
            if (void 0 === n && (n = "barba"), this.F = null, this.transitions.isRunning) this.force(t);
            else if (!(i = "popstate" === n ? this.history.current && this.url.getPath(this.history.current.url) === this.url.getPath(t) && this.url.getQuery(this.history.current.url, !0) === this.url.getQuery(t, !0) : this.prevent.run("sameUrl", null, null, t)) || this.transitions.hasSelf) return n = this.history.change(this.cache.has(t) ? this.cache.get(t).target : t, n, r), r && (r.stopPropagation(), r.preventDefault()), this.page(t, n, null != r ? r : void 0, i);
        }, i.once = function(t) {
            try {
                var _$n = this;
                return Promise.resolve(_$n.hooks["do"]("beforeEnter", t)).then(function() {
                    function r() {
                        return Promise.resolve(_$n.hooks["do"]("afterEnter", t)).then(function() {});
                    }
                    var i = function() {
                        if (_$n.transitions.hasOnce) {
                            var _$r = _$n.transitions.get(t, {
                                once: !0
                            });
                            return Promise.resolve(_$n.transitions.doOnce({
                                transition: _$r,
                                data: t
                            })).then(function() {});
                        }
                    }();
                    return i && i.then ? i.then(r) : r();
                });
            } catch (t) {
                return Promise.reject(t);
            }
        }, i.page = function(t, n, i, e) {
            try {
                var o, u = function u() {
                    var _$t = s.data;
                    return Promise.resolve(s.hooks["do"]("page", _$t)).then(function() {
                        var _$n = function(n, r) {
                            try {
                                var _$i = (u = s.transitions.get(_$t, {
                                    once: !1,
                                    self: e
                                }), Promise.resolve(s.transitions.doPage({
                                    data: _$t,
                                    page: o,
                                    transition: u,
                                    wrapper: s.q
                                })).then(function() {
                                    s.I();
                                }));
                            } catch (t) {
                                return r();
                            }
                            var u;
                            return _$i && _$i.then ? _$i.then(void 0, r) : _$i;
                        }(0, function() {
                            0 === d.getLevel() && s.force(_$t.next.url.href);
                        });
                        if (_$n && _$n.then) return _$n.then(function() {});
                    });
                }, s = this;
                if (s.data.next.url = r({
                    href: t
                }, s.url.parse(t)), s.data.trigger = n, s.data.event = i, s.cache.has(t)) o = s.cache.update(t, {
                    action: "click"
                }).request;
                else {
                    var _$f = s.request(t, s.timeout, s.onRequestError.bind(s, n), s.cache, s.headers);
                    _$f.then(function(r) {
                        r.url.href !== t && s.history.add(r.url.href, n, "replace");
                    }), o = s.cache.set(t, _$f, "click", "pending").request;
                }
                var c = function() {
                    if (s.transitions.shouldWait) return Promise.resolve(g(o, s.data)).then(function() {});
                }();
                return Promise.resolve(c && c.then ? c.then(u) : u());
            } catch (t) {
                return Promise.reject(t);
            }
        }, i.onRequestError = function(t) {
            this.transitions.isRunning = !1;
            var _$n = [].slice.call(arguments, 1), r = _$n[0], i = _$n[1], e = this.cache.getAction(r);
            return this.cache["delete"](r), this.B && !1 === this.B(t, e, r, i) || "click" === e && this.force(r), !1;
        }, i.prefetch = function(t) {
            var _$n = this;
            t = this.url.getAbsoluteHref(t), this.cache.has(t) || this.cache.set(t, this.request(t, this.timeout, this.onRequestError.bind(this, "barba"), this.cache, this.headers)["catch"](function(t) {
                _$n.logger.error(t);
            }), "prefetch", "pending");
        }, i.G = function() {
            !0 !== this.prefetchIgnore && (document.addEventListener("mouseover", this.U), document.addEventListener("touchstart", this.U)), document.addEventListener("click", this.$), window.addEventListener("popstate", this.X);
        }, i.J = function() {
            !0 !== this.prefetchIgnore && (document.removeEventListener("mouseover", this.U), document.removeEventListener("touchstart", this.U)), document.removeEventListener("click", this.$), window.removeEventListener("popstate", this.X);
        }, i.U = function(t) {
            var _$n = this, r = this.W(t);
            if (r) {
                var i = this.url.getAbsoluteHref(this.dom.getHref(r));
                this.prevent.checkHref(i) || this.cache.has(i) || this.cache.set(i, this.request(i, this.timeout, this.onRequestError.bind(this, r), this.cache, this.headers)["catch"](function(t) {
                    _$n.logger.error(t);
                }), "enter", "pending");
            }
        }, i.$ = function(t) {
            var _$n = this.W(t);
            if (_$n) {
                if (this.transitions.isRunning && this.preventRunning) return t.preventDefault(), void t.stopPropagation();
                this.F = t, this.go(this.dom.getHref(_$n), _$n, t);
            }
        }, i.X = function(t) {
            this.go(this.url.getHref(), "popstate", t);
        }, i.W = function(t) {
            for(var _$n = t.target; _$n && !this.dom.getHref(_$n);)_$n = _$n.parentNode;
            if (_$n && !this.prevent.checkLink(_$n, t, this.dom.getHref(_$n))) return _$n;
        }, i.I = function() {
            var _$t = this.url.getHref(), _$n = {
                container: this.dom.getContainer(),
                html: this.dom.getHtml(),
                namespace: this.dom.getNamespace(),
                url: r({
                    href: _$t
                }, this.url.parse(_$t))
            };
            this.D = {
                current: _$n,
                event: void 0,
                next: r({}, this.schemaPage),
                trigger: void 0
            }, this.hooks["do"]("reset", this.data);
        }, n(t, [
            {
                key: "data",
                get: function get() {
                    return this.D;
                }
            },
            {
                key: "wrapper",
                get: function get() {
                    return this.q;
                }
            }
        ]), t;
    }();
    return new nt;
});


function $9577490cbbab44e8$export$71511d61b312f219(o) {
    $9577490cbbab44e8$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $9577490cbbab44e8$export$71511d61b312f219(o);
}


function $dd378a221b5d10a9$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($dd378a221b5d10a9$export$71511d61b312f219 = function() {
        return !!result;
    })();
}


function $d01a1a924be89573$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}



function $956e38f495f30304$export$71511d61b312f219(self, call) {
    if (call && ((0, $685ec1f5000467c6$export$71511d61b312f219)(call) === "object" || typeof call === "function")) return call;
    return (0, $d01a1a924be89573$export$71511d61b312f219)(self);
}


function $c1745da3357c8fcc$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $9577490cbbab44e8$export$71511d61b312f219)(derived);
    return (0, $956e38f495f30304$export$71511d61b312f219)(_this, (0, $dd378a221b5d10a9$export$71511d61b312f219)() ? Reflect.construct(derived, args || [], (0, $9577490cbbab44e8$export$71511d61b312f219)(_this).constructor) : derived.apply(_this, args));
}


function $748c5547edb8a18d$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $c95e6614e27503ea$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $c95e6614e27503ea$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $c95e6614e27503ea$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c95e6614e27503ea$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}



function $ba092cd2ea948baf$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $9577490cbbab44e8$export$71511d61b312f219)(object);
        if (object === null) break;
    }
    return object;
}


function $c5cff198ab2b9e8e$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $c5cff198ab2b9e8e$export$71511d61b312f219 = Reflect.get;
    else $c5cff198ab2b9e8e$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $ba092cd2ea948baf$export$71511d61b312f219)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $c5cff198ab2b9e8e$export$71511d61b312f219(target, property, receiver || target);
}



function $15f6468c67525c42$export$71511d61b312f219(o, p) {
    $15f6468c67525c42$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $15f6468c67525c42$export$71511d61b312f219(o, p);
}


function $1e7277e0f02f2550$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $15f6468c67525c42$export$71511d61b312f219)(subClass, superClass);
}


function $f519540aec516cae$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $96187cf7ee687926$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $3df979af0b9955d8$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $b2bf8fa578225284$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $33a612d6eb27b2d8$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $b2bf8fa578225284$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $b2bf8fa578225284$export$71511d61b312f219)(o, minLen);
}


function $1933fb0d7df0f802$export$71511d61b312f219(arr, i) {
    return (0, $f519540aec516cae$export$71511d61b312f219)(arr) || (0, $96187cf7ee687926$export$71511d61b312f219)(arr, i) || (0, $33a612d6eb27b2d8$export$71511d61b312f219)(arr, i) || (0, $3df979af0b9955d8$export$71511d61b312f219)();
}



function $af0557632714edc1$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $b2bf8fa578225284$export$71511d61b312f219)(arr);
}


function $c81b34c9c7c7494c$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $9fef29e465f376d6$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $b6a26340ba3e8c80$export$71511d61b312f219(arr) {
    return (0, $af0557632714edc1$export$71511d61b312f219)(arr) || (0, $c81b34c9c7c7494c$export$71511d61b312f219)(arr) || (0, $33a612d6eb27b2d8$export$71511d61b312f219)(arr) || (0, $9fef29e465f376d6$export$71511d61b312f219)();
}



/**
 * Check to see if an object is a plain object (created using "{}" or "new Object").
 * @param {*} obj Variable of any type
 * @returns {Boolean}
 */ 
var $66f4d3fde35745bd$export$53b83ca8eaab0383 = function(obj) {
    return(// separate from primitives
    (typeof obj === "undefined" ? "undefined" : (0, $685ec1f5000467c6$export$71511d61b312f219)(obj)) === "object" && // is obvious
    obj !== null && // separate instances (Array, DOM, ...)
    obj.constructor === Object && // separate build-in like Math
    Object.prototype.toString.call(obj) === "[object Object]");
};


var $473ff96f0aaf0a3a$export$8b58be045bf06082 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var deep = false;
    if (typeof args[0] == "boolean") deep = args.shift();
    var result = args[0];
    if (!result || (typeof result === "undefined" ? "undefined" : (0, $685ec1f5000467c6$export$71511d61b312f219)(result)) !== "object") throw new Error("extendee must be an object");
    var extenders = args.slice(1);
    var len = extenders.length;
    for(var i = 0; i < len; i++){
        var extender = extenders[i];
        for(var key in extender)if (extender.hasOwnProperty(key)) {
            var value = extender[key];
            if (deep && (Array.isArray(value) || (0, $66f4d3fde35745bd$export$53b83ca8eaab0383)(value))) {
                var base = Array.isArray(value) ? [] : {};
                result[key] = $473ff96f0aaf0a3a$export$8b58be045bf06082(true, result.hasOwnProperty(key) ? result[key] : base, value);
            } else result[key] = value;
        }
    }
    return result;
};


/**
 * Detect if rendering from the client or the server
 */ var $041aa9e7dc769c90$export$71594e8a50f746f4 = !!(typeof window !== "undefined" && window.document && window.document.createElement);



var $eb0b16180e564216$var$preventScrollSupported = null;
var $eb0b16180e564216$export$6a59c51278cd7bb1 = [
    "a[href]",
    "area[href]",
    'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
    "select:not([disabled]):not([aria-hidden])",
    "textarea:not([disabled]):not([aria-hidden])",
    "button:not([disabled]):not([aria-hidden])",
    "iframe",
    "object",
    "embed",
    "video",
    "audio",
    "[contenteditable]",
    '[tabindex]:not([tabindex^="-"]):not([disabled]):not([aria-hidden])'
];
var $eb0b16180e564216$export$5a51bc2ba3a0d25 = function(node) {
    if (!node || !(0, $041aa9e7dc769c90$export$71594e8a50f746f4)) return;
    if ($eb0b16180e564216$var$preventScrollSupported === null) document.createElement("div").focus({
        get preventScroll () {
            $eb0b16180e564216$var$preventScrollSupported = true;
            return false;
        }
    });
    try {
        if (node.setActive) // IE/Edge
        node.setActive();
        else if ($eb0b16180e564216$var$preventScrollSupported) // Modern browsers
        node.focus({
            preventScroll: true
        });
        else {
            // Safari does not support `preventScroll` option
            // https://bugs.webkit.org/show_bug.cgi?id=178583
            // Save position
            var scrollTop = window.pageXOffset || document.body.scrollTop;
            var scrollLeft = window.pageYOffset || document.body.scrollLeft;
            node.focus();
            document.body.scrollTo({
                top: scrollTop,
                left: scrollLeft,
                behavior: "auto"
            });
        }
    } catch (e) {}
};







/**
 * Access nested JavaScript objects by string path.
 * Example: `resolve("a.b.c", {a:{b:{c:"d"}})` would return `d`
 * @param {String} path
 * @param {Object} obj
 * @returns {*}
 */ var $837414a8870a4e01$export$f7ad0328861e2f03 = function resolve(path, obj) {
    return path.split(".").reduce(function(prev, curr) {
        return prev && prev[curr];
    }, obj);
};



var $633001db0e20238e$export$ef88aa0d34c34520 = /*#__PURE__*/ function() {
    "use strict";
    function Base() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $748c5547edb8a18d$export$71511d61b312f219)(this, Base);
        this.options = (0, $473ff96f0aaf0a3a$export$8b58be045bf06082)(true, {}, options);
        this.plugins = [];
        this.events = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        // * Prefill with initial events
        for(var _i = 0, _iter = [
            "on",
            "once"
        ]; _i < _iter.length; _i++){
            var type = _iter[_i];
            try {
                for(var _iterator = Object.entries(this.options[type] || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var args = _step.value;
                    this[type].apply(this, (0, $b6a26340ba3e8c80$export$71511d61b312f219)(args));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }
    (0, $c95e6614e27503ea$export$71511d61b312f219)(Base, [
        {
            /**
   * Retrieve option value by key, supports subkeys
   * @param {String} key Option name
   * @param {*} [fallback] Fallback value for non-existing key
   * @returns {*}
   */ key: "option",
            value: function option(key, fallback) {
                for(var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
                    rest[_key - 2] = arguments[_key];
                }
                var _value;
                // Make sure it is string
                key = String(key);
                var value = (0, $837414a8870a4e01$export$f7ad0328861e2f03)(key, this.options);
                // Allow to have functions as options
                if (typeof value === "function") value = (_value = value).call.apply(_value, [
                    this,
                    this
                ].concat((0, $b6a26340ba3e8c80$export$71511d61b312f219)(rest)));
                return value === undefined ? fallback : value;
            }
        },
        {
            /**
   * Simple l10n support - replaces object keys
   * found in template with corresponding values
   * @param {String} str String containing values to localize
   * @param {Array} params Substitute parameters
   * @returns {String}
   */ key: "localize",
            value: function localize(str) {
                var _this = this;
                var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
                str = String(str).replace(/\{\{(\w+).?(\w+)?\}\}/g, function(match, key, subkey) {
                    var rez = "";
                    // Plugins have `Plugin.l10n.KEY`
                    if (subkey) rez = _this.option("".concat(key[0] + key.toLowerCase().substring(1), ".l10n.").concat(subkey));
                    else if (key) rez = _this.option("l10n.".concat(key));
                    if (!rez) rez = match;
                    for(var index = 0; index < params.length; index++)rez = rez.split(params[index][0]).join(params[index][1]);
                    return rez;
                });
                str = str.replace(/\{\{(.*)\}\}/, function(match, key) {
                    return key;
                });
                return str;
            }
        },
        {
            /**
   * Subscribe to an event
   * @param {String} name
   * @param {Function} callback
   * @returns {Object}
   */ key: "on",
            value: function on(name, callback) {
                var _this = this;
                if ((0, $66f4d3fde35745bd$export$53b83ca8eaab0383)(name)) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.entries(name)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var args = _step.value;
                            this.on.apply(this, (0, $b6a26340ba3e8c80$export$71511d61b312f219)(args));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return this;
                }
                String(name).split(" ").forEach(function(item) {
                    var listeners = _this.events[item] = _this.events[item] || [];
                    if (listeners.indexOf(callback) == -1) listeners.push(callback);
                });
                return this;
            }
        },
        {
            /**
   * Subscribe to an event only once
   * @param {String} name
   * @param {Function} callback
   * @returns {Object}
   */ key: "once",
            value: function once(name, callback) {
                var _this = this;
                if ((0, $66f4d3fde35745bd$export$53b83ca8eaab0383)(name)) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.entries(name)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var args = _step.value;
                            this.once.apply(this, (0, $b6a26340ba3e8c80$export$71511d61b312f219)(args));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return this;
                }
                String(name).split(" ").forEach(function(item) {
                    var _this1 = _this;
                    var listener = function() {
                        for(var _len = arguments.length, details = new Array(_len), _key = 0; _key < _len; _key++){
                            details[_key] = arguments[_key];
                        }
                        var _callback;
                        _this1.off(item, listener);
                        (_callback = callback).call.apply(_callback, [
                            _this1,
                            _this1
                        ].concat((0, $b6a26340ba3e8c80$export$71511d61b312f219)(details)));
                    };
                    listener._ = callback;
                    _this.on(item, listener);
                });
                return this;
            }
        },
        {
            /**
   * Unsubscribe event with name and callback
   * @param {String} name
   * @param {Function} callback
   * @returns {Object}
   */ key: "off",
            value: function off(name, callback) {
                var _this = this;
                if ((0, $66f4d3fde35745bd$export$53b83ca8eaab0383)(name)) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.entries(name)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var args = _step.value;
                            this.off.apply(this, (0, $b6a26340ba3e8c80$export$71511d61b312f219)(args));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return;
                }
                name.split(" ").forEach(function(item) {
                    var listeners = _this.events[item];
                    if (!listeners || !listeners.length) return _this;
                    var index = -1;
                    for(var i = 0, len = listeners.length; i < len; i++){
                        var listener = listeners[i];
                        if (listener && (listener === callback || listener._ === callback)) {
                            index = i;
                            break;
                        }
                    }
                    if (index != -1) listeners.splice(index, 1);
                });
                return this;
            }
        },
        {
            /**
   * Emit an event.
   * If present, `"*"` handlers are invoked after name-matched handlers.
   * @param {String} name
   * @param  {...any} details
   * @returns {Boolean}
   */ key: "trigger",
            value: function trigger(name) {
                for(var _len = arguments.length, details = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    details[_key - 1] = arguments[_key];
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (0, $b6a26340ba3e8c80$export$71511d61b312f219)(this.events[name] || []).slice()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var listener = _step.value;
                        var _listener;
                        if (listener && (_listener = listener).call.apply(_listener, [
                            this,
                            this
                        ].concat((0, $b6a26340ba3e8c80$export$71511d61b312f219)(details))) === false) return false;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    // A wildcard "*" event type
                    for(var _iterator1 = (0, $b6a26340ba3e8c80$export$71511d61b312f219)(this.events["*"] || []).slice()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var listener1 = _step1.value;
                        var _listener1;
                        if (listener1 && (_listener1 = listener1).call.apply(_listener1, [
                            this,
                            name,
                            this
                        ].concat((0, $b6a26340ba3e8c80$export$71511d61b312f219)(details))) === false) return false;
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                            _iterator1["return"]();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                return true;
            }
        },
        {
            /**
   * Add given plugins to this instance,
   * this will end up calling `attach` method of each plugin
   * @param {Object} Plugins
   * @returns {Object}
   */ key: "attachPlugins",
            value: function attachPlugins(plugins) {
                var newPlugins = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(plugins || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $1933fb0d7df0f802$export$71511d61b312f219)(_step.value, 2), key = _step_value[0], Plugin = _step_value[1];
                        // Check if this plugin is not disabled by option
                        if (this.options[key] !== false && !this.plugins[key]) {
                            // Populate options with defaults from the plugin
                            this.options[key] = (0, $473ff96f0aaf0a3a$export$8b58be045bf06082)({}, Plugin.defaults || {}, this.options[key]);
                            // Initialise plugin
                            newPlugins[key] = new Plugin(this);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = Object.entries(newPlugins)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var _step_value1 = (0, $1933fb0d7df0f802$export$71511d61b312f219)(_step1.value, 2), key1 = _step_value1[0], plugin = _step_value1[1];
                        plugin.attach(this);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                            _iterator1["return"]();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                this.plugins = Object.assign({}, this.plugins, newPlugins);
                return this;
            }
        },
        {
            /**
   * Remove all plugin instances from this instance,
   * this will end up calling `detach` method of each plugin
   * @returns {Object}
   */ key: "detachPlugins",
            value: function detachPlugins() {
                for(var key in this.plugins){
                    var plugin = void 0;
                    if ((plugin = this.plugins[key]) && typeof plugin.detach === "function") plugin.detach(this);
                }
                this.plugins = {};
                return this;
            }
        }
    ]);
    return Base;
}();






function $48a9316a11301a62$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $2c2de140d7828cca$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $48a9316a11301a62$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $f077b226522f8b2c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f077b226522f8b2c$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $f077b226522f8b2c$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}













/**
 * Round half up; to be more specific and to ensure things like 1.005 round correctly
 * @param {Float} value
 * @param {Integer} precision
 * @returns {Float}
 */ var $589b315cfb953e4c$export$2077e0241d6afd3c = function(value) {
    var precision = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10000;
    value = parseFloat(value) || 0;
    return Math.round((value + Number.EPSILON) * precision) / precision;
};


/**
 * Check if  element has scrollable content
 * @param {Node} node
 * @returns {Boolean}
 */ 
var $73e79f034cb06cc3$export$988b38dbf6859d61 = function hasScrollbars(node) {
    var overflowY = getComputedStyle(node)["overflow-y"], overflowX = getComputedStyle(node)["overflow-x"], vertical = (overflowY === "scroll" || overflowY === "auto") && Math.abs(node.scrollHeight - node.clientHeight) > 1, horizontal = (overflowX === "scroll" || overflowX === "auto") && Math.abs(node.scrollWidth - node.clientWidth) > 1;
    return vertical || horizontal;
};
var $73e79f034cb06cc3$export$2bb74740c4e19def = function isScrollable1(node) {
    if (!node || !((typeof node === "undefined" ? "undefined" : (0, $685ec1f5000467c6$export$71511d61b312f219)(node)) === "object" && node instanceof Element) || node === document.body) return false;
    if (node.__Panzoom) return false;
    if ($73e79f034cb06cc3$export$988b38dbf6859d61(node)) return node;
    return $73e79f034cb06cc3$export$2bb74740c4e19def(node.parentNode);
};


/**
 * ResizeObserver Polyfill
 */ 

var $95bdb4c54af14f5e$export$9caf76241ca21a11 = typeof window !== "undefined" && window.ResizeObserver || /*#__PURE__*/ function() {
    "use strict";
    function _class(callback) {
        (0, $748c5547edb8a18d$export$71511d61b312f219)(this, _class);
        this.observables = [];
        // Array of observed elements that looks like this:
        // [{
        //   el: domNode,
        //   size: {height: x, width: y}
        // }]
        this.boundCheck = this.check.bind(this);
        this.boundCheck();
        this.callback = callback;
    }
    (0, $c95e6614e27503ea$export$71511d61b312f219)(_class, [
        {
            key: "observe",
            value: function observe(el) {
                if (this.observables.some(function(observable) {
                    return observable.el === el;
                })) return;
                var newObservable = {
                    el: el,
                    size: {
                        height: el.clientHeight,
                        width: el.clientWidth
                    }
                };
                this.observables.push(newObservable);
            }
        },
        {
            key: "unobserve",
            value: function unobserve(el) {
                this.observables = this.observables.filter(function(obj) {
                    return obj.el !== el;
                });
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                this.observables = [];
            }
        },
        {
            key: "check",
            value: function check() {
                var changedEntries = this.observables.filter(function(obj) {
                    var currentHeight = obj.el.clientHeight;
                    var currentWidth = obj.el.clientWidth;
                    if (obj.size.height !== currentHeight || obj.size.width !== currentWidth) {
                        obj.size.height = currentHeight;
                        obj.size.width = currentWidth;
                        return true;
                    }
                }).map(function(obj) {
                    return obj.el;
                });
                if (changedEntries.length > 0) this.callback(changedEntries);
                window.requestAnimationFrame(this.boundCheck);
            }
        }
    ]);
    return _class;
}();




var $ea371fd2824cf301$var$Pointer = function Pointer(nativePointer) {
    "use strict";
    (0, $748c5547edb8a18d$export$71511d61b312f219)(this, Pointer);
    this.id = self.Touch && nativePointer instanceof Touch ? nativePointer.identifier : -1;
    this.pageX = nativePointer.pageX;
    this.pageY = nativePointer.pageY;
    this.clientX = nativePointer.clientX;
    this.clientY = nativePointer.clientY;
};
var $ea371fd2824cf301$export$79376507b09a66f = function(a, b) {
    if (!b) return 0;
    return Math.sqrt(Math.pow(b.clientX - a.clientX, 2) + Math.pow(b.clientY - a.clientY, 2));
};
var $ea371fd2824cf301$export$b820caf342892892 = function(a, b) {
    if (!b) return a;
    return {
        clientX: (a.clientX + b.clientX) / 2,
        clientY: (a.clientY + b.clientY) / 2
    };
};
var $ea371fd2824cf301$var$isTouchEvent = function(event) {
    return "changedTouches" in event;
};
var $ea371fd2824cf301$export$602faa26dc074936 = /*#__PURE__*/ function() {
    "use strict";
    function PointerTracker(_element) {
        var _this = this;
        var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_start = _ref.start, start = _ref_start === void 0 ? function() {
            return true;
        } : _ref_start, _ref_move = _ref.move, move = _ref_move === void 0 ? function() {} : _ref_move, _ref_end = _ref.end, end = _ref_end === void 0 ? function() {} : _ref_end;
        (0, $748c5547edb8a18d$export$71511d61b312f219)(this, PointerTracker);
        this._element = _element;
        this.startPointers = [];
        this.currentPointers = [];
        this._pointerStart = function(event) {
            if (event.buttons > 0 && event.button !== 0) return;
            var pointer = new $ea371fd2824cf301$var$Pointer(event);
            if (_this.currentPointers.some(function(p) {
                return p.id === pointer.id;
            })) return;
            if (!_this._triggerPointerStart(pointer, event)) return;
            window.addEventListener("mousemove", _this._move);
            window.addEventListener("mouseup", _this._pointerEnd);
        };
        this._touchStart = function(event) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Array.from(event.changedTouches || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var touch = _step.value;
                    _this._triggerPointerStart(new $ea371fd2824cf301$var$Pointer(touch), event);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        };
        this._move = function(event) {
            var previousPointers = _this.currentPointers.slice();
            var changedPointers = $ea371fd2824cf301$var$isTouchEvent(event) ? Array.from(event.changedTouches).map(function(t) {
                return new $ea371fd2824cf301$var$Pointer(t);
            }) : [
                new $ea371fd2824cf301$var$Pointer(event)
            ];
            var trackedChangedPointers = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                var _loop = function() {
                    var pointer = _step.value;
                    var index = _this.currentPointers.findIndex(function(p) {
                        return p.id === pointer.id;
                    });
                    if (index < 0) return "continue";
                    trackedChangedPointers.push(pointer);
                    _this.currentPointers[index] = pointer;
                };
                for(var _iterator = changedPointers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            _this._moveCallback(previousPointers, _this.currentPointers.slice(), event);
        };
        this._triggerPointerEnd = function(pointer, event) {
            var index = _this.currentPointers.findIndex(function(p) {
                return p.id === pointer.id;
            });
            if (index < 0) return false;
            _this.currentPointers.splice(index, 1);
            _this.startPointers.splice(index, 1);
            _this._endCallback(pointer, event);
            return true;
        };
        this._pointerEnd = function(event) {
            if (event.buttons > 0 && event.button !== 0) return;
            if (!_this._triggerPointerEnd(new $ea371fd2824cf301$var$Pointer(event), event)) return;
            window.removeEventListener("mousemove", _this._move, {
                passive: false
            });
            window.removeEventListener("mouseup", _this._pointerEnd, {
                passive: false
            });
        };
        this._touchEnd = function(event) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Array.from(event.changedTouches || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var touch = _step.value;
                    _this._triggerPointerEnd(new $ea371fd2824cf301$var$Pointer(touch), event);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        };
        this._startCallback = start;
        this._moveCallback = move;
        this._endCallback = end;
        this._element.addEventListener("mousedown", this._pointerStart, {
            passive: false
        });
        this._element.addEventListener("touchstart", this._touchStart, {
            passive: false
        });
        this._element.addEventListener("touchmove", this._move, {
            passive: false
        });
        this._element.addEventListener("touchend", this._touchEnd);
        this._element.addEventListener("touchcancel", this._touchEnd);
    }
    (0, $c95e6614e27503ea$export$71511d61b312f219)(PointerTracker, [
        {
            key: "stop",
            value: function stop() {
                this._element.removeEventListener("mousedown", this._pointerStart, {
                    passive: false
                });
                this._element.removeEventListener("touchstart", this._touchStart, {
                    passive: false
                });
                this._element.removeEventListener("touchmove", this._move, {
                    passive: false
                });
                this._element.removeEventListener("touchend", this._touchEnd);
                this._element.removeEventListener("touchcancel", this._touchEnd);
                window.removeEventListener("mousemove", this._move);
                window.removeEventListener("mouseup", this._pointerEnd);
            }
        },
        {
            key: "_triggerPointerStart",
            value: function _triggerPointerStart(pointer, event) {
                if (!this._startCallback(pointer, event)) return false;
                this.currentPointers.push(pointer);
                this.startPointers.push(pointer);
                return true;
            }
        }
    ]);
    return PointerTracker;
}();


/**
 * Get element child node at the given coordinates
 * @param {Element} HTML element
 * @param {Float|Integer} x
 * @param {Float|Integer} y
 * @returns {Node|Boolean}}
 */ var $e8a9a06cad284bae$export$5a4c7d2802d310f9 = function(element, x, y) {
    var nodes = element.childNodes;
    var range = document.createRange();
    for(var i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.nodeType !== Node.TEXT_NODE) continue;
        range.selectNodeContents(node);
        var rect = range.getBoundingClientRect();
        if (x >= rect.left && y >= rect.top && x <= rect.right && y <= rect.bottom) return node;
    }
    return false;
};


/**
 * Get actual width of the element, regardless of how much of content is currently visible
 * @param {Element} elem
 * @returns {Integer}
 */ var $f591b94ce82dac9c$export$b6952c0cabba95b1 = function(elem) {
    return Math.max(parseFloat(elem.naturalWidth || 0), parseFloat(elem.width && elem.width.baseVal && elem.width.baseVal.value || 0), parseFloat(elem.offsetWidth || 0), parseFloat(elem.scrollWidth || 0));
};
var $f591b94ce82dac9c$export$36c2abee46ce2f83 = function(elem) {
    return Math.max(parseFloat(elem.naturalHeight || 0), parseFloat(elem.height && elem.height.baseVal && elem.height.baseVal.value || 0), parseFloat(elem.offsetHeight || 0), parseFloat(elem.scrollHeight || 0));
};
var $f591b94ce82dac9c$export$26b8a639408dbbb6 = function(srcWidth, srcHeight, maxWidth, maxHeight) {
    var ratio = Math.min(maxWidth / srcWidth || 0, maxHeight / srcHeight);
    return {
        width: srcWidth * ratio || 0,
        height: srcHeight * ratio || 0
    };
};



var $ad7b922a9ea61c9f$export$c203ca0aafe4939a = {};


var $9707d077d55fad71$var$defaults = {
    // Enable touch guestures
    touch: true,
    // Enable zooming
    zoom: true,
    // Enable pinch gesture to zoom in/out using two fingers
    pinchToZoom: true,
    // Disable dragging if scale level is equal to value of `baseScale` option
    panOnlyZoomed: false,
    // Lock axis while dragging,
    // possible values: false | "x" | "y" | "xy"
    lockAxis: false,
    // * All friction values are inside [0, 1) interval,
    // * where 0 would change instantly, but 0.99 would update extremely slowly
    // Friction while panning/dragging
    friction: 0.64,
    // Friction while decelerating after drag end
    decelFriction: 0.88,
    // Friction while scaling
    zoomFriction: 0.74,
    // Bounciness after hitting the edge
    bounceForce: 0.2,
    // Initial scale level
    baseScale: 1,
    // Minimum scale level
    minScale: 1,
    // Maximum scale level
    maxScale: 2,
    // Default scale step while zooming
    step: 0.5,
    // Allow to select text,
    // if enabled, dragging will be disabled when text selection is detected
    textSelection: false,
    // Add `click` event listener,
    // possible values: true | false | function | "toggleZoom"
    click: "toggleZoom",
    // Add `wheel` event listener,
    // possible values: true | false | function |  "zoom"
    wheel: "zoom",
    // Value for zoom on mouse wheel
    wheelFactor: 42,
    // Number of wheel events after which it should stop preventing default behaviour of mouse wheel
    wheelLimit: 5,
    // Class name added to `$viewport` element to indicate if content is draggable
    draggableClass: "is-draggable",
    // Class name added to `$viewport` element to indicate that user is currently dragging
    draggingClass: "is-dragging",
    // Content will be scaled by this number,
    // this can also be a function which should return a number, for example:
    // ratio: function() { return 1 / (window.devicePixelRatio || 1) }
    ratio: 1
};
var $9707d077d55fad71$export$b704d075ddd20210 = /*#__PURE__*/ function(Base) {
    "use strict";
    (0, $1e7277e0f02f2550$export$71511d61b312f219)(Panzoom, Base);
    function Panzoom($container) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $748c5547edb8a18d$export$71511d61b312f219)(this, Panzoom);
        var _this;
        _this = (0, $c1745da3357c8fcc$export$71511d61b312f219)(this, Panzoom, [
            (0, $473ff96f0aaf0a3a$export$8b58be045bf06082)(true, {}, $9707d077d55fad71$var$defaults, options)
        ]);
        _this.state = "init";
        _this.$container = $container;
        // Bind event handlers for referencability
        for(var _i = 0, _iter = [
            "onLoad",
            "onWheel",
            "onClick"
        ]; _i < _iter.length; _i++){
            var methodName = _iter[_i];
            _this[methodName] = _this[methodName].bind(_this);
        }
        _this.initLayout();
        _this.resetValues();
        _this.attachPlugins(Panzoom.Plugins);
        _this.trigger("init");
        _this.updateMetrics();
        _this.attachEvents();
        _this.trigger("ready");
        if (_this.option("centerOnStart") === false) _this.state = "ready";
        else _this.panTo({
            friction: 0
        });
        $container.__Panzoom = _this;
        return _this;
    }
    (0, $c95e6614e27503ea$export$71511d61b312f219)(Panzoom, [
        {
            /**
   * Create references to container, viewport and content elements
   */ key: "initLayout",
            value: function initLayout() {
                var $container = this.$container;
                // Make sure content element exists
                if (!($container instanceof HTMLElement)) throw new Error("Panzoom: Container not found");
                var $content = this.option("content") || $container.querySelector(".panzoom__content");
                // Make sure content element exists
                if (!$content) throw new Error("Panzoom: Content not found");
                this.$content = $content;
                var $viewport = this.option("viewport") || $container.querySelector(".panzoom__viewport");
                if (!$viewport && this.option("wrapInner") !== false) {
                    var _$viewport;
                    $viewport = document.createElement("div");
                    $viewport.classList.add("panzoom__viewport");
                    (_$viewport = $viewport).append.apply(_$viewport, (0, $b6a26340ba3e8c80$export$71511d61b312f219)($container.childNodes));
                    $container.appendChild($viewport);
                }
                this.$viewport = $viewport || $content.parentNode;
            }
        },
        {
            /**
   * Restore instance variables to default values
   */ key: "resetValues",
            value: function resetValues() {
                this.updateRate = this.option("updateRate", /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ? 250 : 24);
                this.container = {
                    width: 0,
                    height: 0
                };
                this.viewport = {
                    width: 0,
                    height: 0
                };
                this.content = {
                    // Full content dimensions (naturalWidth/naturalHeight for images)
                    origWidth: 0,
                    origHeight: 0,
                    // Current dimensions of the content
                    width: 0,
                    height: 0,
                    // Current position; these values reflect CSS `transform` value
                    x: this.option("x", 0),
                    y: this.option("y", 0),
                    // Current scale; does not reflect CSS `transform` value
                    scale: this.option("baseScale")
                };
                // End values of current pan / zoom animation
                this.transform = {
                    x: 0,
                    y: 0,
                    scale: 1
                };
                this.resetDragPosition();
            }
        },
        {
            /**
   * Handle `load` event
   * @param {Event} event
   */ key: "onLoad",
            value: function onLoad(event) {
                this.updateMetrics();
                this.panTo({
                    scale: this.option("baseScale"),
                    friction: 0
                });
                this.trigger("load", event);
            }
        },
        {
            /**
   * Handle `click` event
   * @param {Event} event
   */ key: "onClick",
            value: function onClick(event) {
                if (event.defaultPrevented) return;
                if (document.activeElement && document.activeElement.closest("[contenteditable]")) return;
                // Skip if text is selected
                if (this.option("textSelection") && window.getSelection().toString().length && !(event.target && event.target.hasAttribute("data-fancybox-close"))) {
                    event.stopPropagation();
                    return;
                }
                var rect = this.$content.getClientRects()[0];
                // Check if container has changed position (for example, when current instance is inside another one)
                if (this.state !== "ready") {
                    if (this.dragPosition.midPoint || Math.abs(rect.top - this.dragStart.rect.top) > 1 || Math.abs(rect.left - this.dragStart.rect.left) > 1) {
                        event.preventDefault();
                        event.stopPropagation();
                        return;
                    }
                }
                if (this.trigger("click", event) === false) return;
                if (this.option("zoom") && this.option("click") === "toggleZoom") {
                    event.preventDefault();
                    event.stopPropagation();
                    this.zoomWithClick(event);
                }
            }
        },
        {
            /**
   * Handle `wheel` event
   * @param {Event} event
   */ key: "onWheel",
            value: function onWheel(event) {
                if (this.trigger("wheel", event) === false) return;
                if (this.option("zoom") && this.option("wheel")) this.zoomWithWheel(event);
            }
        },
        {
            /**
   * Change zoom level depending on scroll direction
   * @param {Event} event `wheel` event
   */ key: "zoomWithWheel",
            value: function zoomWithWheel(event) {
                if (this.changedDelta === undefined) this.changedDelta = 0;
                var delta = Math.max(-1, Math.min(1, -event.deltaY || -event.deltaX || event.wheelDelta || -event.detail));
                var scale = this.content.scale;
                var newScale = scale * (100 + delta * this.option("wheelFactor")) / 100;
                if (delta < 0 && Math.abs(scale - this.option("minScale")) < 0.01 || delta > 0 && Math.abs(scale - this.option("maxScale")) < 0.01) {
                    this.changedDelta += Math.abs(delta);
                    newScale = scale;
                } else {
                    this.changedDelta = 0;
                    newScale = Math.max(Math.min(newScale, this.option("maxScale")), this.option("minScale"));
                }
                if (this.changedDelta > this.option("wheelLimit")) return;
                event.preventDefault();
                if (newScale === scale) return;
                var rect = this.$content.getBoundingClientRect();
                var x = event.clientX - rect.left;
                var y = event.clientY - rect.top;
                this.zoomTo(newScale, {
                    x: x,
                    y: y
                });
            }
        },
        {
            /**
   * Change zoom level depending on click coordinates
   * @param {Event} event `click` event
   */ key: "zoomWithClick",
            value: function zoomWithClick(event) {
                var rect = this.$content.getClientRects()[0];
                var x = event.clientX - rect.left;
                var y = event.clientY - rect.top;
                this.toggleZoom({
                    x: x,
                    y: y
                });
            }
        },
        {
            /**
   * Attach load, wheel and click event listeners, initialize `resizeObserver` and `PointerTracker`
   */ key: "attachEvents",
            value: function attachEvents() {
                var _this = this;
                this.$content.addEventListener("load", this.onLoad);
                this.$container.addEventListener("wheel", this.onWheel, {
                    passive: false
                });
                this.$container.addEventListener("click", this.onClick, {
                    passive: false
                });
                this.initObserver();
                var pointerTracker = new (0, $ea371fd2824cf301$export$602faa26dc074936)(this.$container, {
                    start: function(pointer, event) {
                        if (!_this.option("touch")) return false;
                        if (_this.velocity.scale < 0) return false;
                        var target = event.composedPath()[0];
                        if (!pointerTracker.currentPointers.length) {
                            var ignoreClickedElement = [
                                "BUTTON",
                                "TEXTAREA",
                                "OPTION",
                                "INPUT",
                                "SELECT",
                                "VIDEO"
                            ].indexOf(target.nodeName) !== -1;
                            if (ignoreClickedElement) return false;
                            // Allow text selection
                            if (_this.option("textSelection") && (0, $e8a9a06cad284bae$export$5a4c7d2802d310f9)(target, pointer.clientX, pointer.clientY)) return false;
                        }
                        if ((0, $73e79f034cb06cc3$export$2bb74740c4e19def)(target)) return false;
                        if (_this.trigger("touchStart", event) === false) return false;
                        if (event.type === "mousedown") event.preventDefault();
                        _this.state = "pointerdown";
                        _this.resetDragPosition();
                        _this.dragPosition.midPoint = null;
                        _this.dragPosition.time = Date.now();
                        return true;
                    },
                    move: function(previousPointers, currentPointers, event) {
                        if (_this.state !== "pointerdown") return;
                        if (_this.trigger("touchMove", event) === false) {
                            event.preventDefault();
                            return;
                        }
                        // Disable touch action if current zoom level is below base level
                        if (currentPointers.length < 2 && _this.option("panOnlyZoomed") === true && _this.content.width <= _this.viewport.width && _this.content.height <= _this.viewport.height && _this.transform.scale <= _this.option("baseScale")) return;
                        if (currentPointers.length > 1 && (!_this.option("zoom") || _this.option("pinchToZoom") === false)) return;
                        var prevMidpoint = (0, $ea371fd2824cf301$export$b820caf342892892)(previousPointers[0], previousPointers[1]);
                        var newMidpoint = (0, $ea371fd2824cf301$export$b820caf342892892)(currentPointers[0], currentPointers[1]);
                        var panX = newMidpoint.clientX - prevMidpoint.clientX;
                        var panY = newMidpoint.clientY - prevMidpoint.clientY;
                        var prevDistance = (0, $ea371fd2824cf301$export$79376507b09a66f)(previousPointers[0], previousPointers[1]);
                        var newDistance = (0, $ea371fd2824cf301$export$79376507b09a66f)(currentPointers[0], currentPointers[1]);
                        var scaleDiff = prevDistance && newDistance ? newDistance / prevDistance : 1;
                        _this.dragOffset.x += panX;
                        _this.dragOffset.y += panY;
                        _this.dragOffset.scale *= scaleDiff;
                        _this.dragOffset.time = Date.now() - _this.dragPosition.time;
                        var axisToLock = _this.dragStart.scale === 1 && _this.option("lockAxis");
                        if (axisToLock && !_this.lockAxis) {
                            if (Math.abs(_this.dragOffset.x) < 6 && Math.abs(_this.dragOffset.y) < 6) {
                                event.preventDefault();
                                return;
                            }
                            var angle = Math.abs(Math.atan2(_this.dragOffset.y, _this.dragOffset.x) * 180 / Math.PI);
                            _this.lockAxis = angle > 45 && angle < 135 ? "y" : "x";
                        }
                        if (axisToLock !== "xy" && _this.lockAxis === "y") return;
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        if (_this.lockAxis) _this.dragOffset[_this.lockAxis === "x" ? "y" : "x"] = 0;
                        _this.$container.classList.add(_this.option("draggingClass"));
                        if (!(_this.transform.scale === _this.option("baseScale") && _this.lockAxis === "y")) _this.dragPosition.x = _this.dragStart.x + _this.dragOffset.x;
                        if (!(_this.transform.scale === _this.option("baseScale") && _this.lockAxis === "x")) _this.dragPosition.y = _this.dragStart.y + _this.dragOffset.y;
                        _this.dragPosition.scale = _this.dragStart.scale * _this.dragOffset.scale;
                        if (currentPointers.length > 1) {
                            var startPoint = (0, $ea371fd2824cf301$export$b820caf342892892)(pointerTracker.startPointers[0], pointerTracker.startPointers[1]);
                            var xPos = startPoint.clientX - _this.dragStart.rect.x;
                            var yPos = startPoint.clientY - _this.dragStart.rect.y;
                            var _this_getZoomDelta = _this.getZoomDelta(_this.content.scale * _this.dragOffset.scale, xPos, yPos), deltaX = _this_getZoomDelta.deltaX, deltaY = _this_getZoomDelta.deltaY;
                            _this.dragPosition.x -= deltaX;
                            _this.dragPosition.y -= deltaY;
                            _this.dragPosition.midPoint = newMidpoint;
                        } else _this.setDragResistance();
                        // Update final position
                        _this.transform = {
                            x: _this.dragPosition.x,
                            y: _this.dragPosition.y,
                            scale: _this.dragPosition.scale
                        };
                        _this.startAnimation();
                    },
                    end: function(pointer, event) {
                        if (_this.state !== "pointerdown") return;
                        _this._dragOffset = (0, $2c2de140d7828cca$export$71511d61b312f219)({}, _this.dragOffset);
                        if (pointerTracker.currentPointers.length) {
                            _this.resetDragPosition();
                            return;
                        }
                        _this.state = "decel";
                        _this.friction = _this.option("decelFriction");
                        _this.recalculateTransform();
                        _this.$container.classList.remove(_this.option("draggingClass"));
                        if (_this.trigger("touchEnd", event) === false) return;
                        if (_this.state !== "decel") return;
                        // * Check if scaled content past limits
                        // Below minimum
                        var minScale = _this.option("minScale");
                        if (_this.transform.scale < minScale) {
                            _this.zoomTo(minScale, {
                                friction: 0.64
                            });
                            return;
                        }
                        // Exceed maximum
                        var maxScale = _this.option("maxScale");
                        if (_this.transform.scale - maxScale > 0.01) {
                            var last = _this.dragPosition.midPoint || pointer;
                            var rect = _this.$content.getClientRects()[0];
                            _this.zoomTo(maxScale, {
                                friction: 0.64,
                                x: last.clientX - rect.left,
                                y: last.clientY - rect.top
                            });
                            return;
                        }
                    }
                });
                this.pointerTracker = pointerTracker;
            }
        },
        {
            key: "initObserver",
            value: function initObserver() {
                var _this = this;
                if (this.resizeObserver) return;
                this.resizeObserver = new (0, $95bdb4c54af14f5e$export$9caf76241ca21a11)(function() {
                    if (_this.updateTimer) return;
                    _this.updateTimer = setTimeout(function() {
                        var rect = _this.$container.getBoundingClientRect();
                        if (!(rect.width && rect.height)) {
                            _this.updateTimer = null;
                            return;
                        }
                        // Check to see if there are any changes
                        if (Math.abs(rect.width - _this.container.width) > 1 || Math.abs(rect.height - _this.container.height) > 1) {
                            if (_this.isAnimating()) _this.endAnimation(true);
                            _this.updateMetrics();
                            _this.panTo({
                                x: _this.content.x,
                                y: _this.content.y,
                                scale: _this.option("baseScale"),
                                friction: 0
                            });
                        }
                        _this.updateTimer = null;
                    }, _this.updateRate);
                });
                this.resizeObserver.observe(this.$container);
            }
        },
        {
            /**
   * Restore drag related variables to default values
   */ key: "resetDragPosition",
            value: function resetDragPosition() {
                this.lockAxis = null;
                this.friction = this.option("friction");
                this.velocity = {
                    x: 0,
                    y: 0,
                    scale: 0
                };
                var _this_content = this.content, x = _this_content.x, y = _this_content.y, scale = _this_content.scale;
                this.dragStart = {
                    rect: this.$content.getBoundingClientRect(),
                    x: x,
                    y: y,
                    scale: scale
                };
                this.dragPosition = (0, $f077b226522f8b2c$export$71511d61b312f219)((0, $2c2de140d7828cca$export$71511d61b312f219)({}, this.dragPosition), {
                    x: x,
                    y: y,
                    scale: scale
                });
                this.dragOffset = {
                    x: 0,
                    y: 0,
                    scale: 1,
                    time: 0
                };
            }
        },
        {
            /**
   * Trigger update events before/after resizing content and viewport
   * @param {Boolean} silently Should trigger `afterUpdate` event at the end
   */ key: "updateMetrics",
            value: function updateMetrics(silently) {
                if (silently !== true) this.trigger("beforeUpdate");
                var $container = this.$container;
                var $content = this.$content;
                var $viewport = this.$viewport;
                var contentIsImage = $content instanceof HTMLImageElement;
                var contentIsZoomable = this.option("zoom");
                var shouldResizeParent = this.option("resizeParent", contentIsZoomable);
                var width = this.option("width");
                var height = this.option("height");
                var origWidth = width || (0, $f591b94ce82dac9c$export$b6952c0cabba95b1)($content);
                var origHeight = height || (0, $f591b94ce82dac9c$export$36c2abee46ce2f83)($content);
                Object.assign($content.style, {
                    width: width ? "".concat(width, "px") : "",
                    height: height ? "".concat(height, "px") : "",
                    maxWidth: "",
                    maxHeight: ""
                });
                if (shouldResizeParent) Object.assign($viewport.style, {
                    width: "",
                    height: ""
                });
                var ratio = this.option("ratio");
                origWidth = (0, $589b315cfb953e4c$export$2077e0241d6afd3c)(origWidth * ratio);
                origHeight = (0, $589b315cfb953e4c$export$2077e0241d6afd3c)(origHeight * ratio);
                width = origWidth;
                height = origHeight;
                var contentRect = $content.getBoundingClientRect();
                var viewportRect = $viewport.getBoundingClientRect();
                var containerRect = $viewport == $container ? viewportRect : $container.getBoundingClientRect();
                var viewportWidth = Math.max($viewport.offsetWidth, (0, $589b315cfb953e4c$export$2077e0241d6afd3c)(viewportRect.width));
                var viewportHeight = Math.max($viewport.offsetHeight, (0, $589b315cfb953e4c$export$2077e0241d6afd3c)(viewportRect.height));
                var viewportStyles = window.getComputedStyle($viewport);
                viewportWidth -= parseFloat(viewportStyles.paddingLeft) + parseFloat(viewportStyles.paddingRight);
                viewportHeight -= parseFloat(viewportStyles.paddingTop) + parseFloat(viewportStyles.paddingBottom);
                this.viewport.width = viewportWidth;
                this.viewport.height = viewportHeight;
                if (contentIsZoomable) {
                    if (Math.abs(origWidth - contentRect.width) > 0.1 || Math.abs(origHeight - contentRect.height) > 0.1) {
                        var rez = (0, $f591b94ce82dac9c$export$26b8a639408dbbb6)(origWidth, origHeight, Math.min(origWidth, contentRect.width), Math.min(origHeight, contentRect.height));
                        width = (0, $589b315cfb953e4c$export$2077e0241d6afd3c)(rez.width);
                        height = (0, $589b315cfb953e4c$export$2077e0241d6afd3c)(rez.height);
                    }
                    Object.assign($content.style, {
                        width: "".concat(width, "px"),
                        height: "".concat(height, "px"),
                        transform: ""
                    });
                }
                if (shouldResizeParent) {
                    Object.assign($viewport.style, {
                        width: "".concat(width, "px"),
                        height: "".concat(height, "px")
                    });
                    this.viewport = (0, $f077b226522f8b2c$export$71511d61b312f219)((0, $2c2de140d7828cca$export$71511d61b312f219)({}, this.viewport), {
                        width: width,
                        height: height
                    });
                }
                if (contentIsImage && contentIsZoomable && typeof this.options.maxScale !== "function") {
                    var maxScale = this.option("maxScale");
                    this.options.maxScale = function() {
                        return this.content.origWidth > 0 && this.content.fitWidth > 0 ? this.content.origWidth / this.content.fitWidth : maxScale;
                    };
                }
                this.content = (0, $f077b226522f8b2c$export$71511d61b312f219)((0, $2c2de140d7828cca$export$71511d61b312f219)({}, this.content), {
                    origWidth: origWidth,
                    origHeight: origHeight,
                    fitWidth: width,
                    fitHeight: height,
                    width: width,
                    height: height,
                    scale: 1,
                    isZoomable: contentIsZoomable
                });
                this.container = {
                    width: containerRect.width,
                    height: containerRect.height
                };
                if (silently !== true) this.trigger("afterUpdate");
            }
        },
        {
            /**
   * Increase zoom level
   * @param {Number} [step] Zoom ratio; `0.5` would increase scale from 1 to 1.5
   */ key: "zoomIn",
            value: function zoomIn(step) {
                this.zoomTo(this.content.scale + (step || this.option("step")));
            }
        },
        {
            /**
   * Decrease zoom level
   * @param {Number} [step] Zoom ratio; `0.5` would decrease scale from 1.5 to 1
   */ key: "zoomOut",
            value: function zoomOut(step) {
                this.zoomTo(this.content.scale - (step || this.option("step")));
            }
        },
        {
            /**
   * Toggles zoom level between max and base levels
   * @param {Object} [options] Additional options
   */ key: "toggleZoom",
            value: function toggleZoom() {
                var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var maxScale = this.option("maxScale");
                var baseScale = this.option("baseScale");
                var scale = this.content.scale > baseScale + (maxScale - baseScale) * 0.5 ? baseScale : maxScale;
                this.zoomTo(scale, props);
            }
        },
        {
            /**
   * Animate to given zoom level
   * @param {Number} scale New zoom level
   * @param {Object} [options] Additional options
   */ key: "zoomTo",
            value: function zoomTo() {
                var scale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.option("baseScale"), _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_x = _ref.x, x = _ref_x === void 0 ? null : _ref_x, _ref_y = _ref.y, y = _ref_y === void 0 ? null : _ref_y;
                scale = Math.max(Math.min(scale, this.option("maxScale")), this.option("minScale"));
                // Adjust zoom position
                var currentScale = (0, $589b315cfb953e4c$export$2077e0241d6afd3c)(this.content.scale / (this.content.width / this.content.fitWidth), 10000000);
                if (x === null) x = this.content.width * currentScale * 0.5;
                if (y === null) y = this.content.height * currentScale * 0.5;
                var _this_getZoomDelta = this.getZoomDelta(scale, x, y), deltaX = _this_getZoomDelta.deltaX, deltaY = _this_getZoomDelta.deltaY;
                x = this.content.x - deltaX;
                y = this.content.y - deltaY;
                this.panTo({
                    x: x,
                    y: y,
                    scale: scale,
                    friction: this.option("zoomFriction")
                });
            }
        },
        {
            /**
   * Calculate difference for top/left values if content would scale at given coordinates
   * @param {Number} scale
   * @param {Number} x
   * @param {Number} y
   * @returns {Object}
   */ key: "getZoomDelta",
            value: function getZoomDelta(scale) {
                var x = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, y = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                var currentWidth = this.content.fitWidth * this.content.scale;
                var currentHeight = this.content.fitHeight * this.content.scale;
                var percentXInCurrentBox = x > 0 && currentWidth ? x / currentWidth : 0;
                var percentYInCurrentBox = y > 0 && currentHeight ? y / currentHeight : 0;
                var nextWidth = this.content.fitWidth * scale;
                var nextHeight = this.content.fitHeight * scale;
                var deltaX = (nextWidth - currentWidth) * percentXInCurrentBox;
                var deltaY = (nextHeight - currentHeight) * percentYInCurrentBox;
                return {
                    deltaX: deltaX,
                    deltaY: deltaY
                };
            }
        },
        {
            /**
   * Animate to given positon and/or zoom level
   * @param {Object} [options] Additional options
   */ key: "panTo",
            value: function panTo() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_x = _ref.x, x = _ref_x === void 0 ? this.content.x : _ref_x, _ref_y = _ref.y, y = _ref_y === void 0 ? this.content.y : _ref_y, scale = _ref.scale, _ref_friction = _ref.friction, friction = _ref_friction === void 0 ? this.option("friction") : _ref_friction, _ref_ignoreBounds = _ref.ignoreBounds, ignoreBounds = _ref_ignoreBounds === void 0 ? false : _ref_ignoreBounds;
                scale = scale || this.content.scale || 1;
                if (!ignoreBounds) {
                    var _this_getBounds = this.getBounds(scale), boundX = _this_getBounds.boundX, boundY = _this_getBounds.boundY;
                    if (boundX) x = Math.max(Math.min(x, boundX.to), boundX.from);
                    if (boundY) y = Math.max(Math.min(y, boundY.to), boundY.from);
                }
                this.friction = friction;
                this.transform = (0, $f077b226522f8b2c$export$71511d61b312f219)((0, $2c2de140d7828cca$export$71511d61b312f219)({}, this.transform), {
                    x: x,
                    y: y,
                    scale: scale
                });
                if (friction) {
                    this.state = "panning";
                    this.velocity = {
                        x: (1 / this.friction - 1) * (x - this.content.x),
                        y: (1 / this.friction - 1) * (y - this.content.y),
                        scale: (1 / this.friction - 1) * (scale - this.content.scale)
                    };
                    this.startAnimation();
                } else this.endAnimation();
            }
        },
        {
            /**
   * Start animation loop
   */ key: "startAnimation",
            value: function startAnimation() {
                var _this = this;
                if (!this.rAF) this.trigger("startAnimation");
                else cancelAnimationFrame(this.rAF);
                this.rAF = requestAnimationFrame(function() {
                    return _this.animate();
                });
            }
        },
        {
            /**
   * Process animation frame
   */ key: "animate",
            value: function animate() {
                var _this = this;
                this.setEdgeForce();
                this.setDragForce();
                this.velocity.x *= this.friction;
                this.velocity.y *= this.friction;
                this.velocity.scale *= this.friction;
                this.content.x += this.velocity.x;
                this.content.y += this.velocity.y;
                this.content.scale += this.velocity.scale;
                if (this.isAnimating()) this.setTransform();
                else if (this.state !== "pointerdown") {
                    this.endAnimation();
                    return;
                }
                this.rAF = requestAnimationFrame(function() {
                    return _this.animate();
                });
            }
        },
        {
            /**
   * Calculate boundaries
   */ key: "getBounds",
            value: function getBounds(scale) {
                var boundX = this.boundX;
                var boundY = this.boundY;
                if (boundX !== undefined && boundY !== undefined) return {
                    boundX: boundX,
                    boundY: boundY
                };
                boundX = {
                    from: 0,
                    to: 0
                };
                boundY = {
                    from: 0,
                    to: 0
                };
                scale = scale || this.transform.scale;
                var width = this.content.fitWidth * scale;
                var height = this.content.fitHeight * scale;
                var viewportWidth = this.viewport.width;
                var viewportHeight = this.viewport.height;
                if (width < viewportWidth) {
                    var deltaX = (0, $589b315cfb953e4c$export$2077e0241d6afd3c)((viewportWidth - width) * 0.5);
                    boundX.from = deltaX;
                    boundX.to = deltaX;
                } else boundX.from = (0, $589b315cfb953e4c$export$2077e0241d6afd3c)(viewportWidth - width);
                if (height < viewportHeight) {
                    var deltaY = (viewportHeight - height) * 0.5;
                    boundY.from = deltaY;
                    boundY.to = deltaY;
                } else boundY.from = (0, $589b315cfb953e4c$export$2077e0241d6afd3c)(viewportHeight - height);
                return {
                    boundX: boundX,
                    boundY: boundY
                };
            }
        },
        {
            /**
   * Change animation velocity if boundary is reached
   */ key: "setEdgeForce",
            value: function setEdgeForce() {
                if (this.state !== "decel") return;
                var bounceForce = this.option("bounceForce");
                var _this_getBounds = this.getBounds(Math.max(this.transform.scale, this.content.scale)), boundX = _this_getBounds.boundX, boundY = _this_getBounds.boundY;
                var pastLeft, pastRight, pastTop, pastBottom;
                if (boundX) {
                    pastLeft = this.content.x < boundX.from;
                    pastRight = this.content.x > boundX.to;
                }
                if (boundY) {
                    pastTop = this.content.y < boundY.from;
                    pastBottom = this.content.y > boundY.to;
                }
                if (pastLeft || pastRight) {
                    var bound = pastLeft ? boundX.from : boundX.to;
                    var distance = bound - this.content.x;
                    var force = distance * bounceForce;
                    var restX = this.content.x + (this.velocity.x + force) / this.friction;
                    if (restX >= boundX.from && restX <= boundX.to) force += this.velocity.x;
                    this.velocity.x = force;
                    this.recalculateTransform();
                }
                if (pastTop || pastBottom) {
                    var bound1 = pastTop ? boundY.from : boundY.to;
                    var distance1 = bound1 - this.content.y;
                    var force1 = distance1 * bounceForce;
                    var restY = this.content.y + (force1 + this.velocity.y) / this.friction;
                    if (restY >= boundY.from && restY <= boundY.to) force1 += this.velocity.y;
                    this.velocity.y = force1;
                    this.recalculateTransform();
                }
            }
        },
        {
            /**
   * Change dragging position if boundary is reached
   */ key: "setDragResistance",
            value: function setDragResistance() {
                if (this.state !== "pointerdown") return;
                var _this_getBounds = this.getBounds(this.dragPosition.scale), boundX = _this_getBounds.boundX, boundY = _this_getBounds.boundY;
                var pastLeft, pastRight, pastTop, pastBottom;
                if (boundX) {
                    pastLeft = this.dragPosition.x < boundX.from;
                    pastRight = this.dragPosition.x > boundX.to;
                }
                if (boundY) {
                    pastTop = this.dragPosition.y < boundY.from;
                    pastBottom = this.dragPosition.y > boundY.to;
                }
                if ((pastLeft || pastRight) && !(pastLeft && pastRight)) {
                    var bound = pastLeft ? boundX.from : boundX.to;
                    var distance = bound - this.dragPosition.x;
                    this.dragPosition.x = bound - distance * 0.3;
                }
                if ((pastTop || pastBottom) && !(pastTop && pastBottom)) {
                    var bound1 = pastTop ? boundY.from : boundY.to;
                    var distance1 = bound1 - this.dragPosition.y;
                    this.dragPosition.y = bound1 - distance1 * 0.3;
                }
            }
        },
        {
            /**
   * Set velocity to move content to drag position
   */ key: "setDragForce",
            value: function setDragForce() {
                if (this.state === "pointerdown") {
                    this.velocity.x = this.dragPosition.x - this.content.x;
                    this.velocity.y = this.dragPosition.y - this.content.y;
                    this.velocity.scale = this.dragPosition.scale - this.content.scale;
                }
            }
        },
        {
            /**
   * Update end values based on current velocity and friction;
   */ key: "recalculateTransform",
            value: function recalculateTransform() {
                this.transform.x = this.content.x + this.velocity.x / (1 / this.friction - 1);
                this.transform.y = this.content.y + this.velocity.y / (1 / this.friction - 1);
                this.transform.scale = this.content.scale + this.velocity.scale / (1 / this.friction - 1);
            }
        },
        {
            /**
   * Check if content is currently animating
   * @returns {Boolean}
   */ key: "isAnimating",
            value: function isAnimating() {
                return !!(this.friction && (Math.abs(this.velocity.x) > 0.05 || Math.abs(this.velocity.y) > 0.05 || Math.abs(this.velocity.scale) > 0.05));
            }
        },
        {
            /**
   * Set content `style.transform` value based on current animation frame
   */ key: "setTransform",
            value: function setTransform(final) {
                var x, y, scale;
                if (final) {
                    x = (0, $589b315cfb953e4c$export$2077e0241d6afd3c)(this.transform.x);
                    y = (0, $589b315cfb953e4c$export$2077e0241d6afd3c)(this.transform.y);
                    scale = this.transform.scale;
                    this.content = (0, $f077b226522f8b2c$export$71511d61b312f219)((0, $2c2de140d7828cca$export$71511d61b312f219)({}, this.content), {
                        x: x,
                        y: y,
                        scale: scale
                    });
                } else {
                    x = (0, $589b315cfb953e4c$export$2077e0241d6afd3c)(this.content.x);
                    y = (0, $589b315cfb953e4c$export$2077e0241d6afd3c)(this.content.y);
                    scale = this.content.scale / (this.content.width / this.content.fitWidth);
                    this.content = (0, $f077b226522f8b2c$export$71511d61b312f219)((0, $2c2de140d7828cca$export$71511d61b312f219)({}, this.content), {
                        x: x,
                        y: y
                    });
                }
                this.trigger("beforeTransform");
                x = (0, $589b315cfb953e4c$export$2077e0241d6afd3c)(this.content.x);
                y = (0, $589b315cfb953e4c$export$2077e0241d6afd3c)(this.content.y);
                if (final && this.option("zoom")) {
                    var width;
                    var height;
                    width = (0, $589b315cfb953e4c$export$2077e0241d6afd3c)(this.content.fitWidth * scale);
                    height = (0, $589b315cfb953e4c$export$2077e0241d6afd3c)(this.content.fitHeight * scale);
                    this.content.width = width;
                    this.content.height = height;
                    this.transform = (0, $f077b226522f8b2c$export$71511d61b312f219)((0, $2c2de140d7828cca$export$71511d61b312f219)({}, this.transform), {
                        width: width,
                        height: height,
                        scale: scale
                    });
                    Object.assign(this.$content.style, {
                        width: "".concat(width, "px"),
                        height: "".concat(height, "px"),
                        maxWidth: "none",
                        maxHeight: "none",
                        transform: "translate3d(".concat(x, "px, ").concat(y, "px, 0) scale(1)")
                    });
                } else this.$content.style.transform = "translate3d(".concat(x, "px, ").concat(y, "px, 0) scale(").concat(scale, ")");
                this.trigger("afterTransform");
            }
        },
        {
            /**
   * Stop animation loop
   */ key: "endAnimation",
            value: function endAnimation(silently) {
                cancelAnimationFrame(this.rAF);
                this.rAF = null;
                this.velocity = {
                    x: 0,
                    y: 0,
                    scale: 0
                };
                this.setTransform(true);
                this.state = "ready";
                this.handleCursor();
                if (silently !== true) this.trigger("endAnimation");
            }
        },
        {
            /**
   * Update the class name depending on whether the content is scaled
   */ key: "handleCursor",
            value: function handleCursor() {
                var draggableClass = this.option("draggableClass");
                if (!draggableClass || !this.option("touch")) return;
                if (this.option("panOnlyZoomed") == true && this.content.width <= this.viewport.width && this.content.height <= this.viewport.height && this.transform.scale <= this.option("baseScale")) this.$container.classList.remove(draggableClass);
                else this.$container.classList.add(draggableClass);
            }
        },
        {
            /**
   * Remove observation and detach event listeners
   */ key: "detachEvents",
            value: function detachEvents() {
                this.$content.removeEventListener("load", this.onLoad);
                this.$container.removeEventListener("wheel", this.onWheel, {
                    passive: false
                });
                this.$container.removeEventListener("click", this.onClick, {
                    passive: false
                });
                if (this.pointerTracker) {
                    this.pointerTracker.stop();
                    this.pointerTracker = null;
                }
                if (this.resizeObserver) {
                    this.resizeObserver.disconnect();
                    this.resizeObserver = null;
                }
            }
        },
        {
            /**
   * Clean up
   */ key: "destroy",
            value: function destroy() {
                if (this.state === "destroy") return;
                this.state = "destroy";
                clearTimeout(this.updateTimer);
                this.updateTimer = null;
                cancelAnimationFrame(this.rAF);
                this.rAF = null;
                this.detachEvents();
                this.detachPlugins();
                this.resetDragPosition();
            }
        }
    ]);
    return Panzoom;
}((0, $633001db0e20238e$export$ef88aa0d34c34520));
// Expose version
$9707d077d55fad71$export$b704d075ddd20210.version = "__VERSION__";
// Static properties are a recent addition that dont work in all browsers yet
$9707d077d55fad71$export$b704d075ddd20210.Plugins = (0, $ad7b922a9ea61c9f$export$c203ca0aafe4939a);




/**
 * Throttling enforces a maximum number of times a function can be called over time
 * @param {Function} func Callback function
 * @param {Integer} limit Milliseconds
 * @returns {Function}
 */ 
var $cd87ca5ae25fb62a$export$de363e709c412c8a = function(func, limit) {
    var lastCall = 0;
    return function throttle() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var now = new Date().getTime();
        if (now - lastCall < limit) return;
        lastCall = now;
        return func.apply(void 0, (0, $b6a26340ba3e8c80$export$71511d61b312f219)(args));
    };
};





var $0b700c0bcb375c63$var$defaults = {
    prevTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M15 3l-9 9 9 9"/></svg>',
    nextTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M9 3l9 9-9 9"/></svg>',
    classNames: {
        main: "carousel__nav",
        button: "carousel__button",
        next: "is-next",
        prev: "is-prev"
    }
};
var $0b700c0bcb375c63$export$b8a61e5c71402559 = /*#__PURE__*/ function() {
    "use strict";
    function Navigation(carousel) {
        (0, $748c5547edb8a18d$export$71511d61b312f219)(this, Navigation);
        this.$container = null;
        this.$prev = null;
        this.$next = null;
        this.carousel = carousel;
        this.onRefresh = this.onRefresh.bind(this);
    }
    (0, $c95e6614e27503ea$export$71511d61b312f219)(Navigation, [
        {
            /**
   * Shortcut to get option for this plugin
   * @param {String} name option name
   * @returns option value
   */ key: "option",
            value: function option(name) {
                return this.carousel.option("Navigation.".concat(name));
            }
        },
        {
            /**
   * Creates and returns new button element with default class names and click event
   * @param {String} type
   */ key: "createButton",
            value: function createButton(type) {
                var _this = this;
                var _$btn_classList;
                var $btn = document.createElement("button");
                $btn.setAttribute("title", this.carousel.localize("{{".concat(type.toUpperCase(), "}}")));
                var classNames = this.option("classNames.button") + " " + this.option("classNames.".concat(type));
                (_$btn_classList = $btn.classList).add.apply(_$btn_classList, (0, $b6a26340ba3e8c80$export$71511d61b312f219)(classNames.split(" ")));
                $btn.setAttribute("tabindex", "0");
                $btn.innerHTML = this.carousel.localize(this.option("".concat(type, "Tpl")));
                $btn.addEventListener("click", function(event) {
                    event.preventDefault();
                    event.stopPropagation();
                    _this.carousel["slide".concat(type === "next" ? "Next" : "Prev")]();
                });
                return $btn;
            }
        },
        {
            /**
   * Build necessary DOM elements
   */ key: "build",
            value: function build() {
                if (!this.$container) {
                    var _this_$container_classList;
                    this.$container = document.createElement("div");
                    (_this_$container_classList = this.$container.classList).add.apply(_this_$container_classList, (0, $b6a26340ba3e8c80$export$71511d61b312f219)(this.option("classNames.main").split(" ")));
                    this.carousel.$container.appendChild(this.$container);
                }
                if (!this.$next) {
                    this.$next = this.createButton("next");
                    this.$container.appendChild(this.$next);
                }
                if (!this.$prev) {
                    this.$prev = this.createButton("prev");
                    this.$container.appendChild(this.$prev);
                }
            }
        },
        {
            /**
   *  Process carousel `refresh` and `change` events to enable/disable buttons if needed
   */ key: "onRefresh",
            value: function onRefresh() {
                var pageCount = this.carousel.pages.length;
                if (pageCount <= 1 || pageCount > 1 && this.carousel.elemDimWidth < this.carousel.wrapDimWidth && !Number.isInteger(this.carousel.option("slidesPerPage"))) {
                    this.cleanup();
                    return;
                }
                this.build();
                this.$prev.removeAttribute("disabled");
                this.$next.removeAttribute("disabled");
                if (this.carousel.option("infiniteX", this.carousel.option("infinite"))) return;
                if (this.carousel.page <= 0) this.$prev.setAttribute("disabled", "");
                if (this.carousel.page >= pageCount - 1) this.$next.setAttribute("disabled", "");
            }
        },
        {
            key: "cleanup",
            value: function cleanup() {
                if (this.$prev) this.$prev.remove();
                this.$prev = null;
                if (this.$next) this.$next.remove();
                this.$next = null;
                if (this.$container) this.$container.remove();
                this.$container = null;
            }
        },
        {
            key: "attach",
            value: function attach() {
                this.carousel.on("refresh change", this.onRefresh);
            }
        },
        {
            key: "detach",
            value: function detach() {
                this.carousel.off("refresh change", this.onRefresh);
                this.cleanup();
            }
        }
    ]);
    return Navigation;
}();
// Expose defaults
$0b700c0bcb375c63$export$b8a61e5c71402559.defaults = $0b700c0bcb375c63$var$defaults;




var $dc0389f73b4c7cd3$var$defaults = {
    // The minimum number of slides to display dots
    minSlideCount: 2
};
var $dc0389f73b4c7cd3$export$8da50d3722682be0 = /*#__PURE__*/ function() {
    "use strict";
    function Dots(carousel) {
        (0, $748c5547edb8a18d$export$71511d61b312f219)(this, Dots);
        this.carousel = carousel;
        this.$list = null;
        this.events = {
            change: this.onChange.bind(this),
            refresh: this.onRefresh.bind(this)
        };
    }
    (0, $c95e6614e27503ea$export$71511d61b312f219)(Dots, [
        {
            /**
   * Build wrapping DOM element containing all dots
   */ key: "buildList",
            value: function buildList() {
                var _this = this;
                if (this.carousel.pages.length < this.carousel.option("Dots.minSlideCount")) return;
                var $list = document.createElement("ol");
                $list.classList.add("carousel__dots");
                $list.addEventListener("click", function(e) {
                    if (!("page" in e.target.dataset)) return;
                    e.preventDefault();
                    e.stopPropagation();
                    var page = parseInt(e.target.dataset.page, 10);
                    var carousel = _this.carousel;
                    if (page === carousel.page) return;
                    if (carousel.pages.length < 3 && carousel.option("infinite")) carousel[page == 0 ? "slidePrev" : "slideNext"]();
                    else carousel.slideTo(page);
                });
                this.$list = $list;
                this.carousel.$container.appendChild($list);
                this.carousel.$container.classList.add("has-dots");
                return $list;
            }
        },
        {
            /**
   * Remove wrapping DOM element
   */ key: "removeList",
            value: function removeList() {
                if (this.$list) {
                    this.$list.parentNode.removeChild(this.$list);
                    this.$list = null;
                }
                this.carousel.$container.classList.remove("has-dots");
            }
        },
        {
            /**
   * Remove existing dots and create fresh ones
   */ key: "rebuildDots",
            value: function rebuildDots() {
                var _this, _loop = function(index) {
                    var $dot = document.createElement("li");
                    $dot.classList.add("carousel__dot");
                    $dot.dataset.page = index;
                    $dot.setAttribute("role", "button");
                    $dot.setAttribute("tabindex", "0");
                    $dot.setAttribute("title", _this.carousel.localize("{{GOTO}}", [
                        [
                            "%d",
                            index + 1
                        ]
                    ]));
                    $dot.addEventListener("keydown", function(event) {
                        var code = event.code;
                        var $el;
                        if (code === "Enter" || code === "NumpadEnter") $el = $dot;
                        else if (code === "ArrowRight") $el = $dot.nextSibling;
                        else if (code === "ArrowLeft") $el = $dot.previousSibling;
                        $el && $el.click();
                    });
                    _this.$list.appendChild($dot);
                };
                var $list = this.$list;
                var listExists = !!$list;
                var pagesCount = this.carousel.pages.length;
                if (pagesCount < 2) {
                    if (listExists) this.removeList();
                    return;
                }
                if (!listExists) $list = this.buildList();
                // Remove existing dots
                var dotCount = this.$list.children.length;
                if (dotCount > pagesCount) {
                    for(var i = pagesCount; i < dotCount; i++)this.$list.removeChild(this.$list.lastChild);
                    return;
                }
                // Create fresh DOM elements (dots) for each page
                for(var index = dotCount; index < pagesCount; index++)_this = this, _loop(index);
                this.setActiveDot();
            }
        },
        {
            /**
   * Mark active dot by toggling class name
   */ key: "setActiveDot",
            value: function setActiveDot() {
                if (!this.$list) return;
                this.$list.childNodes.forEach(function($dot) {
                    $dot.classList.remove("is-selected");
                });
                var $activeDot = this.$list.childNodes[this.carousel.page];
                if ($activeDot) $activeDot.classList.add("is-selected");
            }
        },
        {
            /**
   * Process carousel `change` event
   */ key: "onChange",
            value: function onChange() {
                this.setActiveDot();
            }
        },
        {
            /**
   * Process carousel `refresh` event
   */ key: "onRefresh",
            value: function onRefresh() {
                this.rebuildDots();
            }
        },
        {
            key: "attach",
            value: function attach() {
                this.carousel.on(this.events);
            }
        },
        {
            key: "detach",
            value: function detach() {
                this.removeList();
                this.carousel.off(this.events);
                this.carousel = null;
            }
        }
    ]);
    return Dots;
}();





var $0a215badadabff3b$var$defaults = {
    friction: 0.92
};
var $0a215badadabff3b$export$2ae15352e0a80063 = /*#__PURE__*/ function() {
    "use strict";
    function Sync(carousel) {
        (0, $748c5547edb8a18d$export$71511d61b312f219)(this, Sync);
        this.carousel = carousel;
        this.selectedIndex = null;
        this.friction = 0;
        this.onNavReady = this.onNavReady.bind(this);
        this.onNavClick = this.onNavClick.bind(this);
        this.onNavCreateSlide = this.onNavCreateSlide.bind(this);
        this.onTargetChange = this.onTargetChange.bind(this);
    }
    (0, $c95e6614e27503ea$export$71511d61b312f219)(Sync, [
        {
            /**
   * Make this one as main carousel and selected carousel as navigation
   * @param {Object} nav Carousel
   */ key: "addAsTargetFor",
            value: function addAsTargetFor(nav) {
                this.target = this.carousel;
                this.nav = nav;
                this.attachEvents();
            }
        },
        {
            /**
   * Make this one as navigation carousel for selected carousel
   * @param {Object} target
   */ key: "addAsNavFor",
            value: function addAsNavFor(target) {
                this.target = target;
                this.nav = this.carousel;
                this.attachEvents();
            }
        },
        {
            /**
   * Attach event listeners on both carousels
   */ key: "attachEvents",
            value: function attachEvents() {
                this.nav.options.initialSlide = this.target.options.initialPage;
                this.nav.on("ready", this.onNavReady);
                this.nav.on("createSlide", this.onNavCreateSlide);
                this.nav.on("Panzoom.click", this.onNavClick);
                this.target.on("change", this.onTargetChange);
                this.target.on("Panzoom.afterUpdate", this.onTargetChange);
            }
        },
        {
            /**
   * Process main carousel `ready` event; bind events and set initial page
   */ key: "onNavReady",
            value: function onNavReady() {
                this.onTargetChange(true);
            }
        },
        {
            /**
   * Process main carousel `click` event
   * @param {Object} panzoom
   * @param {Object} event
   */ key: "onNavClick",
            value: function onNavClick(carousel, panzoom, event) {
                var clickedNavSlide = event.target.closest(".carousel__slide");
                if (!clickedNavSlide) return;
                event.stopPropagation();
                var selectedNavIndex = parseInt(clickedNavSlide.dataset.index, 10);
                var selectedSyncPage = this.target.findPageForSlide(selectedNavIndex);
                if (this.target.page !== selectedSyncPage) this.target.slideTo(selectedSyncPage, {
                    friction: this.friction
                });
                this.markSelectedSlide(selectedNavIndex);
            }
        },
        {
            /**
   * Process main carousel `createSlide` event
   * @param {Object} carousel
   * @param {Object} slide
   */ key: "onNavCreateSlide",
            value: function onNavCreateSlide(carousel, slide) {
                if (slide.index === this.selectedIndex) this.markSelectedSlide(slide.index);
            }
        },
        {
            /**
   * Process target carousel `change` event
   * @param {Object} target
   */ key: "onTargetChange",
            value: function onTargetChange() {
                var targetIndex = this.target.pages[this.target.page].indexes[0];
                var selectedNavPage = this.nav.findPageForSlide(targetIndex);
                this.nav.slideTo(selectedNavPage);
                this.markSelectedSlide(targetIndex);
            }
        },
        {
            /**
   * Toggle classname for slides that marks currently selected slides
   * @param {Number} selectedIndex
   */ key: "markSelectedSlide",
            value: function markSelectedSlide(selectedIndex) {
                this.selectedIndex = selectedIndex;
                (0, $b6a26340ba3e8c80$export$71511d61b312f219)(this.nav.slides).filter(function(slide) {
                    return slide.$el && slide.$el.classList.remove("is-nav-selected");
                });
                var slide = this.nav.slides[selectedIndex];
                if (slide && slide.$el) slide.$el.classList.add("is-nav-selected");
            }
        },
        {
            key: "attach",
            value: function attach(carousel) {
                var sync = carousel.options.Sync;
                if (!sync.target && !sync.nav) return;
                if (sync.target) this.addAsNavFor(sync.target);
                else if (sync.nav) this.addAsTargetFor(sync.nav);
                this.friction = sync.friction;
            }
        },
        {
            key: "detach",
            value: function detach() {
                if (this.nav) {
                    this.nav.off("ready", this.onNavReady);
                    this.nav.off("Panzoom.click", this.onNavClick);
                    this.nav.off("createSlide", this.onNavCreateSlide);
                }
                if (this.target) {
                    this.target.off("Panzoom.afterUpdate", this.onTargetChange);
                    this.target.off("change", this.onTargetChange);
                }
            }
        }
    ]);
    return Sync;
}();
// Expose defaults
$0a215badadabff3b$export$2ae15352e0a80063.defaults = $0a215badadabff3b$var$defaults;


var $6416c7d79f195c83$export$c203ca0aafe4939a = {
    Navigation: (0, $0b700c0bcb375c63$export$b8a61e5c71402559),
    Dots: (0, $dc0389f73b4c7cd3$export$8da50d3722682be0),
    Sync: (0, $0a215badadabff3b$export$2ae15352e0a80063)
};


var $abe5c6b2c70a8f1a$export$2e2bcd8739ae039 = {
    NEXT: "Next slide",
    PREV: "Previous slide",
    GOTO: "Go to slide #%d"
};


var $ddbfb93057510fe5$var$defaults = {
    // Virtual slides. Each object should have at least `html` property that will be used to set content,
    // example: `slides: [{html: 'First slide'}, {html: 'Second slide'}]`
    slides: [],
    // Number of slides to preload before/after visible slides
    preload: 0,
    // Number of slides to group into the page,
    // if `auto` - group all slides that fit into the viewport
    slidesPerPage: "auto",
    // Index of initial page
    initialPage: null,
    // Index of initial slide
    initialSlide: null,
    // Panzoom friction while changing page
    friction: 0.92,
    // Should center active page
    center: true,
    // Should carousel scroll infinitely
    infinite: true,
    // Should the gap be filled before first and after last slide if `infinite: false`
    fill: true,
    // Should Carousel settle at any position after a swipe.
    dragFree: false,
    // Prefix for CSS classes, must be the same as the  SCSS `$carousel-prefix` variable
    prefix: "",
    // Class names for DOM elements (without prefix)
    classNames: {
        viewport: "carousel__viewport",
        track: "carousel__track",
        slide: "carousel__slide",
        // Classname toggled for slides inside current page
        slideSelected: "is-selected"
    },
    // Localization of strings
    l10n: (0, $abe5c6b2c70a8f1a$export$2e2bcd8739ae039)
};
var $ddbfb93057510fe5$export$144901db2ea8e967 = /*#__PURE__*/ function(Base) {
    "use strict";
    (0, $1e7277e0f02f2550$export$71511d61b312f219)(Carousel, Base);
    function Carousel($container) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $748c5547edb8a18d$export$71511d61b312f219)(this, Carousel);
        var _this;
        options = (0, $473ff96f0aaf0a3a$export$8b58be045bf06082)(true, {}, $ddbfb93057510fe5$var$defaults, options);
        _this = (0, $c1745da3357c8fcc$export$71511d61b312f219)(this, Carousel, [
            options
        ]);
        _this.state = "init";
        _this.$container = $container;
        if (!(_this.$container instanceof HTMLElement)) throw new Error("No root element provided");
        _this.slideNext = (0, $cd87ca5ae25fb62a$export$de363e709c412c8a)(_this.slideNext.bind(_this), 250, true);
        _this.slidePrev = (0, $cd87ca5ae25fb62a$export$de363e709c412c8a)(_this.slidePrev.bind(_this), 250, true);
        _this.init();
        $container.__Carousel = _this;
        return _this;
    }
    (0, $c95e6614e27503ea$export$71511d61b312f219)(Carousel, [
        {
            /**
   * Perform initialization
   */ key: "init",
            value: function init() {
                this.pages = [];
                this.page = this.pageIndex = null;
                this.prevPage = this.prevPageIndex = null;
                this.attachPlugins(Carousel.Plugins);
                this.trigger("init");
                this.initLayout();
                this.initSlides();
                this.updateMetrics();
                if (this.$track && this.pages.length) this.$track.style.transform = "translate3d(".concat(this.pages[this.page].left * -1, "px, 0px, 0) scale(1)");
                this.manageSlideVisiblity();
                this.initPanzoom();
                this.state = "ready";
                this.trigger("ready");
            }
        },
        {
            /**
   * Initialize layout; create necessary elements
   */ key: "initLayout",
            value: function initLayout() {
                var prefix = this.option("prefix");
                var classNames = this.option("classNames");
                this.$viewport = this.option("viewport") || this.$container.querySelector(".".concat(prefix).concat(classNames.viewport));
                if (!this.$viewport) {
                    var _this_$viewport_classList, _this_$viewport;
                    this.$viewport = document.createElement("div");
                    (_this_$viewport_classList = this.$viewport.classList).add.apply(_this_$viewport_classList, (0, $b6a26340ba3e8c80$export$71511d61b312f219)((prefix + classNames.viewport).split(" ")));
                    (_this_$viewport = this.$viewport).append.apply(_this_$viewport, (0, $b6a26340ba3e8c80$export$71511d61b312f219)(this.$container.childNodes));
                    this.$container.appendChild(this.$viewport);
                }
                this.$track = this.option("track") || this.$container.querySelector(".".concat(prefix).concat(classNames.track));
                if (!this.$track) {
                    var _this_$track_classList, _this_$track;
                    this.$track = document.createElement("div");
                    (_this_$track_classList = this.$track.classList).add.apply(_this_$track_classList, (0, $b6a26340ba3e8c80$export$71511d61b312f219)((prefix + classNames.track).split(" ")));
                    (_this_$track = this.$track).append.apply(_this_$track, (0, $b6a26340ba3e8c80$export$71511d61b312f219)(this.$viewport.childNodes));
                    this.$viewport.appendChild(this.$track);
                }
            }
        },
        {
            /**
   * Fill `slides` array with objects from existing nodes and/or `slides` option
   */ key: "initSlides",
            value: function initSlides() {
                var _this = this;
                this.slides = [];
                // Get existing slides from the DOM
                var elems = this.$viewport.querySelectorAll(".".concat(this.option("prefix")).concat(this.option("classNames.slide")));
                elems.forEach(function(el) {
                    var slide = {
                        $el: el,
                        isDom: true
                    };
                    _this.slides.push(slide);
                    _this.trigger("createSlide", slide, _this.slides.length);
                });
                // Add virtual slides, but do not create DOM elements yet,
                // because they will be created dynamically based on current carousel position
                if (Array.isArray(this.options.slides)) this.slides = (0, $473ff96f0aaf0a3a$export$8b58be045bf06082)(true, (0, $b6a26340ba3e8c80$export$71511d61b312f219)(this.slides), this.options.slides);
            }
        },
        {
            /**
   * Do all calculations related to slide size and paging
   */ key: "updateMetrics",
            value: function updateMetrics() {
                var _this = this;
                // Calculate content width, viewport width
                // ===
                var contentWidth = 0;
                var indexes = [];
                var lastSlideWidth;
                this.slides.forEach(function(slide, index) {
                    var $el = slide.$el;
                    var slideWidth = slide.isDom || !lastSlideWidth ? _this.getSlideMetrics($el) : lastSlideWidth;
                    slide.index = index;
                    slide.width = slideWidth;
                    slide.left = contentWidth;
                    lastSlideWidth = slideWidth;
                    contentWidth += slideWidth;
                    indexes.push(index);
                });
                var viewportWidth = Math.max(this.$track.offsetWidth, (0, $589b315cfb953e4c$export$2077e0241d6afd3c)(this.$track.getBoundingClientRect().width));
                var viewportStyles = getComputedStyle(this.$track);
                viewportWidth = viewportWidth - (parseFloat(viewportStyles.paddingLeft) + parseFloat(viewportStyles.paddingRight));
                this.contentWidth = contentWidth;
                this.viewportWidth = viewportWidth;
                // Split slides into pages
                // ===
                var pages = [];
                var slidesPerPage = this.option("slidesPerPage");
                if (Number.isInteger(slidesPerPage) && contentWidth > viewportWidth) // Fixed number of slides in the page
                for(var i = 0; i < this.slides.length; i += slidesPerPage)pages.push({
                    indexes: indexes.slice(i, i + slidesPerPage),
                    slides: this.slides.slice(i, i + slidesPerPage)
                });
                else {
                    // Slides that fit inside viewport
                    var currentPage = 0;
                    var currentWidth = 0;
                    for(var i1 = 0; i1 < this.slides.length; i1 += 1){
                        var slide = this.slides[i1];
                        // Add next page
                        if (!pages.length || currentWidth + slide.width > viewportWidth) {
                            pages.push({
                                indexes: [],
                                slides: []
                            });
                            currentPage = pages.length - 1;
                            currentWidth = 0;
                        }
                        currentWidth += slide.width;
                        pages[currentPage].indexes.push(i1);
                        pages[currentPage].slides.push(slide);
                    }
                }
                var shouldCenter = this.option("center");
                var shouldFill = this.option("fill");
                // Calculate width and start position for each page
                // ===
                pages.forEach(function(page, index) {
                    page.index = index;
                    page.width = page.slides.reduce(function(sum, slide) {
                        return sum + slide.width;
                    }, 0);
                    page.left = page.slides[0].left;
                    if (shouldCenter) page.left += (viewportWidth - page.width) * -0.5;
                    if (shouldFill && !_this.option("infiniteX", _this.option("infinite")) && contentWidth > viewportWidth) {
                        page.left = Math.max(page.left, 0);
                        page.left = Math.min(page.left, contentWidth - viewportWidth);
                    }
                });
                // Merge pages
                // ===
                var rez = [];
                var prevPage;
                pages.forEach(function(page2) {
                    var page = (0, $2c2de140d7828cca$export$71511d61b312f219)({}, page2);
                    if (prevPage && page.left === prevPage.left) {
                        prevPage.width += page.width;
                        prevPage.slides = (0, $b6a26340ba3e8c80$export$71511d61b312f219)(prevPage.slides).concat((0, $b6a26340ba3e8c80$export$71511d61b312f219)(page.slides));
                        prevPage.indexes = (0, $b6a26340ba3e8c80$export$71511d61b312f219)(prevPage.indexes).concat((0, $b6a26340ba3e8c80$export$71511d61b312f219)(page.indexes));
                    } else {
                        page.index = rez.length;
                        prevPage = page;
                        rez.push(page);
                    }
                });
                this.pages = rez;
                var page = this.page;
                if (page === null) {
                    var initialSlide = this.option("initialSlide");
                    if (initialSlide !== null) page = this.findPageForSlide(initialSlide);
                    else page = parseInt(this.option("initialPage", 0), 10) || 0;
                    if (!rez[page]) page = rez.length && page > rez.length ? rez[rez.length - 1].index : 0;
                    this.page = page;
                    this.pageIndex = page;
                }
                this.updatePanzoom();
                this.trigger("refresh");
            }
        },
        {
            /**
   * Calculate slide element width (including left, right margins)
   * @param {Object} node
   * @returns {Number} Width in px
   */ key: "getSlideMetrics",
            value: function getSlideMetrics(node) {
                if (!node) {
                    var _node_classList, _node_classList1;
                    var firstSlide = this.slides[0];
                    node = document.createElement("div");
                    node.dataset.isTestEl = 1;
                    node.style.visibility = "hidden";
                    (_node_classList = node.classList).add.apply(_node_classList, (0, $b6a26340ba3e8c80$export$71511d61b312f219)((this.option("prefix") + this.option("classNames.slide")).split(" ")));
                    // Assume all slides have the same custom class, if any
                    if (firstSlide.customClass) (_node_classList1 = node.classList).add.apply(_node_classList1, (0, $b6a26340ba3e8c80$export$71511d61b312f219)(firstSlide.customClass.split(" ")));
                    this.$track.prepend(node);
                }
                var width = Math.max(node.offsetWidth, (0, $589b315cfb953e4c$export$2077e0241d6afd3c)(node.getBoundingClientRect().width));
                // Add left/right margin
                var style = node.currentStyle || window.getComputedStyle(node);
                width = width + (parseFloat(style.marginLeft) || 0) + (parseFloat(style.marginRight) || 0);
                if (node.dataset.isTestEl) node.remove();
                return width;
            }
        },
        {
            /**
   *
   * @param {Integer} index Index of the slide
   * @returns {Integer|null} Index of the page if found, or null
   */ key: "findPageForSlide",
            value: function findPageForSlide(index) {
                index = parseInt(index, 10) || 0;
                var page = this.pages.find(function(page) {
                    return page.indexes.indexOf(index) > -1;
                });
                return page ? page.index : null;
            }
        },
        {
            /**
   * Slide to next page, if possible
   */ key: "slideNext",
            value: function slideNext() {
                this.slideTo(this.pageIndex + 1);
            }
        },
        {
            /**
   * Slide to previous page, if possible
   */ key: "slidePrev",
            value: function slidePrev() {
                this.slideTo(this.pageIndex - 1);
            }
        },
        {
            /**
   * Slides carousel to given page
   * @param {Number} page - New index of active page
   * @param {Object} [params] - Additional options
   */ key: "slideTo",
            value: function slideTo(page) {
                var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _params_x = params.x, x = _params_x === void 0 ? this.setPage(page, true) * -1 : _params_x, _params_y = params.y, y = _params_y === void 0 ? 0 : _params_y, _params_friction = params.friction, friction = _params_friction === void 0 ? this.option("friction") : _params_friction;
                if (this.Panzoom.content.x === x && !this.Panzoom.velocity.x && friction) return;
                this.Panzoom.panTo({
                    x: x,
                    y: y,
                    friction: friction,
                    ignoreBounds: true
                });
                if (this.state === "ready" && this.Panzoom.state === "ready") this.trigger("settle");
            }
        },
        {
            /**
   * Initialise main Panzoom instance
   */ key: "initPanzoom",
            value: function initPanzoom() {
                var _this = this;
                var _this1 = this;
                if (this.Panzoom) this.Panzoom.destroy();
                // Create fresh object containing options for Pazoom instance
                var options = (0, $473ff96f0aaf0a3a$export$8b58be045bf06082)(true, {}, {
                    // Track element will be set as Panzoom $content
                    content: this.$track,
                    wrapInner: false,
                    resizeParent: false,
                    // Disable any user interaction
                    zoom: false,
                    click: false,
                    // Right now, only horizontal navigation is supported
                    lockAxis: "x",
                    x: this.pages.length ? this.pages[this.page].left * -1 : 0,
                    centerOnStart: false,
                    // Make `textSelection` option more easy to customize
                    textSelection: function() {
                        return _this.option("textSelection", false);
                    },
                    // Disable dragging if content (e.g. all slides) fits inside viewport
                    panOnlyZoomed: function panOnlyZoomed() {
                        return this.content.width <= this.viewport.width;
                    }
                }, this.option("Panzoom"));
                // Create new Panzoom instance
                this.Panzoom = new (0, $9707d077d55fad71$export$b704d075ddd20210)(this.$container, options);
                this.Panzoom.on({
                    // Bubble events
                    "*": function(name) {
                        for(var _len = arguments.length, details = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                            details[_key - 1] = arguments[_key];
                        }
                        return _this1.trigger.apply(_this1, [
                            "Panzoom.".concat(name)
                        ].concat((0, $b6a26340ba3e8c80$export$71511d61b312f219)(details)));
                    },
                    // The rest of events to be processed
                    afterUpdate: function() {
                        _this.updatePage();
                    },
                    beforeTransform: this.onBeforeTransform.bind(this),
                    touchEnd: this.onTouchEnd.bind(this),
                    endAnimation: function() {
                        _this.trigger("settle");
                    }
                });
                // The contents of the slides may cause the page scroll bar to appear, so the carousel width may change
                // and slides have to be repositioned
                this.updateMetrics();
                this.manageSlideVisiblity();
            }
        },
        {
            key: "updatePanzoom",
            value: function updatePanzoom() {
                if (!this.Panzoom) return;
                this.Panzoom.content = (0, $f077b226522f8b2c$export$71511d61b312f219)((0, $2c2de140d7828cca$export$71511d61b312f219)({}, this.Panzoom.content), {
                    fitWidth: this.contentWidth,
                    origWidth: this.contentWidth,
                    width: this.contentWidth
                });
                if (this.pages.length > 1 && this.option("infiniteX", this.option("infinite"))) this.Panzoom.boundX = null;
                else if (this.pages.length) this.Panzoom.boundX = {
                    from: this.pages[this.pages.length - 1].left * -1,
                    to: this.pages[0].left * -1
                };
                if (this.option("infiniteY", this.option("infinite"))) this.Panzoom.boundY = null;
                else this.Panzoom.boundY = {
                    from: 0,
                    to: 0
                };
                this.Panzoom.handleCursor();
            }
        },
        {
            key: "manageSlideVisiblity",
            value: function manageSlideVisiblity() {
                var _this = this;
                var contentWidth = this.contentWidth;
                var viewportWidth = this.viewportWidth;
                var currentX = this.Panzoom ? this.Panzoom.content.x * -1 : this.pages.length ? this.pages[this.page].left : 0;
                var preload = this.option("preload");
                var infinite = this.option("infiniteX", this.option("infinite"));
                var paddingLeft = parseFloat(getComputedStyle(this.$viewport, null).getPropertyValue("padding-left"));
                var paddingRight = parseFloat(getComputedStyle(this.$viewport, null).getPropertyValue("padding-right"));
                // Check visibility of each slide
                this.slides.forEach(function(slide) {
                    var leftBoundary, rightBoundary;
                    var hasDiff = 0;
                    // #1 - slides in current viewport; this does not include infinite items
                    leftBoundary = currentX - paddingLeft;
                    rightBoundary = currentX + viewportWidth + paddingRight;
                    leftBoundary -= preload * (viewportWidth + paddingLeft + paddingRight);
                    rightBoundary += preload * (viewportWidth + paddingLeft + paddingRight);
                    var insideCurrentInterval = slide.left + slide.width > leftBoundary && slide.left < rightBoundary;
                    // #2 - infinite items inside current viewport; from previous interval
                    leftBoundary = currentX + contentWidth - paddingLeft;
                    rightBoundary = currentX + contentWidth + viewportWidth + paddingRight;
                    // Include slides that have to be preloaded
                    leftBoundary -= preload * (viewportWidth + paddingLeft + paddingRight);
                    var insidePrevInterval = infinite && slide.left + slide.width > leftBoundary && slide.left < rightBoundary;
                    // #2 - infinite items inside current viewport; from next interval
                    leftBoundary = currentX - contentWidth - paddingLeft;
                    rightBoundary = currentX - contentWidth + viewportWidth + paddingRight;
                    // Include slides that have to be preloaded
                    leftBoundary -= preload * (viewportWidth + paddingLeft + paddingRight);
                    var insideNextInterval = infinite && slide.left + slide.width > leftBoundary && slide.left < rightBoundary;
                    // Create virtual slides that should be visible or preloaded, remove others
                    if (insidePrevInterval || insideCurrentInterval || insideNextInterval) {
                        _this.createSlideEl(slide);
                        if (insideCurrentInterval) hasDiff = 0;
                        if (insidePrevInterval) hasDiff = -1;
                        if (insideNextInterval) hasDiff = 1;
                        // Bring preloaded slides back to viewport, if needed
                        if (slide.left + slide.width > currentX && slide.left <= currentX + viewportWidth + paddingRight) hasDiff = 0;
                    } else _this.removeSlideEl(slide);
                    slide.hasDiff = hasDiff;
                });
                // Reposition slides for continuity
                var nextIndex = 0;
                var nextPos = 0;
                this.slides.forEach(function(slide, index) {
                    var updatedX = 0;
                    if (slide.$el) {
                        if (index !== nextIndex || slide.hasDiff) updatedX = nextPos + slide.hasDiff * contentWidth;
                        else nextPos = 0;
                        slide.$el.style.left = Math.abs(updatedX) > 0.1 ? "".concat(nextPos + slide.hasDiff * contentWidth, "px") : "";
                        nextIndex++;
                    } else nextPos += slide.width;
                });
                this.markSelectedSlides();
            }
        },
        {
            /**
   * Creates main DOM element for virtual slides,
   * lazy loads images inside regular slides
   * @param {Object} slide
   */ key: "createSlideEl",
            value: function createSlideEl(slide) {
                var _div_classList, _div_classList1;
                if (!slide) return;
                if (slide.$el) {
                    var curentIndex = slide.$el.dataset.index;
                    if (!curentIndex || parseInt(curentIndex, 10) !== slide.index) {
                        slide.$el.dataset.index = slide.index;
                        // Lazy load images
                        // ===
                        slide.$el.querySelectorAll("[data-lazy-srcset]").forEach(function(node) {
                            node.srcset = node.dataset.lazySrcset;
                        });
                        slide.$el.querySelectorAll("[data-lazy-src]").forEach(function(node) {
                            var lazySrc = node.dataset.lazySrc;
                            if (node instanceof HTMLImageElement) node.src = lazySrc;
                            else node.style.backgroundImage = "url('".concat(lazySrc, "')");
                        });
                        // Lazy load slide background image
                        // ===
                        var lazySrc;
                        if (lazySrc = slide.$el.dataset.lazySrc) slide.$el.style.backgroundImage = "url('".concat(lazySrc, "')");
                        slide.state = "ready";
                    }
                    return;
                }
                var div = document.createElement("div");
                div.dataset.index = slide.index;
                (_div_classList = div.classList).add.apply(_div_classList, (0, $b6a26340ba3e8c80$export$71511d61b312f219)((this.option("prefix") + this.option("classNames.slide")).split(" ")));
                if (slide.customClass) (_div_classList1 = div.classList).add.apply(_div_classList1, (0, $b6a26340ba3e8c80$export$71511d61b312f219)(slide.customClass.split(" ")));
                if (slide.html) div.innerHTML = slide.html;
                var allElelements = [];
                this.slides.forEach(function(slide, index) {
                    if (slide.$el) allElelements.push(index);
                });
                // Find a place in DOM to insert an element
                var goal = slide.index;
                var refSlide = null;
                if (allElelements.length) {
                    var refIndex = allElelements.reduce(function(prev, curr) {
                        return Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev;
                    });
                    refSlide = this.slides[refIndex];
                }
                this.$track.insertBefore(div, refSlide && refSlide.$el ? refSlide.index < slide.index ? refSlide.$el.nextSibling : refSlide.$el : null);
                slide.$el = div;
                this.trigger("createSlide", slide, goal);
                return slide;
            }
        },
        {
            /**
   * Removes main DOM element of given slide
   * @param {Object} slide
   */ key: "removeSlideEl",
            value: function removeSlideEl(slide) {
                if (slide.$el && !slide.isDom) {
                    this.trigger("removeSlide", slide);
                    slide.$el.remove();
                    slide.$el = null;
                }
            }
        },
        {
            /**
   * Toggles selected class name and aria-hidden attribute for slides based on visibility
   */ key: "markSelectedSlides",
            value: function markSelectedSlides() {
                var _this = this;
                var selectedClass = this.option("classNames.slideSelected");
                var attr = "aria-hidden";
                this.slides.forEach(function(slide, index) {
                    var $el = slide.$el;
                    if (!$el) return;
                    var page = _this.pages[_this.page];
                    if (page && page.indexes && page.indexes.indexOf(index) > -1) {
                        if (selectedClass && !$el.classList.contains(selectedClass)) {
                            $el.classList.add(selectedClass);
                            _this.trigger("selectSlide", slide);
                        }
                        $el.removeAttribute(attr);
                    } else {
                        if (selectedClass && $el.classList.contains(selectedClass)) {
                            $el.classList.remove(selectedClass);
                            _this.trigger("unselectSlide", slide);
                        }
                        $el.setAttribute(attr, true);
                    }
                });
            }
        },
        {
            /**
   * Perform all calculations and center current page
   */ key: "updatePage",
            value: function updatePage() {
                this.updateMetrics();
                this.slideTo(this.page, {
                    friction: 0
                });
            }
        },
        {
            /**
   * Process `Panzoom.beforeTransform` event to remove slides moved out of viewport and
   * to create necessary ones
   */ key: "onBeforeTransform",
            value: function onBeforeTransform() {
                if (this.option("infiniteX", this.option("infinite"))) this.manageInfiniteTrack();
                this.manageSlideVisiblity();
            }
        },
        {
            /**
   * Seamlessly flip position of infinite carousel, if needed; this way x position stays low
   */ key: "manageInfiniteTrack",
            value: function manageInfiniteTrack() {
                var contentWidth = this.contentWidth;
                var viewportWidth = this.viewportWidth;
                if (!this.option("infiniteX", this.option("infinite")) || this.pages.length < 2 || contentWidth < viewportWidth) return;
                var panzoom = this.Panzoom;
                var isFlipped = false;
                if (panzoom.content.x < (contentWidth - viewportWidth) * -1) {
                    panzoom.content.x += contentWidth;
                    this.pageIndex = this.pageIndex - this.pages.length;
                    isFlipped = true;
                }
                if (panzoom.content.x > viewportWidth) {
                    panzoom.content.x -= contentWidth;
                    this.pageIndex = this.pageIndex + this.pages.length;
                    isFlipped = true;
                }
                if (isFlipped && panzoom.state === "pointerdown") panzoom.resetDragPosition();
                return isFlipped;
            }
        },
        {
            /**
   * Process `Panzoom.touchEnd` event; slide to next/prev page if needed
   * @param {object} panzoom
   */ key: "onTouchEnd",
            value: function onTouchEnd(panzoom, event) {
                var dragFree = this.option("dragFree");
                // If this is a quick horizontal flick, slide to next/prev slide
                if (!dragFree && this.pages.length > 1 && panzoom.dragOffset.time < 350 && Math.abs(panzoom.dragOffset.y) < 1 && Math.abs(panzoom.dragOffset.x) > 5) {
                    this[panzoom.dragOffset.x < 0 ? "slideNext" : "slidePrev"]();
                    return;
                }
                // Set the slide at the end of the animation as the current one,
                // or slide to closest page
                if (dragFree) {
                    var _this_getPageFromPosition = (0, $1933fb0d7df0f802$export$71511d61b312f219)(this.getPageFromPosition(panzoom.transform.x * -1), 2), nextPageIndex = _this_getPageFromPosition[1];
                    this.setPage(nextPageIndex);
                } else this.slideToClosest();
            }
        },
        {
            /**
   * Slides to the closest page (useful, if carousel is changed manually)
   * @param {Object} [params] - Object containing additional options
   */ key: "slideToClosest",
            value: function slideToClosest() {
                var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this_getPageFromPosition = (0, $1933fb0d7df0f802$export$71511d61b312f219)(this.getPageFromPosition(this.Panzoom.content.x * -1), 2), nextPageIndex = _this_getPageFromPosition[1];
                this.slideTo(nextPageIndex, params);
            }
        },
        {
            /**
   * Returns index of closest page to given x position
   * @param {Number} xPos
   */ key: "getPageFromPosition",
            value: function getPageFromPosition(xPos) {
                var pageCount = this.pages.length;
                var center = this.option("center");
                if (center) xPos += this.viewportWidth * 0.5;
                var interval = Math.floor(xPos / this.contentWidth);
                xPos -= interval * this.contentWidth;
                var slide = this.slides.find(function(slide) {
                    return slide.left <= xPos && slide.left + slide.width > xPos;
                });
                if (slide) {
                    var pageIndex = this.findPageForSlide(slide.index);
                    return [
                        pageIndex,
                        pageIndex + interval * pageCount
                    ];
                }
                return [
                    0,
                    0
                ];
            }
        },
        {
            /**
   * Changes active page
   * @param {Number} page - New index of active page
   * @param {Boolean} toClosest - to closest page based on scroll distance (for infinite navigation)
   */ key: "setPage",
            value: function setPage(page, toClosest) {
                var nextPosition = 0;
                var pageIndex = parseInt(page, 10) || 0;
                var prevPage = this.page, prevPageIndex = this.pageIndex, pageCount = this.pages.length;
                var contentWidth = this.contentWidth;
                var viewportWidth = this.viewportWidth;
                page = (pageIndex % pageCount + pageCount) % pageCount;
                if (this.option("infiniteX", this.option("infinite")) && contentWidth > viewportWidth) {
                    var nextInterval = Math.floor(pageIndex / pageCount) || 0, elemDimWidth = contentWidth;
                    nextPosition = this.pages[page].left + nextInterval * elemDimWidth;
                    if (toClosest === true && pageCount > 2) {
                        var currPosition = this.Panzoom.content.x * -1;
                        // * Find closest interval
                        var decreasedPosition = nextPosition - elemDimWidth, increasedPosition = nextPosition + elemDimWidth, diff1 = Math.abs(currPosition - nextPosition), diff2 = Math.abs(currPosition - decreasedPosition), diff3 = Math.abs(currPosition - increasedPosition);
                        if (diff3 < diff1 && diff3 <= diff2) {
                            nextPosition = increasedPosition;
                            pageIndex += pageCount;
                        } else if (diff2 < diff1 && diff2 < diff3) {
                            nextPosition = decreasedPosition;
                            pageIndex -= pageCount;
                        }
                    }
                } else {
                    page = pageIndex = Math.max(0, Math.min(pageIndex, pageCount - 1));
                    nextPosition = this.pages.length ? this.pages[page].left : 0;
                }
                this.page = page;
                this.pageIndex = pageIndex;
                if (prevPage !== null && page !== prevPage) {
                    this.prevPage = prevPage;
                    this.prevPageIndex = prevPageIndex;
                    this.trigger("change", page, prevPage);
                }
                return nextPosition;
            }
        },
        {
            /**
   * Clean up
   */ key: "destroy",
            value: function destroy() {
                var _this = this;
                this.state = "destroy";
                this.slides.forEach(function(slide) {
                    _this.removeSlideEl(slide);
                });
                this.slides = [];
                this.Panzoom.destroy();
                this.detachPlugins();
            }
        }
    ]);
    return Carousel;
}((0, $633001db0e20238e$export$ef88aa0d34c34520));
// Expose version
$ddbfb93057510fe5$export$144901db2ea8e967.version = "__VERSION__";
// Static properties are a recent addition that dont work in all browsers yet
$ddbfb93057510fe5$export$144901db2ea8e967.Plugins = (0, $6416c7d79f195c83$export$c203ca0aafe4939a);





var $d5cc0f2be00b0b23$export$43c4ad2b7f26555a = /*#__PURE__*/ function() {
    "use strict";
    function ScrollLock(fancybox) {
        (0, $748c5547edb8a18d$export$71511d61b312f219)(this, ScrollLock);
        this.fancybox = fancybox;
        this.viewport = null;
        this.pendingUpdate = null;
        for(var _i = 0, _iter = [
            "onReady",
            "onResize",
            "onTouchstart",
            "onTouchmove"
        ]; _i < _iter.length; _i++){
            var methodName = _iter[_i];
            this[methodName] = this[methodName].bind(this);
        }
    }
    (0, $c95e6614e27503ea$export$71511d61b312f219)(ScrollLock, [
        {
            /**
   * Process `initLayout` event to attach event listeners and resize viewport if needed
   */ key: "onReady",
            value: function onReady() {
                //* Support Visual Viewport API
                // https://developer.mozilla.org/en-US/docs/Web/API/Visual_Viewport_API
                var viewport = window.visualViewport;
                if (viewport) {
                    this.viewport = viewport;
                    this.startY = 0;
                    viewport.addEventListener("resize", this.onResize);
                    this.updateViewport();
                }
                //* Prevent bouncing while scrolling on mobile devices
                window.addEventListener("touchstart", this.onTouchstart, {
                    passive: false
                });
                window.addEventListener("touchmove", this.onTouchmove, {
                    passive: false
                });
                //* Prevent window scrolling with mouse wheel
                window.addEventListener("wheel", this.onWheel, {
                    passive: false
                });
            }
        },
        {
            /**
   * Handle `resize` event to call `updateViewport`
   */ key: "onResize",
            value: function onResize() {
                this.updateViewport();
            }
        },
        {
            /**
   * Scale $container proportionally to actually fit inside browser,
   * e.g., disable viewport zooming
   */ key: "updateViewport",
            value: function updateViewport() {
                var fancybox = this.fancybox, viewport = this.viewport, scale = viewport.scale || 1, $container = fancybox.$container;
                if (!$container) return;
                var width = "", height = "", transform = "";
                if (scale - 1 > 0.1) {
                    width = "".concat(viewport.width * scale, "px");
                    height = "".concat(viewport.height * scale, "px");
                    transform = "translate3d(".concat(viewport.offsetLeft, "px, ").concat(viewport.offsetTop, "px, 0) scale(").concat(1 / scale, ")");
                }
                $container.style.width = width;
                $container.style.height = height;
                $container.style.transform = transform;
            }
        },
        {
            /**
   * Handle `touchstart` event to mark drag start position
   * @param {Object} event
   */ key: "onTouchstart",
            value: function onTouchstart(event) {
                this.startY = event.touches ? event.touches[0].screenY : event.screenY;
            }
        },
        {
            /**
   * Handle `touchmove` event to fix scrolling on mobile devices (iOS)
   * @param {Object} event
   */ key: "onTouchmove",
            value: function onTouchmove(event) {
                var startY = this.startY;
                var zoom = window.innerWidth / window.document.documentElement.clientWidth;
                if (!event.cancelable) return;
                if (event.touches.length > 1 || zoom !== 1) return;
                var el = (0, $73e79f034cb06cc3$export$2bb74740c4e19def)(event.composedPath()[0]);
                if (!el) {
                    event.preventDefault();
                    return;
                }
                var style = window.getComputedStyle(el);
                var height = parseInt(style.getPropertyValue("height"), 10);
                var curY = event.touches ? event.touches[0].screenY : event.screenY;
                var isAtTop = startY <= curY && el.scrollTop === 0;
                var isAtBottom = startY >= curY && el.scrollHeight - el.scrollTop === height;
                if (isAtTop || isAtBottom) event.preventDefault();
            }
        },
        {
            /**
   * Handle `wheel` event
   */ key: "onWheel",
            value: function onWheel(event) {
                if (!(0, $73e79f034cb06cc3$export$2bb74740c4e19def)(event.composedPath()[0])) event.preventDefault();
            }
        },
        {
            /**
   * Clean everything up
   */ key: "cleanup",
            value: function cleanup() {
                if (this.pendingUpdate) {
                    cancelAnimationFrame(this.pendingUpdate);
                    this.pendingUpdate = null;
                }
                var viewport = this.viewport;
                if (viewport) {
                    viewport.removeEventListener("resize", this.onResize);
                    this.viewport = null;
                }
                window.removeEventListener("touchstart", this.onTouchstart, false);
                window.removeEventListener("touchmove", this.onTouchmove, false);
                window.removeEventListener("wheel", this.onWheel, {
                    passive: false
                });
            }
        },
        {
            key: "attach",
            value: function attach() {
                this.fancybox.on("initLayout", this.onReady);
            }
        },
        {
            key: "detach",
            value: function detach() {
                this.fancybox.off("initLayout", this.onReady);
                this.cleanup();
            }
        }
    ]);
    return ScrollLock;
}();






var $a13d8c14ffa4a792$var$defaults = {
    // The minimum number of images in the gallery to display thumbnails
    minSlideCount: 2,
    // Minimum screen height to display thumbnails
    minScreenHeight: 500,
    // Automatically show thumbnails when opened
    autoStart: true,
    // Keyboard shortcut to toggle thumbnail container
    key: "t",
    // Customize Carousel instance
    Carousel: {},
    tpl: '<div class="fancybox__thumb" style="background-image:url(\'{{src}}\')"></div>'
};
var $a13d8c14ffa4a792$export$73e055b807a6709 = /*#__PURE__*/ function() {
    "use strict";
    function Thumbs(fancybox) {
        (0, $748c5547edb8a18d$export$71511d61b312f219)(this, Thumbs);
        this.fancybox = fancybox;
        this.$container = null;
        this.state = "init";
        for(var _i = 0, _iter = [
            "onPrepare",
            "onClosing",
            "onKeydown"
        ]; _i < _iter.length; _i++){
            var methodName = _iter[_i];
            this[methodName] = this[methodName].bind(this);
        }
        this.events = {
            prepare: this.onPrepare,
            closing: this.onClosing,
            keydown: this.onKeydown
        };
    }
    (0, $c95e6614e27503ea$export$71511d61b312f219)(Thumbs, [
        {
            /**
   * Process `prepare` event to build the layout
   */ key: "onPrepare",
            value: function onPrepare() {
                // Get slides, skip if the total number is less than the minimum
                var slides = this.getSlides();
                if (slides.length < this.fancybox.option("Thumbs.minSlideCount")) {
                    this.state = "disabled";
                    return;
                }
                if (this.fancybox.option("Thumbs.autoStart") === true && this.fancybox.Carousel.Panzoom.content.height >= this.fancybox.option("Thumbs.minScreenHeight")) this.build();
            }
        },
        {
            /**
   * Process `closing` event to disable all events
   */ key: "onClosing",
            value: function onClosing() {
                if (this.Carousel) this.Carousel.Panzoom.detachEvents();
            }
        },
        {
            /**
   * Process `keydown` event to enable thumbnail list toggling using keyboard key
   * @param {Object} fancybox
   * @param {String} key
   */ key: "onKeydown",
            value: function onKeydown(fancybox, key) {
                if (key === fancybox.option("Thumbs.key")) this.toggle();
            }
        },
        {
            /**
   * Build layout and init thumbnail Carousel
   */ key: "build",
            value: function build() {
                var _this = this;
                if (this.$container) return;
                // Create wrapping element and append to layout
                var $container = document.createElement("div");
                $container.classList.add("fancybox__thumbs");
                this.fancybox.$carousel.parentNode.insertBefore($container, this.fancybox.$carousel.nextSibling);
                // Initialise thumbnail carousel with all slides
                this.Carousel = new (0, $ddbfb93057510fe5$export$144901db2ea8e967)($container, (0, $473ff96f0aaf0a3a$export$8b58be045bf06082)(true, {
                    Dots: false,
                    Navigation: false,
                    Sync: {
                        friction: 0
                    },
                    infinite: false,
                    center: true,
                    fill: true,
                    dragFree: true,
                    slidesPerPage: 1,
                    preload: 1
                }, this.fancybox.option("Thumbs.Carousel"), {
                    Sync: {
                        target: this.fancybox.Carousel
                    },
                    slides: this.getSlides()
                }));
                // Slide carousel on wheel event
                this.Carousel.Panzoom.on("wheel", function(panzoom, event) {
                    event.preventDefault();
                    _this.fancybox[event.deltaY < 0 ? "prev" : "next"]();
                });
                this.$container = $container;
                this.state = "visible";
            }
        },
        {
            /**
   * Process all fancybox slides to get all thumbnail images
   */ key: "getSlides",
            value: function getSlides() {
                var slides = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.fancybox.items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var slide = _step.value;
                        var thumb = slide.thumb;
                        if (thumb) slides.push({
                            html: this.fancybox.option("Thumbs.tpl").replace(/\{\{src\}\}/gi, thumb),
                            customClass: "has-thumb has-".concat(slide.type || "image")
                        });
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return slides;
            }
        },
        {
            /**
   * Toggle visibility of thumbnail list
   * Tip: you can use `Fancybox.getInstance().plugins.Thumbs.toggle()` from anywhere in your code
   */ key: "toggle",
            value: function toggle() {
                if (this.state === "visible") this.hide();
                else if (this.state === "hidden") this.show();
                else this.build();
            }
        },
        {
            /**
   * Show thumbnail list
   */ key: "show",
            value: function show() {
                if (this.state === "hidden") {
                    this.$container.style.display = "";
                    this.Carousel.Panzoom.attachEvents();
                    this.state = "visible";
                }
            }
        },
        {
            /**
   * Hide thumbnail list
   */ key: "hide",
            value: function hide() {
                if (this.state === "visible") {
                    this.Carousel.Panzoom.detachEvents();
                    this.$container.style.display = "none";
                    this.state = "hidden";
                }
            }
        },
        {
            /**
   * Reset the state
   */ key: "cleanup",
            value: function cleanup() {
                if (this.Carousel) {
                    this.Carousel.destroy();
                    this.Carousel = null;
                }
                if (this.$container) {
                    this.$container.remove();
                    this.$container = null;
                }
                this.state = "init";
            }
        },
        {
            key: "attach",
            value: function attach() {
                this.fancybox.on(this.events);
            }
        },
        {
            key: "detach",
            value: function detach() {
                this.fancybox.off(this.events);
                this.cleanup();
            }
        }
    ]);
    return Thumbs;
}();
// Expose defaults
$a13d8c14ffa4a792$export$73e055b807a6709.defaults = $a13d8c14ffa4a792$var$defaults;







var $d58512219d95ad81$var$buildURLQuery = function(src, obj) {
    var url = new URL(src);
    var params = new URLSearchParams(url.search);
    var rez = new URLSearchParams();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = (0, $b6a26340ba3e8c80$export$71511d61b312f219)(params).concat((0, $b6a26340ba3e8c80$export$71511d61b312f219)(Object.entries(obj)))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $1933fb0d7df0f802$export$71511d61b312f219)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            // Youtube
            if (key === "t") rez.set("start", parseInt(value));
            else rez.set(key, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Convert to 'foo=1&bar=2&baz=3'
    rez = rez.toString();
    // Vimeo
    // https://vimeo.zendesk.com/hc/en-us/articles/360000121668-Starting-playback-at-a-specific-timecode
    var matches = src.match(/#t=((.*)?\d+s)/);
    if (matches) rez += "#t=".concat(matches[1]);
    return rez;
};
var $d58512219d95ad81$var$defaults = {
    // General options for any video content (Youtube, Vimeo, HTML5 video)
    video: {
        autoplay: true,
        ratio: 16 / 9
    },
    // Youtube embed parameters
    youtube: {
        autohide: 1,
        fs: 1,
        rel: 0,
        hd: 1,
        wmode: "transparent",
        enablejsapi: 1,
        html5: 1
    },
    // Vimeo embed parameters
    vimeo: {
        hd: 1,
        show_title: 1,
        show_byline: 1,
        show_portrait: 0,
        fullscreen: 1
    },
    // HTML5 video parameters
    html5video: {
        tpl: '<video class="fancybox__html5video" playsinline controls controlsList="nodownload" poster="{{poster}}">\n  <source src="{{src}}" type="{{format}}" />Sorry, your browser doesn\'t support embedded videos.</video>',
        format: ""
    }
};
var $d58512219d95ad81$export$13f9d3c4397c4713 = /*#__PURE__*/ function() {
    "use strict";
    function Html(fancybox) {
        (0, $748c5547edb8a18d$export$71511d61b312f219)(this, Html);
        this.fancybox = fancybox;
        for(var _i = 0, _iter = [
            "onInit",
            "onReady",
            "onCreateSlide",
            "onRemoveSlide",
            "onSelectSlide",
            "onUnselectSlide",
            "onRefresh",
            // For communication with iframed video (youtube/vimeo)
            "onMessage"
        ]; _i < _iter.length; _i++){
            var methodName = _iter[_i];
            this[methodName] = this[methodName].bind(this);
        }
        this.events = {
            init: this.onInit,
            ready: this.onReady,
            "Carousel.createSlide": this.onCreateSlide,
            "Carousel.removeSlide": this.onRemoveSlide,
            "Carousel.selectSlide": this.onSelectSlide,
            "Carousel.unselectSlide": this.onUnselectSlide,
            "Carousel.refresh": this.onRefresh
        };
    }
    (0, $c95e6614e27503ea$export$71511d61b312f219)(Html, [
        {
            /**
   * Check if each gallery item has type when fancybox starts
   */ key: "onInit",
            value: function onInit() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.fancybox.items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var slide = _step.value;
                        this.processType(slide);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
   * Set content type for the slide
   * @param {Object} slide
   */ key: "processType",
            value: function processType(slide) {
                // Add support for `new Fancybox({items : [{html : 'smth'}]});`
                if (slide.html) {
                    slide.src = slide.html;
                    slide.type = "html";
                    delete slide.html;
                    return;
                }
                var src = slide.src || "";
                var type = slide.type || this.fancybox.options.type, rez = null;
                if (src && typeof src !== "string") return;
                if (rez = src.match(/(?:youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(?:watch\?(?:.*&)?v=|v\/|u\/|embed\/?)?(videoseries\?list=(?:.*)|[\w-]{11}|\?listType=(?:.*)&list=(?:.*))(?:.*)/i)) {
                    var params = $d58512219d95ad81$var$buildURLQuery(src, this.fancybox.option("Html.youtube"));
                    var videoId = encodeURIComponent(rez[1]);
                    slide.videoId = videoId;
                    slide.src = "https://www.youtube-nocookie.com/embed/".concat(videoId, "?").concat(params);
                    slide.thumb = slide.thumb || "https://i.ytimg.com/vi/".concat(videoId, "/mqdefault.jpg");
                    slide.vendor = "youtube";
                    type = "video";
                } else if (rez = src.match(/^.+vimeo.com\/(?:\/)?([\d]+)(.*)?/)) {
                    var params1 = $d58512219d95ad81$var$buildURLQuery(src, this.fancybox.option("Html.vimeo"));
                    var videoId1 = encodeURIComponent(rez[1]);
                    slide.videoId = videoId1;
                    slide.src = "https://player.vimeo.com/video/".concat(videoId1, "?").concat(params1);
                    slide.vendor = "vimeo";
                    type = "video";
                } else if (rez = src.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:(?:(?:maps\/(?:place\/(?:.*)\/)?\@(.*),(\d+.?\d+?)z))|(?:\?ll=))(.*)?/i)) {
                    slide.src = "//maps.google.".concat(rez[1], "/?ll=").concat((rez[2] ? rez[2] + "&z=" + Math.floor(rez[3]) + (rez[4] ? rez[4].replace(/^\//, "&") : "") : rez[4] + "").replace(/\?/, "&"), "&output=").concat(rez[4] && rez[4].indexOf("layer=c") > 0 ? "svembed" : "embed");
                    type = "map";
                } else if (rez = src.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:maps\/search\/)(.*)/i)) {
                    slide.src = "//maps.google.".concat(rez[1], "/maps?q=").concat(rez[2].replace("query=", "q=").replace("api=1", ""), "&output=embed");
                    type = "map";
                }
                // Guess content type
                if (!type) {
                    if (src.charAt(0) === "#") type = "inline";
                    else if (rez = src.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i)) {
                        type = "html5video";
                        slide.format = slide.format || "video/" + (rez[1] === "ogv" ? "ogg" : rez[1]);
                    } else if (src.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i)) type = "image";
                    else if (src.match(/\.(pdf)((\?|#).*)?$/i)) type = "pdf";
                }
                slide.type = type || this.fancybox.option("defaultType", "image");
                if (type === "html5video" || type === "video") {
                    slide.video = (0, $473ff96f0aaf0a3a$export$8b58be045bf06082)({}, this.fancybox.option("Html.video"), slide.video);
                    if (slide._width && slide._height) slide.ratio = parseFloat(slide._width) / parseFloat(slide._height);
                    else slide.ratio = slide.ratio || slide.video.ratio || $d58512219d95ad81$var$defaults.video.ratio;
                }
            }
        },
        {
            /**
   * Start loading content when Fancybox is ready
   */ key: "onReady",
            value: function onReady() {
                var _this = this;
                this.fancybox.Carousel.slides.forEach(function(slide) {
                    if (slide.$el) {
                        _this.setContent(slide);
                        if (slide.index === _this.fancybox.getSlide().index) _this.playVideo(slide);
                    }
                });
            }
        },
        {
            /**
   * Process `Carousel.createSlide` event to create image content
   * @param {Object} fancybox
   * @param {Object} carousel
   * @param {Object} slide
   */ key: "onCreateSlide",
            value: function onCreateSlide(fancybox, carousel, slide) {
                if (this.fancybox.state !== "ready") return;
                this.setContent(slide);
            }
        },
        {
            /**
   * Retrieve and set slide content
   * @param {Object} slide
   */ key: "loadInlineContent",
            value: function loadInlineContent(slide) {
                var $content;
                if (slide.src instanceof HTMLElement) $content = slide.src;
                else if (typeof slide.src === "string") {
                    var tmp = slide.src.split("#", 2);
                    var id = tmp.length === 2 && tmp[0] === "" ? tmp[1] : tmp[0];
                    $content = document.getElementById(id);
                }
                if ($content) {
                    if (slide.type === "clone" || $content.$placeHolder) {
                        $content = $content.cloneNode(true);
                        var attrId = $content.getAttribute("id");
                        attrId = attrId ? "".concat(attrId, "--clone") : "clone-".concat(this.fancybox.id, "-").concat(slide.index);
                        $content.setAttribute("id", attrId);
                    } else {
                        var $placeHolder = document.createElement("div");
                        $placeHolder.classList.add("fancybox-placeholder");
                        $content.parentNode.insertBefore($placeHolder, $content);
                        $content.$placeHolder = $placeHolder;
                    }
                    this.fancybox.setContent(slide, $content);
                } else this.fancybox.setError(slide, "{{ELEMENT_NOT_FOUND}}");
            }
        },
        {
            /**
   * Makes AJAX request and sets response as slide content
   * @param {Object} slide
   */ key: "loadAjaxContent",
            value: function loadAjaxContent(slide) {
                var fancybox = this.fancybox;
                var xhr = new XMLHttpRequest();
                fancybox.showLoading(slide);
                xhr.onreadystatechange = function() {
                    if (xhr.readyState === XMLHttpRequest.DONE) {
                        if (fancybox.state === "ready") {
                            fancybox.hideLoading(slide);
                            if (xhr.status === 200) fancybox.setContent(slide, xhr.responseText);
                            else fancybox.setError(slide, xhr.status === 404 ? "{{AJAX_NOT_FOUND}}" : "{{AJAX_FORBIDDEN}}");
                        }
                    }
                };
                var data = slide.ajax || null;
                xhr.open(data ? "POST" : "GET", slide.src);
                xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
                xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
                xhr.send(data);
                slide.xhr = xhr;
            }
        },
        {
            /**
   * Creates iframe as slide content, preloads if needed before displaying
   * @param {Object} slide
   */ key: "loadIframeContent",
            value: function loadIframeContent(slide) {
                var _this = this;
                var fancybox = this.fancybox;
                var $iframe = document.createElement("iframe");
                $iframe.className = "fancybox__iframe";
                $iframe.setAttribute("id", "fancybox__iframe_".concat(fancybox.id, "_").concat(slide.index));
                $iframe.setAttribute("allow", "autoplay; fullscreen");
                $iframe.setAttribute("scrolling", "auto");
                slide.$iframe = $iframe;
                if (slide.type !== "iframe" || slide.preload === false) {
                    $iframe.setAttribute("src", slide.src);
                    this.fancybox.setContent(slide, $iframe);
                    this.resizeIframe(slide);
                    return;
                }
                fancybox.showLoading(slide);
                var $content = document.createElement("div");
                $content.style.visibility = "hidden";
                this.fancybox.setContent(slide, $content);
                $content.appendChild($iframe);
                $iframe.onerror = function() {
                    fancybox.setError(slide, "{{IFRAME_ERROR}}");
                };
                $iframe.onload = function() {
                    fancybox.hideLoading(slide);
                    var isFirstLoad = false;
                    if (!$iframe.isReady) {
                        $iframe.isReady = true;
                        isFirstLoad = true;
                    }
                    if (!$iframe.src.length) return;
                    $iframe.parentNode.style.visibility = "";
                    _this.resizeIframe(slide);
                    if (isFirstLoad) fancybox.revealContent(slide);
                };
                $iframe.setAttribute("src", slide.src);
            }
        },
        {
            /**
   * Set CSS max/min width/height properties of the content to have the correct aspect ratio
   * @param {Object} slide
   */ key: "setAspectRatio",
            value: function setAspectRatio(slide) {
                var $content = slide.$content;
                var ratio = slide.ratio;
                if (!$content) return;
                var width = slide._width;
                var height = slide._height;
                if (ratio || width && height) {
                    Object.assign($content.style, {
                        width: width && height ? "100%" : "",
                        height: width && height ? "100%" : "",
                        maxWidth: "",
                        maxHeight: ""
                    });
                    var maxWidth = $content.offsetWidth;
                    var maxHeight = $content.offsetHeight;
                    width = width || maxWidth;
                    height = height || maxHeight;
                    // Resize to fit
                    if (width > maxWidth || height > maxHeight) {
                        var maxRatio = Math.min(maxWidth / width, maxHeight / height);
                        width = width * maxRatio;
                        height = height * maxRatio;
                    }
                    // Recheck ratio
                    if (Math.abs(width / height - ratio) > 0.01) {
                        if (ratio < width / height) width = height * ratio;
                        else height = width / ratio;
                    }
                    Object.assign($content.style, {
                        width: "".concat(width, "px"),
                        height: "".concat(height, "px")
                    });
                }
            }
        },
        {
            /**
   * Adjust the width and height of the iframe according to the content dimensions, or defined sizes
   * @param {Object} slide
   */ key: "resizeIframe",
            value: function resizeIframe(slide) {
                var $iframe = slide.$iframe;
                if (!$iframe) return;
                var width_ = slide._width || 0;
                var height_ = slide._height || 0;
                if (width_ && height_) slide.autoSize = false;
                var $parent = $iframe.parentNode;
                var parentStyle = $parent && $parent.style;
                if (slide.preload !== false && slide.autoSize !== false && parentStyle) try {
                    var compStyles = window.getComputedStyle($parent), paddingX = parseFloat(compStyles.paddingLeft) + parseFloat(compStyles.paddingRight), paddingY = parseFloat(compStyles.paddingTop) + parseFloat(compStyles.paddingBottom);
                    var document1 = $iframe.contentWindow.document, $html = document1.getElementsByTagName("html")[0], $body = document1.body;
                    // Allow content to expand horizontally
                    parentStyle.width = "";
                    // Get rid of vertical scrollbar
                    $body.style.overflow = "hidden";
                    width_ = width_ || $html.scrollWidth + paddingX;
                    parentStyle.width = "".concat(width_, "px");
                    $body.style.overflow = "";
                    parentStyle.flex = "0 0 auto";
                    parentStyle.height = "".concat($body.scrollHeight, "px");
                    height_ = $html.scrollHeight + paddingY;
                } catch (error) {
                //
                }
                if (width_ || height_) {
                    var newStyle = {
                        flex: "0 1 auto"
                    };
                    if (width_) newStyle.width = "".concat(width_, "px");
                    if (height_) newStyle.height = "".concat(height_, "px");
                    Object.assign(parentStyle, newStyle);
                }
            }
        },
        {
            /**
   * Process `Carousel.onRefresh` event,
   * trigger iframe autosizing and set content aspect ratio for each slide
   * @param {Object} fancybox
   * @param {Object} carousel
   */ key: "onRefresh",
            value: function onRefresh(fancybox, carousel) {
                var _this = this;
                carousel.slides.forEach(function(slide) {
                    if (!slide.$el) return;
                    if (slide.$iframe) _this.resizeIframe(slide);
                    if (slide.ratio) _this.setAspectRatio(slide);
                });
            }
        },
        {
            /**
   * Process `Carousel.onCreateSlide` event to set content
   * @param {Object} fancybox
   * @param {Object} carousel
   * @param {Object} slide
   */ key: "setContent",
            value: function setContent(slide) {
                if (!slide || slide.isDom) return;
                switch(slide.type){
                    case "html":
                        this.fancybox.setContent(slide, slide.src);
                        break;
                    case "html5video":
                        this.fancybox.setContent(slide, this.fancybox.option("Html.html5video.tpl").replace(/\{\{src\}\}/gi, slide.src).replace("{{format}}", slide.format || slide.html5video && slide.html5video.format || "").replace("{{poster}}", slide.poster || slide.thumb || ""));
                        break;
                    case "inline":
                    case "clone":
                        this.loadInlineContent(slide);
                        break;
                    case "ajax":
                        this.loadAjaxContent(slide);
                        break;
                    case "pdf":
                    case "video":
                    case "map":
                        slide.preload = false;
                    case "iframe":
                        this.loadIframeContent(slide);
                        break;
                }
                if (slide.ratio) this.setAspectRatio(slide);
            }
        },
        {
            /**
   * Process `Carousel.onSelectSlide` event to start video
   * @param {Object} fancybox
   * @param {Object} carousel
   * @param {Object} slide
   */ key: "onSelectSlide",
            value: function onSelectSlide(fancybox, carousel, slide) {
                if (fancybox.state === "ready") this.playVideo(slide);
            }
        },
        {
            /**
   * Attempts to begin playback of the media
   * @param {Object} slide
   */ key: "playVideo",
            value: function playVideo(slide) {
                if (slide.type === "html5video" && slide.video.autoplay) try {
                    var $video = slide.$el.querySelector("video");
                    if ($video) {
                        var promise = $video.play();
                        if (promise !== undefined) promise.then(function() {
                        // Autoplay started
                        })["catch"](function(error) {
                            // Autoplay was prevented.
                            $video.muted = true;
                            $video.play();
                        });
                    }
                } catch (err) {}
                if (slide.type !== "video" || !(slide.$iframe && slide.$iframe.contentWindow)) return;
                // This function will be repeatedly called to check
                // if video iframe has been loaded to send message to start the video
                var poller = function() {
                    if (slide.state === "done" && slide.$iframe && slide.$iframe.contentWindow) {
                        var command;
                        if (slide.$iframe.isReady) {
                            if (slide.video && slide.video.autoplay) {
                                if (slide.vendor == "youtube") command = {
                                    event: "command",
                                    func: "playVideo"
                                };
                                else command = {
                                    method: "play",
                                    value: "true"
                                };
                            }
                            if (command) slide.$iframe.contentWindow.postMessage(JSON.stringify(command), "*");
                            return;
                        }
                        if (slide.vendor === "youtube") {
                            command = {
                                event: "listening",
                                id: slide.$iframe.getAttribute("id")
                            };
                            slide.$iframe.contentWindow.postMessage(JSON.stringify(command), "*");
                        }
                    }
                    slide.poller = setTimeout(poller, 250);
                };
                poller();
            }
        },
        {
            /**
   * Process `Carousel.onUnselectSlide` event to pause video
   * @param {Object} fancybox
   * @param {Object} carousel
   * @param {Object} slide
   */ key: "onUnselectSlide",
            value: function onUnselectSlide(fancybox, carousel, slide) {
                if (slide.type === "html5video") {
                    try {
                        slide.$el.querySelector("video").pause();
                    } catch (error) {}
                    return;
                }
                var command = false;
                if (slide.vendor == "vimeo") command = {
                    method: "pause",
                    value: "true"
                };
                else if (slide.vendor === "youtube") command = {
                    event: "command",
                    func: "pauseVideo"
                };
                if (command && slide.$iframe && slide.$iframe.contentWindow) slide.$iframe.contentWindow.postMessage(JSON.stringify(command), "*");
                clearTimeout(slide.poller);
            }
        },
        {
            /**
   * Process `Carousel.onRemoveSlide` event to do clean up
   * @param {Object} fancybox
   * @param {Object} carousel
   * @param {Object} slide
   */ key: "onRemoveSlide",
            value: function onRemoveSlide(fancybox, carousel, slide) {
                // Abort ajax request if exists
                if (slide.xhr) {
                    slide.xhr.abort();
                    slide.xhr = null;
                }
                // Unload iframe content if exists
                if (slide.$iframe) {
                    slide.$iframe.onload = slide.$iframe.onerror = null;
                    slide.$iframe.src = "//about:blank";
                    slide.$iframe = null;
                }
                // Clear inline content
                var $content = slide.$content;
                if (slide.type === "inline" && $content) {
                    $content.classList.remove("fancybox__content");
                    if ($content.style.display !== "none") $content.style.display = "none";
                }
                if (slide.$closeButton) {
                    slide.$closeButton.remove();
                    slide.$closeButton = null;
                }
                var $placeHolder = $content && $content.$placeHolder;
                if ($placeHolder) {
                    $placeHolder.parentNode.insertBefore($content, $placeHolder);
                    $placeHolder.remove();
                    $content.$placeHolder = null;
                }
            }
        },
        {
            /**
   * Process `window.message` event to mark video iframe element as `ready`
   * @param {Object} e - Event
   */ key: "onMessage",
            value: function onMessage(e) {
                try {
                    var data = JSON.parse(e.data);
                    if (e.origin === "https://player.vimeo.com") {
                        if (data.event === "ready") {
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = document.getElementsByClassName("fancybox__iframe")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var $iframe = _step.value;
                                    if ($iframe.contentWindow === e.source) $iframe.isReady = 1;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                    } else if (e.origin === "https://www.youtube-nocookie.com") {
                        if (data.event === "onReady") document.getElementById(data.id).isReady = 1;
                    }
                } catch (ex) {}
            }
        },
        {
            key: "attach",
            value: function attach() {
                this.fancybox.on(this.events);
                window.addEventListener("message", this.onMessage, false);
            }
        },
        {
            key: "detach",
            value: function detach() {
                this.fancybox.off(this.events);
                window.removeEventListener("message", this.onMessage, false);
            }
        }
    ]);
    return Html;
}();
// Expose defaults
$d58512219d95ad81$export$13f9d3c4397c4713.defaults = $d58512219d95ad81$var$defaults;






var $cbfb096d34afb745$var$defaults = {
    // Class name for slide element indicating that content can be zoomed in
    canZoomInClass: "can-zoom_in",
    // Class name for slide element indicating that content can be zoomed out
    canZoomOutClass: "can-zoom_out",
    // Do zoom animation from thumbnail image when starting or closing fancybox
    zoom: true,
    // Animate opacity while zooming
    zoomOpacity: "auto",
    // Zoom animation friction
    zoomFriction: 0.82,
    // Disable zoom animation if thumbnail is visible only partly
    ignoreCoveredThumbnail: false,
    // Enable guestures
    touch: true,
    // Action to be performed when user clicks on the image
    click: "toggleZoom",
    // Action to be performed when double-click event is detected on the image
    doubleClick: null,
    // Action to be performed when user rotates a wheel button on a pointing device
    wheel: "zoom",
    // How image should be resized to fit its container
    fit: "contain",
    // Should create wrapping element around the image
    wrap: false,
    // Custom Panzoom options
    Panzoom: {
        ratio: 1
    }
};
var $cbfb096d34afb745$export$3e431a229df88919 = /*#__PURE__*/ function() {
    "use strict";
    function Image(fancybox) {
        (0, $748c5547edb8a18d$export$71511d61b312f219)(this, Image);
        this.fancybox = fancybox;
        for(var _i = 0, _iter = [
            // Fancybox
            "onReady",
            "onClosing",
            "onDone",
            // Fancybox.Carousel
            "onPageChange",
            "onCreateSlide",
            "onRemoveSlide",
            // Image load/error
            "onImageStatusChange"
        ]; _i < _iter.length; _i++){
            var methodName = _iter[_i];
            this[methodName] = this[methodName].bind(this);
        }
        this.events = {
            ready: this.onReady,
            closing: this.onClosing,
            done: this.onDone,
            "Carousel.change": this.onPageChange,
            "Carousel.createSlide": this.onCreateSlide,
            "Carousel.removeSlide": this.onRemoveSlide
        };
    }
    (0, $c95e6614e27503ea$export$71511d61b312f219)(Image, [
        {
            /**
   * Handle `ready` event to start loading content
   */ key: "onReady",
            value: function onReady() {
                var _this = this;
                this.fancybox.Carousel.slides.forEach(function(slide) {
                    if (slide.$el) _this.setContent(slide);
                });
            }
        },
        {
            /**
   * Handle `done` event to update cursor
   * @param {Object} fancybox
   * @param {Object} slide
   */ key: "onDone",
            value: function onDone(fancybox, slide) {
                this.handleCursor(slide);
            }
        },
        {
            /**
   * Handle `closing` event to clean up all slides and to start zoom-out animation
   * @param {Object} fancybox
   */ key: "onClosing",
            value: function onClosing(fancybox) {
                clearTimeout(this.clickTimer);
                this.clickTimer = null;
                // Remove events
                fancybox.Carousel.slides.forEach(function(slide) {
                    if (slide.$image) slide.state = "destroy";
                    if (slide.Panzoom) slide.Panzoom.detachEvents();
                });
                // If possible, start the zoom animation, it will interrupt the default closing process
                if (this.fancybox.state === "closing" && this.canZoom(fancybox.getSlide())) this.zoomOut();
            }
        },
        {
            /**
   * Process `Carousel.createSlide` event to create image content
   * @param {Object} fancybox
   * @param {Object} carousel
   * @param {Object} slide
   */ key: "onCreateSlide",
            value: function onCreateSlide(fancybox, carousel, slide) {
                if (this.fancybox.state !== "ready") return;
                this.setContent(slide);
            }
        },
        {
            /**
   * Handle `Carousel.removeSlide` event to do clean up the slide
   * @param {Object} fancybox
   * @param {Object} carousel
   * @param {Object} slide
   */ key: "onRemoveSlide",
            value: function onRemoveSlide(fancybox, carousel, slide) {
                if (slide.$image) {
                    slide.$el.classList.remove(fancybox.option("Image.canZoomInClass"));
                    slide.$image.remove();
                    slide.$image = null;
                }
                if (slide.Panzoom) {
                    slide.Panzoom.destroy();
                    slide.Panzoom = null;
                }
                if (slide.$el && slide.$el.dataset) delete slide.$el.dataset.imageFit;
            }
        },
        {
            /**
   * Build DOM elements and add event listeners
   * @param {Object} slide
   */ key: "setContent",
            value: function setContent(slide) {
                var _this = this;
                // Check if this slide should contain an image
                if (slide.isDom || slide.html || slide.type && slide.type !== "image") return;
                if (slide.$image) return;
                slide.type = "image";
                slide.state = "loading";
                // * Build layout
                // Container
                var $content = document.createElement("div");
                $content.style.visibility = "hidden";
                // Image element
                var $image = document.createElement("img");
                $image.addEventListener("load", function(event) {
                    event.stopImmediatePropagation();
                    _this.onImageStatusChange(slide);
                });
                $image.addEventListener("error", function() {
                    _this.onImageStatusChange(slide);
                });
                $image.src = slide.src;
                $image.alt = "";
                $image.draggable = false;
                $image.classList.add("fancybox__image");
                if (slide.srcset) $image.setAttribute("srcset", slide.srcset);
                if (slide.sizes) $image.setAttribute("sizes", slide.sizes);
                slide.$image = $image;
                var shouldWrap = this.fancybox.option("Image.wrap");
                if (shouldWrap) {
                    var $wrap = document.createElement("div");
                    $wrap.classList.add(typeof shouldWrap === "string" ? shouldWrap : "fancybox__image-wrap");
                    $wrap.appendChild($image);
                    $content.appendChild($wrap);
                    slide.$wrap = $wrap;
                } else $content.appendChild($image);
                // Set data attribute if other that default
                // for example, set `[data-image-fit="contain-w"]`
                slide.$el.dataset.imageFit = this.fancybox.option("Image.fit");
                // Append content
                this.fancybox.setContent(slide, $content);
                // Display loading icon
                if ($image.complete || $image.error) this.onImageStatusChange(slide);
                else this.fancybox.showLoading(slide);
            }
        },
        {
            /**
   * Handle image state change, display error or start revealing image
   * @param {Object} slide
   */ key: "onImageStatusChange",
            value: function onImageStatusChange(slide) {
                var _this = this;
                var $image = slide.$image;
                if (!$image || slide.state !== "loading") return;
                if (!($image.complete && $image.naturalWidth && $image.naturalHeight)) {
                    this.fancybox.setError(slide, "{{IMAGE_ERROR}}");
                    return;
                }
                this.fancybox.hideLoading(slide);
                if (this.fancybox.option("Image.fit") === "contain") this.initSlidePanzoom(slide);
                // Add `wheel` and `click` event handler
                slide.$el.addEventListener("wheel", function(event) {
                    return _this.onWheel(slide, event);
                }, {
                    passive: false
                });
                slide.$content.addEventListener("click", function(event) {
                    return _this.onClick(slide, event);
                }, {
                    passive: false
                });
                this.revealContent(slide);
            }
        },
        {
            /**
   * Make image zoomable and draggable using Panzoom
   * @param {Object} slide
   */ key: "initSlidePanzoom",
            value: function initSlidePanzoom(slide) {
                var _this = this;
                if (slide.Panzoom) return;
                //* Initialize Panzoom
                slide.Panzoom = new (0, $9707d077d55fad71$export$b704d075ddd20210)(slide.$el, (0, $473ff96f0aaf0a3a$export$8b58be045bf06082)(true, this.fancybox.option("Image.Panzoom", {}), {
                    viewport: slide.$wrap,
                    content: slide.$image,
                    width: slide._width,
                    height: slide._height,
                    wrapInner: false,
                    // Allow to select caption text
                    textSelection: true,
                    // Toggle gestures
                    touch: this.fancybox.option("Image.touch"),
                    // This will prevent click conflict with fancybox main carousel
                    panOnlyZoomed: true,
                    // Disable default click / wheel events as custom event listeners will replace them,
                    // because click and wheel events should work without Panzoom
                    click: false,
                    wheel: false
                }));
                slide.Panzoom.on("startAnimation", function() {
                    _this.fancybox.trigger("Image.startAnimation", slide);
                });
                slide.Panzoom.on("endAnimation", function() {
                    if (slide.state === "zoomIn") _this.fancybox.done(slide);
                    _this.handleCursor(slide);
                    _this.fancybox.trigger("Image.endAnimation", slide);
                });
                slide.Panzoom.on("afterUpdate", function() {
                    _this.handleCursor(slide);
                    _this.fancybox.trigger("Image.afterUpdate", slide);
                });
            }
        },
        {
            /**
   * Start zoom-in animation if possible, or simply reveal content
   * @param {Object} slide
   */ key: "revealContent",
            value: function revealContent(slide) {
                // Animate only on first run
                if (this.fancybox.Carousel.prevPage === null && slide.index === this.fancybox.options.startIndex && this.canZoom(slide)) this.zoomIn();
                else this.fancybox.revealContent(slide);
            }
        },
        {
            /**
   * Get zoom info for selected slide
   * @param {Object} slide
   */ key: "getZoomInfo",
            value: function getZoomInfo(slide) {
                var $thumb = slide.$thumb, thumbRect = $thumb.getBoundingClientRect(), thumbWidth = thumbRect.width, thumbHeight = thumbRect.height, //
                contentRect = slide.$content.getBoundingClientRect(), contentWidth = contentRect.width, contentHeight = contentRect.height, //
                shiftedTop = contentRect.top - thumbRect.top, shiftedLeft = contentRect.left - thumbRect.left;
                // Check if need to update opacity
                var opacity = this.fancybox.option("Image.zoomOpacity");
                if (opacity === "auto") opacity = Math.abs(thumbWidth / thumbHeight - contentWidth / contentHeight) > 0.1;
                return {
                    top: shiftedTop,
                    left: shiftedLeft,
                    scale: contentWidth && thumbWidth ? thumbWidth / contentWidth : 1,
                    opacity: opacity
                };
            }
        },
        {
            /**
   * Determine if it is possible to do zoom-in animation
   */ key: "canZoom",
            value: function canZoom(slide) {
                var fancybox = this.fancybox, $container = fancybox.$container;
                if (window.visualViewport && window.visualViewport.scale !== 1) return false;
                if (slide.Panzoom && !slide.Panzoom.content.width) return false;
                if (!fancybox.option("Image.zoom") || fancybox.option("Image.fit") !== "contain") return false;
                var $thumb = slide.$thumb;
                if (!$thumb || slide.state === "loading") return false;
                // * Check if thumbnail image is really visible
                $container.classList.add("fancybox__no-click");
                var rect = $thumb.getBoundingClientRect();
                var rez;
                // Check if thumbnail image is actually visible on the screen
                if (this.fancybox.option("Image.ignoreCoveredThumbnail")) {
                    var visibleTopLeft = document.elementFromPoint(rect.left + 1, rect.top + 1) === $thumb;
                    var visibleBottomRight = document.elementFromPoint(rect.right - 1, rect.bottom - 1) === $thumb;
                    rez = visibleTopLeft && visibleBottomRight;
                } else rez = document.elementFromPoint(rect.left + rect.width * 0.5, rect.top + rect.height * 0.5) === $thumb;
                $container.classList.remove("fancybox__no-click");
                return rez;
            }
        },
        {
            /**
   * Perform zoom-in animation
   */ key: "zoomIn",
            value: function zoomIn() {
                var fancybox = this.fancybox, slide = fancybox.getSlide(), Panzoom = slide.Panzoom;
                var _this_getZoomInfo = this.getZoomInfo(slide), top = _this_getZoomInfo.top, left = _this_getZoomInfo.left, scale = _this_getZoomInfo.scale, opacity = _this_getZoomInfo.opacity;
                fancybox.trigger("reveal", slide);
                // Scale and move to start position
                Panzoom.panTo({
                    x: left * -1,
                    y: top * -1,
                    scale: scale,
                    friction: 0,
                    ignoreBounds: true
                });
                slide.$content.style.visibility = "";
                slide.state = "zoomIn";
                if (opacity === true) Panzoom.on("afterTransform", function(panzoom) {
                    if (slide.state === "zoomIn" || slide.state === "zoomOut") panzoom.$content.style.opacity = Math.min(1, 1 - (1 - panzoom.content.scale) / (1 - scale));
                });
                // Animate back to original position
                Panzoom.panTo({
                    x: 0,
                    y: 0,
                    scale: 1,
                    friction: this.fancybox.option("Image.zoomFriction")
                });
            }
        },
        {
            /**
   * Perform zoom-out animation
   */ key: "zoomOut",
            value: function zoomOut() {
                var _this = this;
                var fancybox = this.fancybox, slide = fancybox.getSlide(), Panzoom = slide.Panzoom;
                if (!Panzoom) return;
                slide.state = "zoomOut";
                fancybox.state = "customClosing";
                if (slide.$caption) slide.$caption.style.visibility = "hidden";
                var friction = this.fancybox.option("Image.zoomFriction");
                var animatePosition = function(event) {
                    var _this_getZoomInfo = _this.getZoomInfo(slide), top = _this_getZoomInfo.top, left = _this_getZoomInfo.left, scale = _this_getZoomInfo.scale, opacity = _this_getZoomInfo.opacity;
                    // Increase speed on the first run if opacity is not animated
                    if (!event && !opacity) friction *= 0.82;
                    Panzoom.panTo({
                        x: left * -1,
                        y: top * -1,
                        scale: scale,
                        friction: friction,
                        ignoreBounds: true
                    });
                    // Gradually increase speed
                    friction *= 0.98;
                };
                // Page scrolling will cause thumbnail to change position on the display,
                // therefore animation end position has to be recalculated after each page scroll
                window.addEventListener("scroll", animatePosition);
                Panzoom.once("endAnimation", function() {
                    window.removeEventListener("scroll", animatePosition);
                    fancybox.destroy();
                });
                animatePosition();
            }
        },
        {
            /**
   * Set the type of mouse cursor to indicate if content is zoomable
   * @param {Object} slide
   */ key: "handleCursor",
            value: function handleCursor(slide) {
                if (slide.type !== "image" || !slide.$el) return;
                var panzoom = slide.Panzoom;
                var clickAction = this.fancybox.option("Image.click", false, slide);
                var touchIsEnabled = this.fancybox.option("Image.touch");
                var classList = slide.$el.classList;
                var zoomInClass = this.fancybox.option("Image.canZoomInClass");
                var zoomOutClass = this.fancybox.option("Image.canZoomOutClass");
                classList.remove(zoomOutClass);
                classList.remove(zoomInClass);
                if (panzoom && clickAction === "toggleZoom") {
                    var canZoomIn = panzoom && panzoom.content.scale === 1 && panzoom.option("maxScale") - panzoom.content.scale > 0.01;
                    if (canZoomIn) classList.add(zoomInClass);
                    else if (panzoom.content.scale > 1 && !touchIsEnabled) classList.add(zoomOutClass);
                } else if (clickAction === "close") classList.add(zoomOutClass);
            }
        },
        {
            /**
   * Handle `wheel` event
   * @param {Object} slide
   * @param {Object} event
   */ key: "onWheel",
            value: function onWheel(slide, event) {
                if (this.fancybox.state !== "ready") return;
                if (this.fancybox.trigger("Image.wheel", event) === false) return;
                switch(this.fancybox.option("Image.wheel")){
                    case "zoom":
                        if (slide.state === "done") slide.Panzoom && slide.Panzoom.zoomWithWheel(event);
                        break;
                    case "close":
                        this.fancybox.close();
                        break;
                    case "slide":
                        this.fancybox[event.deltaY < 0 ? "prev" : "next"]();
                        break;
                }
            }
        },
        {
            /**
   * Handle `click` and `dblclick` events
   * @param {Object} slide
   * @param {Object} event
   */ key: "onClick",
            value: function onClick(slide, event) {
                var _this = this;
                // Check that clicks should be allowed
                if (this.fancybox.state !== "ready") return;
                var panzoom = slide.Panzoom;
                if (panzoom && (panzoom.dragPosition.midPoint || panzoom.dragOffset.x !== 0 || panzoom.dragOffset.y !== 0 || panzoom.dragOffset.scale !== 1)) return;
                if (this.fancybox.Carousel.Panzoom.lockAxis) return false;
                var process = function(action) {
                    switch(action){
                        case "toggleZoom":
                            event.stopPropagation();
                            slide.Panzoom && slide.Panzoom.zoomWithClick(event);
                            break;
                        case "close":
                            _this.fancybox.close();
                            break;
                        case "next":
                            event.stopPropagation();
                            _this.fancybox.next();
                            break;
                    }
                };
                var clickAction = this.fancybox.option("Image.click");
                var dblclickAction = this.fancybox.option("Image.doubleClick");
                if (dblclickAction) {
                    if (this.clickTimer) {
                        clearTimeout(this.clickTimer);
                        this.clickTimer = null;
                        process(dblclickAction);
                    } else this.clickTimer = setTimeout(function() {
                        _this.clickTimer = null;
                        process(clickAction);
                    }, 300);
                } else process(clickAction);
            }
        },
        {
            /**
   * Handle `Carousel.change` event to reset zoom level for any zoomed in/out content
   * and to revel content of the current page
   * @param {Object} fancybox
   * @param {Object} carousel
   */ key: "onPageChange",
            value: function onPageChange(fancybox, carousel) {
                var currSlide = fancybox.getSlide();
                carousel.slides.forEach(function(slide) {
                    if (!slide.Panzoom || slide.state !== "done") return;
                    if (slide.index !== currSlide.index) slide.Panzoom.panTo({
                        x: 0,
                        y: 0,
                        scale: 1,
                        friction: 0.8
                    });
                });
            }
        },
        {
            key: "attach",
            value: function attach() {
                this.fancybox.on(this.events);
            }
        },
        {
            key: "detach",
            value: function detach() {
                this.fancybox.off(this.events);
            }
        }
    ]);
    return Image;
}();
// Expose defaults
$cbfb096d34afb745$export$3e431a229df88919.defaults = $cbfb096d34afb745$var$defaults;





var $d62af170a2423346$export$ab85ecd77ce6a5cd = /*#__PURE__*/ function() {
    "use strict";
    function Hash(fancybox) {
        (0, $748c5547edb8a18d$export$71511d61b312f219)(this, Hash);
        this.fancybox = fancybox;
        for(var _i = 0, _iter = [
            "onChange",
            "onClosing"
        ]; _i < _iter.length; _i++){
            var methodName = _iter[_i];
            this[methodName] = this[methodName].bind(this);
        }
        this.events = {
            initCarousel: this.onChange,
            "Carousel.change": this.onChange,
            closing: this.onClosing
        };
        this.hasCreatedHistory = false;
        this.origHash = "";
        this.timer = null;
    }
    (0, $c95e6614e27503ea$export$71511d61b312f219)(Hash, [
        {
            /**
   * Process `Carousel.ready` and `Carousel.change` events to update URL hash
   * @param {Object} fancybox
   * @param {Object} carousel
   */ key: "onChange",
            value: function onChange(fancybox) {
                var _this = this;
                var carousel = fancybox.Carousel;
                if (this.timer) clearTimeout(this.timer);
                var firstRun = carousel.prevPage === null;
                var currentSlide = fancybox.getSlide();
                var currentHash = new URL(document.URL).hash;
                var newHash = false;
                if (currentSlide.slug) newHash = "#" + currentSlide.slug;
                else {
                    var dataset = currentSlide.$trigger && currentSlide.$trigger.dataset;
                    var slug = fancybox.option("slug") || dataset && dataset.fancybox;
                    if (slug && slug.length && slug !== "true") newHash = "#" + slug + (carousel.slides.length > 1 ? "-" + (currentSlide.index + 1) : "");
                }
                if (firstRun) this.origHash = currentHash !== newHash ? currentHash : "";
                if (newHash && currentHash !== newHash) this.timer = setTimeout(function() {
                    try {
                        window.history[firstRun ? "pushState" : "replaceState"]({}, document.title, window.location.pathname + window.location.search + newHash);
                        if (firstRun) _this.hasCreatedHistory = true;
                    } catch (e) {}
                }, 300);
            }
        },
        {
            /**
   * Process `closing` event to clean up
   */ key: "onClosing",
            value: function onClosing() {
                if (this.timer) clearTimeout(this.timer);
                // Skip if closing is triggered by pressing  browser back button or by changing hash manually
                if (this.hasSilentClose === true) return;
                // Restore original url
                try {
                    window.history.replaceState({}, document.title, window.location.pathname + window.location.search + (this.origHash || ""));
                    return;
                } catch (e) {}
            }
        },
        {
            key: "attach",
            value: function attach(fancybox) {
                fancybox.on(this.events);
            }
        },
        {
            key: "detach",
            value: function detach(fancybox) {
                fancybox.off(this.events);
            }
        }
    ], [
        {
            key: "startFromUrl",
            value: /**
   * Start fancybox from current URL hash,
   * this will be called on page load OR/AND after changing URL hash
   * @param {Class} Fancybox
   */ function startFromUrl() {
                var Fancybox = Hash.Fancybox;
                if (!Fancybox || Fancybox.getInstance() || Fancybox.defaults.Hash === false) return;
                var _Hash_getParsedURL = Hash.getParsedURL(), hash = _Hash_getParsedURL.hash, slug = _Hash_getParsedURL.slug, index = _Hash_getParsedURL.index;
                if (!slug) return;
                // Support custom slug
                // ===
                var selectedElem = document.querySelector('[data-slug="'.concat(hash, '"]'));
                if (selectedElem) selectedElem.dispatchEvent(new CustomEvent("click", {
                    bubbles: true,
                    cancelable: true
                }));
                if (Fancybox.getInstance()) return;
                // If elements are not found by custom slug, use URL hash value as group name
                // ===
                var groupElems = document.querySelectorAll('[data-fancybox="'.concat(slug, '"]'));
                if (!groupElems.length) return;
                if (index === null && groupElems.length === 1) selectedElem = groupElems[0];
                else if (index) selectedElem = groupElems[index - 1];
                if (selectedElem) selectedElem.dispatchEvent(new CustomEvent("click", {
                    bubbles: true,
                    cancelable: true
                }));
            }
        },
        {
            key: "onHashChange",
            value: /**
   * Handle `hash` change, change gallery item to current index or start/close current instance
   */ function onHashChange() {
                var _Hash_getParsedURL = Hash.getParsedURL(), slug = _Hash_getParsedURL.slug, index = _Hash_getParsedURL.index;
                var Fancybox = Hash.Fancybox;
                var instance = Fancybox && Fancybox.getInstance();
                if (instance && instance.plugins.Hash) {
                    // Check if hash matches currently active gallery
                    if (slug) {
                        var carousel = instance.Carousel;
                        /**
         * Support manually opened gallery
         */ if (slug === instance.option("slug")) return carousel.slideTo(index - 1);
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            /**
         * Check if URL hash matches `data-slug` value of active element
         */ for(var _iterator = carousel.slides[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var slide = _step.value;
                                if (slide.slug && slide.slug === slug) return carousel.slideTo(slide.index);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        /**
         * Check if URL hash matches `data-fancybox` value of active element
         */ var slide1 = instance.getSlide();
                        var dataset = slide1.$trigger && slide1.$trigger.dataset;
                        if (dataset && dataset.fancybox === slug) return carousel.slideTo(index - 1);
                    }
                    /**
       * Close if no matching element found
       */ instance.plugins.Hash.hasSilentClose = true;
                    instance.close();
                }
                /**
     * Attempt to start
     */ Hash.startFromUrl();
            }
        },
        {
            key: "create",
            value: /**
   * Add event bindings that will start new Fancybox instance based in the current URL
   */ function create(Fancybox) {
                Hash.Fancybox = Fancybox;
                function proceed() {
                    window.addEventListener("hashchange", Hash.onHashChange, false);
                    Hash.startFromUrl();
                }
                if (0, $041aa9e7dc769c90$export$71594e8a50f746f4) window.requestAnimationFrame(function() {
                    if (/complete|interactive|loaded/.test(document.readyState)) proceed();
                    else document.addEventListener("DOMContentLoaded", proceed);
                });
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                window.removeEventListener("hashchange", Hash.onHashChange, false);
            }
        },
        {
            key: "getParsedURL",
            value: /**
   * Helper method to split URL hash into useful pieces
   */ function getParsedURL() {
                var hash = window.location.hash.substr(1), tmp = hash.split("-"), index = tmp.length > 1 && /^\+?\d+$/.test(tmp[tmp.length - 1]) ? parseInt(tmp.pop(-1), 10) || null : null, slug = tmp.join("-");
                return {
                    hash: hash,
                    slug: slug,
                    index: index
                };
            }
        }
    ]);
    return Hash;
}();







var $cc6ce4d2f52426f7$export$159cd03be7087f39 = {
    pageXOffset: 0,
    pageYOffset: 0,
    element: function() {
        return document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;
    },
    activate: function(element) {
        $cc6ce4d2f52426f7$export$159cd03be7087f39.pageXOffset = window.pageXOffset;
        $cc6ce4d2f52426f7$export$159cd03be7087f39.pageYOffset = window.pageYOffset;
        if (element.requestFullscreen) element.requestFullscreen(); // W3C spec
        else if (element.mozRequestFullScreen) element.mozRequestFullScreen(); // Firefox
        else if (element.webkitRequestFullscreen) element.webkitRequestFullscreen(); // Safari
        else if (element.msRequestFullscreen) element.msRequestFullscreen(); // IE/Edge
    },
    deactivate: function() {
        if (document.exitFullscreen) document.exitFullscreen();
        else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
        else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
    }
};




var $ff99a469cddfda5d$export$9e844f8a53211d5 = /*#__PURE__*/ function() {
    "use strict";
    function Slideshow(fancybox) {
        (0, $748c5547edb8a18d$export$71511d61b312f219)(this, Slideshow);
        this.fancybox = fancybox;
        this.active = false;
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
    }
    (0, $c95e6614e27503ea$export$71511d61b312f219)(Slideshow, [
        {
            key: "isActive",
            value: function isActive() {
                return this.active;
            }
        },
        {
            key: "setTimer",
            value: function setTimer() {
                var _this = this;
                if (!this.active || this.timer) return;
                var delay = this.fancybox.option("slideshow.delay", 3000);
                this.timer = setTimeout(function() {
                    _this.timer = null;
                    if (!_this.fancybox.option("infinite") && _this.fancybox.getSlide().index === _this.fancybox.Carousel.slides.length - 1) _this.fancybox.jumpTo(0, {
                        friction: 0
                    });
                    else _this.fancybox.next();
                }, delay);
                var $progress = this.$progress;
                if (!$progress) {
                    $progress = document.createElement("div");
                    $progress.classList.add("fancybox__progress");
                    this.fancybox.$carousel.parentNode.insertBefore($progress, this.fancybox.$carousel);
                    this.$progress = $progress;
                    $progress.offsetHeight; /* trigger reflow */ 
                }
                $progress.style.transitionDuration = "".concat(delay, "ms");
                $progress.style.transform = "scaleX(1)";
            }
        },
        {
            key: "clearTimer",
            value: function clearTimer() {
                clearTimeout(this.timer);
                this.timer = null;
                if (this.$progress) {
                    this.$progress.style.transitionDuration = "";
                    this.$progress.style.transform = "";
                    this.$progress.offsetHeight; /* trigger reflow */ 
                }
            }
        },
        {
            key: "activate",
            value: function activate() {
                if (this.active) return;
                this.active = true;
                this.fancybox.$container.classList.add("has-slideshow");
                if (this.fancybox.getSlide().state === "done") this.setTimer();
                document.addEventListener("visibilitychange", this.handleVisibilityChange, false);
            }
        },
        {
            key: "handleVisibilityChange",
            value: function handleVisibilityChange() {
                this.deactivate();
            }
        },
        {
            key: "deactivate",
            value: function deactivate() {
                this.active = false;
                this.clearTimer();
                this.fancybox.$container.classList.remove("has-slideshow");
                document.removeEventListener("visibilitychange", this.handleVisibilityChange, false);
            }
        },
        {
            key: "toggle",
            value: function toggle() {
                if (this.active) this.deactivate();
                else if (this.fancybox.Carousel.slides.length > 1) this.activate();
            }
        }
    ]);
    return Slideshow;
}();


var $b514db933c4604e3$var$defaults = {
    // What toolbar items to display
    display: [
        "counter",
        //"prev",
        //"next",
        //"download",
        "zoom",
        "slideshow",
        "fullscreen",
        "thumbs",
        "close"
    ],
    // Only create a toolbar item if there is at least one image in the group
    autoEnable: true,
    // Toolbar items; can be links, buttons or `div` elements
    items: {
        counter: {
            position: "left",
            type: "div",
            "class": "fancybox__counter",
            html: '<span data-fancybox-index=""></span>&nbsp;/&nbsp;<span data-fancybox-count=""></span>',
            attr: {
                tabindex: -1
            }
        },
        prev: {
            type: "button",
            "class": "fancybox__button--prev",
            label: "PREV",
            html: '<svg viewBox="0 0 24 24"><path d="M15 4l-8 8 8 8"/></svg>',
            attr: {
                "data-fancybox-prev": ""
            }
        },
        next: {
            type: "button",
            "class": "fancybox__button--next",
            label: "NEXT",
            html: '<svg viewBox="0 0 24 24"><path d="M8 4l8 8-8 8"/></svg>',
            attr: {
                "data-fancybox-next": ""
            }
        },
        fullscreen: {
            type: "button",
            "class": "fancybox__button--fullscreen",
            label: "TOGGLE_FULLSCREEN",
            html: '<svg viewBox="0 0 24 24">\n                <g><path d="M3 8 V3h5"></path><path d="M21 8V3h-5"></path><path d="M8 21H3v-5"></path><path d="M16 21h5v-5"></path></g>\n                <g><path d="M7 2v5H2M17 2v5h5M2 17h5v5M22 17h-5v5"/></g>\n            </svg>',
            click: function click(event) {
                event.preventDefault();
                if ((0, $cc6ce4d2f52426f7$export$159cd03be7087f39).element()) (0, $cc6ce4d2f52426f7$export$159cd03be7087f39).deactivate();
                else (0, $cc6ce4d2f52426f7$export$159cd03be7087f39).activate(this.fancybox.$container);
            }
        },
        slideshow: {
            type: "button",
            "class": "fancybox__button--slideshow",
            label: "TOGGLE_SLIDESHOW",
            html: '<svg viewBox="0 0 24 24">\n                <g><path d="M6 4v16"/><path d="M20 12L6 20"/><path d="M20 12L6 4"/></g>\n                <g><path d="M7 4v15M17 4v15"/></g>\n            </svg>',
            click: function click(event) {
                event.preventDefault();
                this.Slideshow.toggle();
            }
        },
        zoom: {
            type: "button",
            "class": "fancybox__button--zoom",
            label: "TOGGLE_ZOOM",
            html: '<svg viewBox="0 0 24 24"><circle cx="10" cy="10" r="7"></circle><path d="M16 16 L21 21"></svg>',
            click: function click(event) {
                event.preventDefault();
                var panzoom = this.fancybox.getSlide().Panzoom;
                if (panzoom) panzoom.toggleZoom();
            }
        },
        download: {
            type: "link",
            label: "DOWNLOAD",
            "class": "fancybox__button--download",
            html: '<svg viewBox="0 0 24 24"><path d="M12 15V3m0 12l-4-4m4 4l4-4M2 17l.62 2.48A2 2 0 004.56 21h14.88a2 2 0 001.94-1.51L22 17"/></svg>',
            click: function click(event) {
                event.stopPropagation();
            }
        },
        thumbs: {
            type: "button",
            label: "TOGGLE_THUMBS",
            "class": "fancybox__button--thumbs",
            html: '<svg viewBox="0 0 24 24"><circle cx="4" cy="4" r="1" /><circle cx="12" cy="4" r="1" transform="rotate(90 12 4)"/><circle cx="20" cy="4" r="1" transform="rotate(90 20 4)"/><circle cx="4" cy="12" r="1" transform="rotate(90 4 12)"/><circle cx="12" cy="12" r="1" transform="rotate(90 12 12)"/><circle cx="20" cy="12" r="1" transform="rotate(90 20 12)"/><circle cx="4" cy="20" r="1" transform="rotate(90 4 20)"/><circle cx="12" cy="20" r="1" transform="rotate(90 12 20)"/><circle cx="20" cy="20" r="1" transform="rotate(90 20 20)"/></svg>',
            click: function click(event) {
                event.stopPropagation();
                var thumbs = this.fancybox.plugins.Thumbs;
                if (thumbs) thumbs.toggle();
            }
        },
        close: {
            type: "button",
            label: "CLOSE",
            "class": "fancybox__button--close",
            html: '<svg viewBox="0 0 24 24"><path d="M20 20L4 4m16 0L4 20"></path></svg>',
            attr: {
                "data-fancybox-close": "",
                tabindex: 0
            }
        }
    }
};
var $b514db933c4604e3$export$4c260019440d418f = /*#__PURE__*/ function() {
    "use strict";
    function Toolbar(fancybox) {
        var _this = this;
        (0, $748c5547edb8a18d$export$71511d61b312f219)(this, Toolbar);
        this.fancybox = fancybox;
        this.$container = null;
        this.state = "init";
        for(var _i = 0, _iter = [
            "onInit",
            "onPrepare",
            "onDone",
            "onKeydown",
            "onClosing",
            "onChange",
            "onSettle",
            "onRefresh"
        ]; _i < _iter.length; _i++){
            var methodName = _iter[_i];
            this[methodName] = this[methodName].bind(this);
        }
        this.events = {
            init: this.onInit,
            prepare: this.onPrepare,
            done: this.onDone,
            keydown: this.onKeydown,
            closing: this.onClosing,
            // Clear Slideshow when user strts to change current slide
            "Carousel.change": this.onChange,
            // Set timer after carousel changes current slide; deactive if last slide is reached
            "Carousel.settle": this.onSettle,
            // Deactivate Slideshow on user interaction
            "Carousel.Panzoom.touchStart": function() {
                return _this.onRefresh();
            },
            "Image.startAnimation": function(fancybox, slide) {
                return _this.onRefresh(slide);
            },
            "Image.afterUpdate": function(fancybox, slide) {
                return _this.onRefresh(slide);
            }
        };
    }
    (0, $c95e6614e27503ea$export$71511d61b312f219)(Toolbar, [
        {
            key: "onInit",
            value: function onInit() {
                // Disable self if current group does not contain at least one image
                if (this.fancybox.option("Toolbar.autoEnable")) {
                    var hasImage = false;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = this.fancybox.items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var item = _step.value;
                            if (item.type === "image") {
                                hasImage = true;
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    if (!hasImage) {
                        this.state = "disabled";
                        return;
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    // Disable the creation of a close button, if one exists in the toolbar
                    for(var _iterator1 = this.fancybox.option("Toolbar.display")[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var key = _step1.value;
                        var id = (0, $66f4d3fde35745bd$export$53b83ca8eaab0383)(key) ? key.id : key;
                        if (id === "close") {
                            this.fancybox.options.closeButton = false;
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                            _iterator1["return"]();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        },
        {
            key: "onPrepare",
            value: function onPrepare() {
                var fancybox = this.fancybox;
                // Skip if disabled
                if (this.state !== "init") return;
                this.build();
                this.update();
                this.Slideshow = new (0, $ff99a469cddfda5d$export$9e844f8a53211d5)(fancybox);
                if (!fancybox.Carousel.prevPage) {
                    if (fancybox.option("slideshow.autoStart")) this.Slideshow.activate();
                    if (fancybox.option("fullscreen.autoStart") && !(0, $cc6ce4d2f52426f7$export$159cd03be7087f39).element()) try {
                        (0, $cc6ce4d2f52426f7$export$159cd03be7087f39).activate(fancybox.$container);
                    } catch (error) {}
                }
            }
        },
        {
            key: "onFsChange",
            value: function onFsChange() {
                window.scrollTo((0, $cc6ce4d2f52426f7$export$159cd03be7087f39).pageXOffset, (0, $cc6ce4d2f52426f7$export$159cd03be7087f39).pageYOffset);
            }
        },
        {
            key: "onSettle",
            value: function onSettle() {
                var fancybox = this.fancybox;
                var slideshow = this.Slideshow;
                if (slideshow && slideshow.isActive()) {
                    if (fancybox.getSlide().index === fancybox.Carousel.slides.length - 1 && !fancybox.option("infinite")) slideshow.deactivate();
                    else if (fancybox.getSlide().state === "done") slideshow.setTimer();
                }
            }
        },
        {
            key: "onChange",
            value: function onChange() {
                this.update();
                if (this.Slideshow && this.Slideshow.isActive()) this.Slideshow.clearTimer();
            }
        },
        {
            key: "onDone",
            value: function onDone(fancybox, slide) {
                var slideshow = this.Slideshow;
                if (slide.index === fancybox.getSlide().index) {
                    this.update();
                    if (slideshow && slideshow.isActive()) {
                        if (!fancybox.option("infinite") && slide.index === fancybox.Carousel.slides.length - 1) slideshow.deactivate();
                        else slideshow.setTimer();
                    }
                }
            }
        },
        {
            key: "onRefresh",
            value: function onRefresh(slide) {
                if (!slide || slide.index === this.fancybox.getSlide().index) {
                    this.update();
                    if (this.Slideshow && this.Slideshow.isActive() && (!slide || slide.state === "done")) this.Slideshow.deactivate();
                }
            }
        },
        {
            key: "onKeydown",
            value: function onKeydown(fancybox, key, event) {
                if (key === " " && this.Slideshow) {
                    this.Slideshow.toggle();
                    event.preventDefault();
                }
            }
        },
        {
            key: "onClosing",
            value: function onClosing() {
                if (this.Slideshow) this.Slideshow.deactivate();
                document.removeEventListener("fullscreenchange", this.onFsChange);
            }
        },
        {
            /**
   * Create link, button or `div` element for the toolbar
   * @param {Object} obj
   * @returns HTMLElement
   */ key: "createElement",
            value: function createElement(obj) {
                var _$el_classList;
                var $el;
                if (obj.type === "div") $el = document.createElement("div");
                else {
                    $el = document.createElement(obj.type === "link" ? "a" : "button");
                    $el.classList.add("carousel__button");
                }
                $el.innerHTML = obj.html;
                $el.setAttribute("tabindex", obj.tabindex || 0);
                if (obj["class"]) (_$el_classList = $el.classList).add.apply(_$el_classList, (0, $b6a26340ba3e8c80$export$71511d61b312f219)(obj["class"].split(" ")));
                for(var prop in obj.attr)$el.setAttribute(prop, obj.attr[prop]);
                if (obj.label) $el.setAttribute("title", this.fancybox.localize("{{".concat(obj.label, "}}")));
                if (obj.click) $el.addEventListener("click", obj.click.bind(this));
                if (obj.id === "prev") $el.setAttribute("data-fancybox-prev", "");
                if (obj.id === "next") $el.setAttribute("data-fancybox-next", "");
                var $svg = $el.querySelector("svg");
                if ($svg) {
                    $svg.setAttribute("role", "img");
                    $svg.setAttribute("tabindex", "-1");
                    $svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
                }
                return $el;
            }
        },
        {
            /**
   * Create all DOM elements
   */ key: "build",
            value: function build() {
                this.cleanup();
                var all_items = this.fancybox.option("Toolbar.items");
                var all_groups = [
                    {
                        position: "left",
                        items: []
                    },
                    {
                        position: "center",
                        items: []
                    },
                    {
                        position: "right",
                        items: []
                    }
                ];
                var thumbs = this.fancybox.plugins.Thumbs;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    var _this, _loop = function() {
                        var key = _step.value;
                        var id = void 0, item = void 0;
                        if ((0, $66f4d3fde35745bd$export$53b83ca8eaab0383)(key)) {
                            id = key.id;
                            item = (0, $473ff96f0aaf0a3a$export$8b58be045bf06082)({}, all_items[id], key);
                        } else {
                            id = key;
                            item = all_items[id];
                        }
                        if ([
                            "counter",
                            "next",
                            "prev",
                            "slideshow"
                        ].includes(id) && _this.fancybox.items.length < 2) return "continue";
                        if (id === "fullscreen") {
                            if (!document.fullscreenEnabled || window.fullScreen) return "continue";
                            document.addEventListener("fullscreenchange", _this.onFsChange);
                        }
                        if (id === "thumbs" && (!thumbs || thumbs.state === "disabled")) return "continue";
                        if (!item) return "continue";
                        var position = item.position || "right";
                        var group = all_groups.find(function(obj) {
                            return obj.position === position;
                        });
                        if (group) group.items.push(item);
                    };
                    // 1st step - group toolbar elements by position
                    for(var _iterator = this.fancybox.option("Toolbar.display")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_this = this, _loop();
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                // 2st step - create DOM elements
                var $container = document.createElement("div");
                $container.classList.add("fancybox__toolbar");
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = all_groups[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var group = _step1.value;
                        if (group.items.length) {
                            var $wrap = document.createElement("div");
                            $wrap.classList.add("fancybox__toolbar__items");
                            $wrap.classList.add("fancybox__toolbar__items--".concat(group.position));
                            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                            try {
                                for(var _iterator2 = group.items[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                    var obj = _step2.value;
                                    $wrap.appendChild(this.createElement(obj));
                                }
                            } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                                        _iterator2["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError2) {
                                        throw _iteratorError2;
                                    }
                                }
                            }
                            $container.appendChild($wrap);
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                            _iterator1["return"]();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                // Add toolbar container to DOM
                this.fancybox.$carousel.parentNode.insertBefore($container, this.fancybox.$carousel);
                this.$container = $container;
            }
        },
        {
            /**
   * Update element state depending on index of current slide
   */ key: "update",
            value: function update() {
                var slide = this.fancybox.getSlide();
                var idx = slide.index;
                var cnt = this.fancybox.items.length;
                // Download links
                // ====
                var src = slide.downloadSrc || (slide.type === "image" && !slide.error ? slide.src : null);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.fancybox.$container.querySelectorAll("a.fancybox__button--download")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var $el = _step.value;
                        if (src) {
                            $el.removeAttribute("disabled");
                            $el.removeAttribute("tabindex");
                            $el.setAttribute("href", src);
                            $el.setAttribute("download", src);
                            $el.setAttribute("target", "_blank");
                        } else {
                            $el.setAttribute("disabled", "");
                            $el.setAttribute("tabindex", -1);
                            $el.removeAttribute("href");
                            $el.removeAttribute("download");
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                // Zoom button
                // ===
                var panzoom = slide.Panzoom;
                var canZoom = panzoom && panzoom.option("maxScale") > panzoom.option("baseScale");
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = this.fancybox.$container.querySelectorAll(".fancybox__button--zoom")[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var $el1 = _step1.value;
                        if (canZoom) $el1.removeAttribute("disabled");
                        else $el1.setAttribute("disabled", "");
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                            _iterator1["return"]();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                try {
                    // Counter
                    // ====
                    for(var _iterator2 = this.fancybox.$container.querySelectorAll("[data-fancybox-index]")[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                        var $el2 = _step2.value;
                        $el2.innerHTML = slide.index + 1;
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                            _iterator2["return"]();
                        }
                    } finally{
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
                var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                try {
                    for(var _iterator3 = this.fancybox.$container.querySelectorAll("[data-fancybox-count]")[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                        var $el3 = _step3.value;
                        $el3.innerHTML = cnt;
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
                            _iterator3["return"]();
                        }
                    } finally{
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
                // Disable previous/next links if gallery is not infinite and has reached start/end
                // ===
                if (!this.fancybox.option("infinite")) {
                    var _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
                    try {
                        for(var _iterator4 = this.fancybox.$container.querySelectorAll("[data-fancybox-prev]")[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true){
                            var $el4 = _step4.value;
                            if (idx === 0) $el4.setAttribute("disabled", "");
                            else $el4.removeAttribute("disabled");
                        }
                    } catch (err) {
                        _didIteratorError4 = true;
                        _iteratorError4 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion4 && _iterator4["return"] != null) {
                                _iterator4["return"]();
                            }
                        } finally{
                            if (_didIteratorError4) {
                                throw _iteratorError4;
                            }
                        }
                    }
                    var _iteratorNormalCompletion5 = true, _didIteratorError5 = false, _iteratorError5 = undefined;
                    try {
                        for(var _iterator5 = this.fancybox.$container.querySelectorAll("[data-fancybox-next]")[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true){
                            var $el5 = _step5.value;
                            if (idx === cnt - 1) $el5.setAttribute("disabled", "");
                            else $el5.removeAttribute("disabled");
                        }
                    } catch (err) {
                        _didIteratorError5 = true;
                        _iteratorError5 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion5 && _iterator5["return"] != null) {
                                _iterator5["return"]();
                            }
                        } finally{
                            if (_didIteratorError5) {
                                throw _iteratorError5;
                            }
                        }
                    }
                }
            }
        },
        {
            key: "cleanup",
            value: function cleanup() {
                if (this.Slideshow && this.Slideshow.isActive()) this.Slideshow.clearTimer();
                if (this.$container) this.$container.remove();
                this.$container = null;
            }
        },
        {
            key: "attach",
            value: function attach() {
                this.fancybox.on(this.events);
            }
        },
        {
            key: "detach",
            value: function detach() {
                this.fancybox.off(this.events);
                this.cleanup();
            }
        }
    ]);
    return Toolbar;
}();
// Expose defaults
$b514db933c4604e3$export$4c260019440d418f.defaults = $b514db933c4604e3$var$defaults;


var $363ed6cefe758d79$export$c203ca0aafe4939a = {
    ScrollLock: (0, $d5cc0f2be00b0b23$export$43c4ad2b7f26555a),
    Thumbs: (0, $a13d8c14ffa4a792$export$73e055b807a6709),
    Html: (0, $d58512219d95ad81$export$13f9d3c4397c4713),
    Toolbar: (0, $b514db933c4604e3$export$4c260019440d418f),
    Image: (0, $cbfb096d34afb745$export$3e431a229df88919),
    Hash: (0, $d62af170a2423346$export$ab85ecd77ce6a5cd)
};


var $457f0c69ae322ba4$export$2e2bcd8739ae039 = {
    CLOSE: "Close",
    NEXT: "Next",
    PREV: "Previous",
    MODAL: "You can close this modal content with the ESC key",
    ERROR: "Something Went Wrong, Please Try Again Later",
    IMAGE_ERROR: "Image Not Found",
    ELEMENT_NOT_FOUND: "HTML Element Not Found",
    AJAX_NOT_FOUND: "Error Loading AJAX : Not Found",
    AJAX_FORBIDDEN: "Error Loading AJAX : Forbidden",
    IFRAME_ERROR: "Error Loading Page",
    TOGGLE_ZOOM: "Toggle zoom level",
    TOGGLE_THUMBS: "Toggle thumbnails",
    TOGGLE_SLIDESHOW: "Toggle slideshow",
    TOGGLE_FULLSCREEN: "Toggle full-screen mode",
    DOWNLOAD: "Download"
};


// Default settings
var $df5a56240bf9e90a$var$defaults = {
    // Index of active slide on the start
    startIndex: 0,
    // Number of slides to preload before and after active slide
    preload: 1,
    // Should navigation be infinite
    infinite: true,
    // Class name to be applied to the content to reveal it
    showClass: "fancybox-zoomInUp",
    // Class name to be applied to the content to hide it
    hideClass: "fancybox-fadeOut",
    // Should backdrop and UI elements fade in/out on start/close
    animated: true,
    // If browser scrollbar should be hidden
    hideScrollbar: true,
    // Element containing main structure
    parentEl: null,
    // Custom class name or multiple space-separated class names for the container
    mainClass: null,
    // Set focus on first focusable element after displaying content
    autoFocus: true,
    // Trap focus inside Fancybox
    trapFocus: true,
    // Set focus back to trigger element after closing Fancybox
    placeFocusBack: true,
    // Action to take when the user clicks on the backdrop
    click: "close",
    // Position of the close button - over the content or at top right corner of viewport
    closeButton: "inside",
    // Allow user to drag content up/down to close instance
    dragToClose: true,
    // Enable keyboard navigation
    keyboard: {
        Escape: "close",
        Delete: "close",
        Backspace: "close",
        PageUp: "next",
        PageDown: "prev",
        ArrowUp: "next",
        ArrowDown: "prev",
        ArrowRight: "next",
        ArrowLeft: "prev"
    },
    // HTML templates for various elements
    template: {
        // Close button icon
        closeButton: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M20 20L4 4m16 0L4 20"/></svg>',
        // Loading indicator icon
        spinner: '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="25 25 50 50" tabindex="-1"><circle cx="50" cy="50" r="20"/></svg>',
        // Main container element
        main: null
    },
    /* Note: If the `template.main` option is not provided, the structure is generated as follows by default:
  <div class="fancybox__container" role="dialog" aria-modal="true" aria-hidden="true" aria-label="{{MODAL}}" tabindex="-1">
    <div class="fancybox__backdrop"></div>
    <div class="fancybox__carousel"></div>
  </div>
  */ // Localization of strings
    l10n: (0, $457f0c69ae322ba4$export$2e2bcd8739ae039)
};
// Object that contains all active instances of Fancybox
var $df5a56240bf9e90a$var$instances = new Map();
// Number of Fancybox instances created, it is used to generate new instance "id"
var $df5a56240bf9e90a$var$called = 0;
var $df5a56240bf9e90a$export$cb45b08d97cdc4fd = /*#__PURE__*/ function(Base) {
    "use strict";
    (0, $1e7277e0f02f2550$export$71511d61b312f219)(Fancybox, Base);
    function Fancybox(items) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $748c5547edb8a18d$export$71511d61b312f219)(this, Fancybox);
        var _this;
        // Quick hack to fix variable naming collision
        items = items.map(function(item) {
            if (item.width) item._width = item.width;
            if (item.height) item._height = item.height;
            return item;
        });
        _this = (0, $c1745da3357c8fcc$export$71511d61b312f219)(this, Fancybox, [
            (0, $473ff96f0aaf0a3a$export$8b58be045bf06082)(true, {}, $df5a56240bf9e90a$var$defaults, options)
        ]);
        _this.bindHandlers();
        _this.state = "init";
        _this.setItems(items);
        _this.attachPlugins(Fancybox.Plugins);
        // "init" event marks the start of initialization and is available to plugins
        _this.trigger("init");
        if (_this.option("hideScrollbar") === true) _this.hideScrollbar();
        _this.initLayout();
        _this.initCarousel();
        _this.attachEvents();
        $df5a56240bf9e90a$var$instances.set(_this.id, _this);
        // "prepare" event will trigger the creation of additional layout elements, such as thumbnails and toolbar
        _this.trigger("prepare");
        _this.state = "ready";
        // "ready" event will trigger the content to load
        _this.trigger("ready");
        // Reveal container
        _this.$container.setAttribute("aria-hidden", "false");
        // Set focus on the first focusable element inside this instance
        if (_this.option("trapFocus")) _this.focus();
        return _this;
    }
    (0, $c95e6614e27503ea$export$71511d61b312f219)(Fancybox, [
        {
            /**
   * Override `option` method to get value from the current slide
   * @param {String} name option name
   * @param  {...any} rest optional extra parameters
   * @returns {any}
   */ key: "option",
            value: function option(name) {
                for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    rest[_key - 1] = arguments[_key];
                }
                var _$_get;
                var slide = this.getSlide();
                var value = slide ? slide[name] : undefined;
                if (value !== undefined) {
                    var _value;
                    if (typeof value === "function") value = (_value = value).call.apply(_value, [
                        this,
                        this
                    ].concat((0, $b6a26340ba3e8c80$export$71511d61b312f219)(rest)));
                    return value;
                }
                return (_$_get = (0, $c5cff198ab2b9e8e$export$71511d61b312f219)((0, $9577490cbbab44e8$export$71511d61b312f219)(Fancybox.prototype), "option", this)).call.apply(_$_get, [
                    this,
                    name
                ].concat((0, $b6a26340ba3e8c80$export$71511d61b312f219)(rest)));
            }
        },
        {
            /**
   * Bind event handlers for referencability
   */ key: "bindHandlers",
            value: function bindHandlers() {
                for(var _i = 0, _iter = [
                    "onMousedown",
                    "onKeydown",
                    "onClick",
                    "onFocus",
                    "onCreateSlide",
                    "onSettle",
                    "onTouchMove",
                    "onTouchEnd",
                    "onTransform"
                ]; _i < _iter.length; _i++){
                    var methodName = _iter[_i];
                    this[methodName] = this[methodName].bind(this);
                }
            }
        },
        {
            /**
   * Set up a functions that will be called whenever the specified event is delivered
   */ key: "attachEvents",
            value: function attachEvents() {
                document.addEventListener("mousedown", this.onMousedown);
                document.addEventListener("keydown", this.onKeydown, true);
                // Trap keyboard focus inside of the modal
                if (this.option("trapFocus")) document.addEventListener("focus", this.onFocus, true);
                this.$container.addEventListener("click", this.onClick);
            }
        },
        {
            /**
   * Removes previously registered event listeners
   */ key: "detachEvents",
            value: function detachEvents() {
                document.removeEventListener("mousedown", this.onMousedown);
                document.removeEventListener("keydown", this.onKeydown, true);
                document.removeEventListener("focus", this.onFocus, true);
                this.$container.removeEventListener("click", this.onClick);
            }
        },
        {
            /**
   * Initialize layout; create main container, backdrop nd layout for main carousel
   */ key: "initLayout",
            value: function initLayout() {
                var _this = this;
                var _this_$container, _this_$container_classList;
                this.$root = this.option("parentEl") || document.body;
                // Container
                var mainTemplate = this.option("template.main");
                if (mainTemplate) {
                    this.$root.insertAdjacentHTML("beforeend", this.localize(mainTemplate));
                    this.$container = this.$root.querySelector(".fancybox__container");
                }
                if (!this.$container) {
                    this.$container = document.createElement("div");
                    this.$root.appendChild(this.$container);
                }
                // Normally we would not need this, but Safari does not support `preventScroll:false` option for `focus` method
                // and that causes layout issues
                this.$container.onscroll = function() {
                    _this.$container.scrollLeft = 0;
                    return false;
                };
                Object.entries({
                    "class": "fancybox__container",
                    role: "dialog",
                    tabIndex: "-1",
                    "aria-modal": "true",
                    "aria-hidden": "true",
                    "aria-label": this.localize("{{MODAL}}")
                }).forEach(function(args) {
                    return (_this_$container = _this.$container).setAttribute.apply(_this_$container, (0, $b6a26340ba3e8c80$export$71511d61b312f219)(args));
                });
                if (this.option("animated")) this.$container.classList.add("is-animated");
                // Backdrop
                this.$backdrop = this.$container.querySelector(".fancybox__backdrop");
                if (!this.$backdrop) {
                    this.$backdrop = document.createElement("div");
                    this.$backdrop.classList.add("fancybox__backdrop");
                    this.$container.appendChild(this.$backdrop);
                }
                // Carousel
                this.$carousel = this.$container.querySelector(".fancybox__carousel");
                if (!this.$carousel) {
                    this.$carousel = document.createElement("div");
                    this.$carousel.classList.add("fancybox__carousel");
                    this.$container.appendChild(this.$carousel);
                }
                // Make instance reference accessible
                this.$container.Fancybox = this;
                // Make sure the container has an ID
                this.id = this.$container.getAttribute("id");
                if (!this.id) {
                    this.id = this.options.id || ++$df5a56240bf9e90a$var$called;
                    this.$container.setAttribute("id", "fancybox-" + this.id);
                }
                // Add custom class name to main element
                var mainClass = this.option("mainClass");
                if (mainClass) (_this_$container_classList = this.$container.classList).add.apply(_this_$container_classList, (0, $b6a26340ba3e8c80$export$71511d61b312f219)(mainClass.split(" ")));
                // Add class name for <html> element
                document.documentElement.classList.add("with-fancybox");
                this.trigger("initLayout");
                return this;
            }
        },
        {
            /**
   * Prepares slides for the corousel
   * @returns {Array} Slides
   */ key: "setItems",
            value: function setItems(items) {
                var slides = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var slide = _step.value;
                        var $trigger = slide.$trigger;
                        if ($trigger) {
                            var dataset = $trigger.dataset || {};
                            slide.src = dataset.src || $trigger.getAttribute("href") || slide.src;
                            slide.type = dataset.type || slide.type;
                            // Support items without `src`, e.g., when `data-fancybox` attribute added directly to `<img>` element
                            if (!slide.src && $trigger instanceof HTMLImageElement) slide.src = $trigger.currentSrc || slide.$trigger.src;
                        }
                        // Check for thumbnail element
                        var $thumb = slide.$thumb;
                        if (!$thumb) {
                            var origTarget = slide.$trigger && slide.$trigger.origTarget;
                            if (origTarget) {
                                if (origTarget instanceof HTMLImageElement) $thumb = origTarget;
                                else $thumb = origTarget.querySelector("img:not([aria-hidden])");
                            }
                            if (!$thumb && slide.$trigger) $thumb = slide.$trigger instanceof HTMLImageElement ? slide.$trigger : slide.$trigger.querySelector("img:not([aria-hidden])");
                        }
                        slide.$thumb = $thumb || null;
                        // Get thumbnail image source
                        var thumb = slide.thumb;
                        if (!thumb && $thumb) {
                            thumb = $thumb.currentSrc || $thumb.src;
                            if (!thumb && $thumb.dataset) thumb = $thumb.dataset.lazySrc || $thumb.dataset.src;
                        }
                        // Assume we have image, then use it as thumbnail
                        if (!thumb && slide.type === "image") thumb = slide.src;
                        slide.thumb = thumb || null;
                        // Add empty caption to make things simpler
                        slide.caption = slide.caption || "";
                        slides.push(slide);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.items = slides;
            }
        },
        {
            /**
   * Initialize main Carousel that will be used to display the content
   * @param {Array} slides
   */ key: "initCarousel",
            value: function initCarousel() {
                var _this = this;
                var _this1 = this;
                this.Carousel = new (0, $ddbfb93057510fe5$export$144901db2ea8e967)(this.$carousel, (0, $473ff96f0aaf0a3a$export$8b58be045bf06082)(true, {}, {
                    prefix: "",
                    classNames: {
                        viewport: "fancybox__viewport",
                        track: "fancybox__track",
                        slide: "fancybox__slide"
                    },
                    textSelection: true,
                    preload: this.option("preload"),
                    friction: 0.88,
                    slides: this.items,
                    initialPage: this.options.startIndex,
                    slidesPerPage: 1,
                    infiniteX: this.option("infinite"),
                    infiniteY: true,
                    l10n: this.option("l10n"),
                    Dots: false,
                    Navigation: {
                        classNames: {
                            main: "fancybox__nav",
                            button: "carousel__button",
                            next: "is-next",
                            prev: "is-prev"
                        }
                    },
                    Panzoom: {
                        textSelection: true,
                        panOnlyZoomed: function() {
                            return _this.Carousel && _this.Carousel.pages && _this.Carousel.pages.length < 2 && !_this.option("dragToClose");
                        },
                        lockAxis: function() {
                            if (_this.Carousel) {
                                var rez = "x";
                                if (_this.option("dragToClose")) rez += "y";
                                return rez;
                            }
                        }
                    },
                    on: {
                        "*": function(name) {
                            for(var _len = arguments.length, details = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                                details[_key - 1] = arguments[_key];
                            }
                            return _this1.trigger.apply(_this1, [
                                "Carousel.".concat(name)
                            ].concat((0, $b6a26340ba3e8c80$export$71511d61b312f219)(details)));
                        },
                        init: function(carousel) {
                            return _this.Carousel = carousel;
                        },
                        createSlide: this.onCreateSlide,
                        settle: this.onSettle
                    }
                }, this.option("Carousel")));
                if (this.option("dragToClose")) this.Carousel.Panzoom.on({
                    // Stop further touch event handling if content is scaled
                    touchMove: this.onTouchMove,
                    // Update backdrop opacity depending on vertical distance
                    afterTransform: this.onTransform,
                    // Close instance if drag distance exceeds limit
                    touchEnd: this.onTouchEnd
                });
                this.trigger("initCarousel");
                return this;
            }
        },
        {
            /**
   * Process `createSlide` event to create caption element inside new slide
   */ key: "onCreateSlide",
            value: function onCreateSlide(carousel, slide) {
                var caption = slide.caption || "";
                if (typeof this.options.caption === "function") caption = this.options.caption.call(this, this, this.Carousel, slide);
                if (typeof caption === "string" && caption.length) {
                    var $caption = document.createElement("div");
                    var id = "fancybox__caption_".concat(this.id, "_").concat(slide.index);
                    $caption.className = "fancybox__caption";
                    $caption.innerHTML = caption;
                    $caption.setAttribute("id", id);
                    slide.$caption = slide.$el.appendChild($caption);
                    slide.$el.classList.add("has-caption");
                    slide.$el.setAttribute("aria-labelledby", id);
                }
            }
        },
        {
            /**
   * Handle Carousel `settle` event
   */ key: "onSettle",
            value: function onSettle() {
                if (this.option("autoFocus")) this.focus();
            }
        },
        {
            /**
   * Handle focus event
   * @param {Event} event - Focus event
   */ key: "onFocus",
            value: function onFocus(event) {
                if (!this.isTopmost()) return;
                this.focus(event);
            }
        },
        {
            /**
   * Handle click event on the container
   * @param {Event} event - Click event
   */ key: "onClick",
            value: function onClick(event) {
                if (event.defaultPrevented) return;
                var eventTarget = event.composedPath()[0];
                if (eventTarget.matches("[data-fancybox-close]")) {
                    event.preventDefault();
                    Fancybox.close(false, event);
                    return;
                }
                if (eventTarget.matches("[data-fancybox-next]")) {
                    event.preventDefault();
                    Fancybox.next();
                    return;
                }
                if (eventTarget.matches("[data-fancybox-prev]")) {
                    event.preventDefault();
                    Fancybox.prev();
                    return;
                }
                var activeElement = document.activeElement;
                if (activeElement) {
                    if (activeElement.closest("[contenteditable]")) return;
                    if (!eventTarget.matches((0, $eb0b16180e564216$export$6a59c51278cd7bb1))) activeElement.blur();
                }
                // Skip if clicked inside content area
                if (eventTarget.closest(".fancybox__content")) return;
                // Skip if text is selected
                if (getSelection().toString().length) return;
                if (this.trigger("click", event) === false) return;
                var action = this.option("click");
                switch(action){
                    case "close":
                        this.close();
                        break;
                    case "next":
                        this.next();
                        break;
                }
            }
        },
        {
            /**
   * Handle panzoom `touchMove` event; Disable dragging if content of current slide is scaled
   */ key: "onTouchMove",
            value: function onTouchMove() {
                var panzoom = this.getSlide().Panzoom;
                return panzoom && panzoom.content.scale !== 1 ? false : true;
            }
        },
        {
            /**
   * Handle panzoom `touchEnd` event; close when quick flick up/down is detected
   * @param {Object} panzoom - Panzoom instance
   */ key: "onTouchEnd",
            value: function onTouchEnd(panzoom) {
                var distanceY = panzoom.dragOffset.y;
                if (Math.abs(distanceY) >= 150 || Math.abs(distanceY) >= 35 && panzoom.dragOffset.time < 350) {
                    if (this.option("hideClass")) this.getSlide().hideClass = "fancybox-throwOut".concat(panzoom.content.y < 0 ? "Up" : "Down");
                    this.close();
                } else if (panzoom.lockAxis === "y") panzoom.panTo({
                    y: 0
                });
            }
        },
        {
            /**
   * Handle `afterTransform` event; change backdrop opacity based on current y position of panzoom
   * @param {Object} panzoom - Panzoom instance
   */ key: "onTransform",
            value: function onTransform(panzoom) {
                var $backdrop = this.$backdrop;
                if ($backdrop) {
                    var yPos = Math.abs(panzoom.content.y);
                    var opacity = yPos < 1 ? "" : Math.max(0.33, Math.min(1, 1 - yPos / panzoom.content.fitHeight * 1.5));
                    this.$container.style.setProperty("--fancybox-ts", opacity ? "0s" : "");
                    this.$container.style.setProperty("--fancybox-opacity", opacity);
                }
            }
        },
        {
            /**
   * Handle `mousedown` event to mark that the mouse is in use
   */ key: "onMousedown",
            value: function onMousedown() {
                if (this.state === "ready") document.body.classList.add("is-using-mouse");
            }
        },
        {
            /**
   * Handle `keydown` event; trap focus
   * @param {Event} event Keydown event
   */ key: "onKeydown",
            value: function onKeydown(event) {
                if (!this.isTopmost()) return;
                document.body.classList.remove("is-using-mouse");
                var key = event.key;
                var keyboard = this.option("keyboard");
                if (!keyboard || event.ctrlKey || event.altKey || event.shiftKey) return;
                var target = event.composedPath()[0];
                var classList = document.activeElement && document.activeElement.classList;
                var isUIElement = classList && classList.contains("carousel__button");
                // Allow to close using Escape button
                if (key !== "Escape" && !isUIElement) {
                    var ignoreElements = event.target.isContentEditable || [
                        "BUTTON",
                        "TEXTAREA",
                        "OPTION",
                        "INPUT",
                        "SELECT",
                        "VIDEO"
                    ].indexOf(target.nodeName) !== -1;
                    if (ignoreElements) return;
                }
                if (this.trigger("keydown", key, event) === false) return;
                var action = keyboard[key];
                if (typeof this[action] === "function") this[action]();
            }
        },
        {
            /**
   * Get the active slide. This will be the first slide from the current page of the main carousel.
   */ key: "getSlide",
            value: function getSlide() {
                var carousel = this.Carousel;
                if (!carousel) return null;
                var page = carousel.page === null ? carousel.option("initialPage") : carousel.page;
                var pages = carousel.pages || [];
                if (pages.length && pages[page]) return pages[page].slides[0];
                return null;
            }
        },
        {
            /**
   * Place focus on the first focusable element inside current slide
   * @param {Event} [event] - Focus event
   */ key: "focus",
            value: function focus(event) {
                if (Fancybox.ignoreFocusChange) return;
                if ([
                    "init",
                    "closing",
                    "customClosing",
                    "destroy"
                ].indexOf(this.state) > -1) return;
                var $container = this.$container;
                var currentSlide = this.getSlide();
                var $currentSlide = currentSlide.state === "done" ? currentSlide.$el : null;
                // Skip if the DOM element that is currently in focus is already inside the current slide
                if ($currentSlide && $currentSlide.contains(document.activeElement)) return;
                if (event) event.preventDefault();
                Fancybox.ignoreFocusChange = true;
                var allFocusableElems = Array.from($container.querySelectorAll((0, $eb0b16180e564216$export$6a59c51278cd7bb1)));
                var enabledElems = [];
                var $firstEl;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = allFocusableElems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var node = _step.value;
                        // Enable element if it's visible and
                        // is inside the current slide or is outside main carousel (for example, inside the toolbar)
                        var isNodeVisible = node.offsetParent;
                        var isNodeInsideCurrentSlide = $currentSlide && $currentSlide.contains(node);
                        var isNodeOutsideCarousel = !this.Carousel.$viewport.contains(node);
                        if (isNodeVisible && (isNodeInsideCurrentSlide || isNodeOutsideCarousel)) {
                            enabledElems.push(node);
                            if (node.dataset.origTabindex !== undefined) {
                                node.tabIndex = node.dataset.origTabindex;
                                node.removeAttribute("data-orig-tabindex");
                            }
                            if (node.hasAttribute("autoFocus") || !$firstEl && isNodeInsideCurrentSlide && !node.classList.contains("carousel__button")) $firstEl = node;
                        } else {
                            // Element is either hidden or is inside preloaded slide (e.g., not inside current slide, but next/prev)
                            node.dataset.origTabindex = node.dataset.origTabindex === undefined ? node.getAttribute("tabindex") : node.dataset.origTabindex;
                            node.tabIndex = -1;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (!event) {
                    if (this.option("autoFocus") && $firstEl) (0, $eb0b16180e564216$export$5a51bc2ba3a0d25)($firstEl);
                    else if (enabledElems.indexOf(document.activeElement) < 0) (0, $eb0b16180e564216$export$5a51bc2ba3a0d25)($container);
                } else {
                    if (enabledElems.indexOf(event.target) > -1) this.lastFocus = event.target;
                    else if (this.lastFocus === $container) (0, $eb0b16180e564216$export$5a51bc2ba3a0d25)(enabledElems[enabledElems.length - 1]);
                    else (0, $eb0b16180e564216$export$5a51bc2ba3a0d25)($container);
                }
                this.lastFocus = document.activeElement;
                Fancybox.ignoreFocusChange = false;
            }
        },
        {
            /**
   * Hide vertical page scrollbar and adjust right padding value of `body` element to prevent content from shifting
   * (otherwise the `body` element may become wider and the content may expand horizontally).
   */ key: "hideScrollbar",
            value: function hideScrollbar() {
                if (!(0, $041aa9e7dc769c90$export$71594e8a50f746f4)) return;
                var scrollbarWidth = window.innerWidth - document.documentElement.getBoundingClientRect().width;
                var id = "fancybox-style-noscroll";
                var $style = document.getElementById(id);
                if ($style) return;
                if (scrollbarWidth > 0) {
                    $style = document.createElement("style");
                    $style.id = id;
                    $style.type = "text/css";
                    $style.innerHTML = ".compensate-for-scrollbar {padding-right: ".concat(scrollbarWidth, "px;}");
                    document.getElementsByTagName("head")[0].appendChild($style);
                    document.body.classList.add("compensate-for-scrollbar");
                }
            }
        },
        {
            /**
   * Stop hiding vertical page scrollbar
   */ key: "revealScrollbar",
            value: function revealScrollbar() {
                document.body.classList.remove("compensate-for-scrollbar");
                var el = document.getElementById("fancybox-style-noscroll");
                if (el) el.remove();
            }
        },
        {
            /**
   * Remove content for given slide
   * @param {Object} slide - Carousel slide
   */ key: "clearContent",
            value: function clearContent(slide) {
                // * Clear previously added content and class name
                this.Carousel.trigger("removeSlide", slide);
                if (slide.$content) {
                    slide.$content.remove();
                    slide.$content = null;
                }
                if (slide.$closeButton) {
                    slide.$closeButton.remove();
                    slide.$closeButton = null;
                }
                if (slide._className) slide.$el.classList.remove(slide._className);
            }
        },
        {
            /**
   * Set new content for given slide
   * @param {Object} slide - Carousel slide
   * @param {HTMLElement|String} html - HTML element or string containing HTML code
   * @param {Object} [opts] - Options
   */ key: "setContent",
            value: function setContent(slide, html) {
                var opts = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var $content;
                var $el = slide.$el;
                if (html instanceof HTMLElement) {
                    if ([
                        "img",
                        "iframe",
                        "video",
                        "audio"
                    ].indexOf(html.nodeName.toLowerCase()) > -1) {
                        $content = document.createElement("div");
                        $content.appendChild(html);
                    } else $content = html;
                } else {
                    var $fragment = document.createRange().createContextualFragment(html);
                    $content = document.createElement("div");
                    $content.appendChild($fragment);
                }
                if (slide.filter && !slide.error) $content = $content.querySelector(slide.filter);
                if (!($content instanceof Element)) {
                    this.setError(slide, "{{ELEMENT_NOT_FOUND}}");
                    return;
                }
                // * Add class name indicating content type, for example `has-image`
                slide._className = "has-".concat(opts.suffix || slide.type || "unknown");
                $el.classList.add(slide._className);
                // * Set content
                $content.classList.add("fancybox__content");
                // Make sure that content is not hidden and will be visible
                if ($content.style.display === "none" || getComputedStyle($content).getPropertyValue("display") === "none") $content.style.display = slide.display || this.option("defaultDisplay") || "flex";
                if (slide.id) $content.setAttribute("id", slide.id);
                slide.$content = $content;
                $el.prepend($content);
                this.manageCloseButton(slide);
                if (slide.state !== "loading") this.revealContent(slide);
                return $content;
            }
        },
        {
            /**
   * Create close button if needed
   * @param {Object} slide
   */ key: "manageCloseButton",
            value: function manageCloseButton(slide) {
                var _this = this;
                var position = slide.closeButton === undefined ? this.option("closeButton") : slide.closeButton;
                if (!position || position === "top" && this.$closeButton) return;
                var $btn = document.createElement("button");
                $btn.classList.add("carousel__button", "is-close");
                $btn.setAttribute("title", this.options.l10n.CLOSE);
                $btn.innerHTML = this.option("template.closeButton");
                $btn.addEventListener("click", function(e) {
                    return _this.close(e);
                });
                if (position === "inside") {
                    // Remove existing one to avoid scope issues
                    if (slide.$closeButton) slide.$closeButton.remove();
                    slide.$closeButton = slide.$content.appendChild($btn);
                } else this.$closeButton = this.$container.insertBefore($btn, this.$container.firstChild);
            }
        },
        {
            /**
   * Make content visible for given slide and optionally start CSS animation
   * @param {Object} slide - Carousel slide
   */ key: "revealContent",
            value: function revealContent(slide) {
                var _this = this;
                this.trigger("reveal", slide);
                slide.$content.style.visibility = "";
                // Add CSS class name that reveals content (default animation is "fadeIn")
                var showClass = false;
                if (!(slide.error || slide.state === "loading" || this.Carousel.prevPage !== null || slide.index !== this.options.startIndex)) showClass = slide.showClass === undefined ? this.option("showClass") : slide.showClass;
                if (!showClass) {
                    this.done(slide);
                    return;
                }
                slide.state = "animating";
                this.animateCSS(slide.$content, showClass, function() {
                    _this.done(slide);
                });
            }
        },
        {
            /**
   * Add class name to given HTML element and wait for `animationend` event to execute callback
   * @param {HTMLElement} $el
   * @param {String} className
   * @param {Function} callback - A callback to run
   */ key: "animateCSS",
            value: function animateCSS($element, className, callback) {
                if ($element) $element.dispatchEvent(new CustomEvent("animationend", {
                    bubbles: true,
                    cancelable: true
                }));
                if (!$element || !className) {
                    if (typeof callback === "function") callback();
                    return;
                }
                var handleAnimationEnd = function handleAnimationEnd1(event) {
                    if (event.currentTarget === this) {
                        $element.removeEventListener("animationend", handleAnimationEnd);
                        if (callback) callback();
                        $element.classList.remove(className);
                    }
                };
                $element.addEventListener("animationend", handleAnimationEnd);
                $element.classList.add(className);
            }
        },
        {
            /**
   * Mark given slide as `done`, e.g., content is loaded and displayed completely
   * @param {Object} slide - Carousel slide
   */ key: "done",
            value: function done(slide) {
                slide.state = "done";
                this.trigger("done", slide);
                // Trigger focus for current slide (and ignore preloaded slides)
                var currentSlide = this.getSlide();
                if (currentSlide && slide.index === currentSlide.index && this.option("autoFocus")) this.focus();
            }
        },
        {
            /**
   * Set error message as slide content
   * @param {Object} slide - Carousel slide
   * @param {String} message - Error message, can contain HTML code and template variables
   */ key: "setError",
            value: function setError(slide, message) {
                slide.error = message;
                this.hideLoading(slide);
                this.clearContent(slide);
                // Create new content
                var div = document.createElement("div");
                div.classList.add("fancybox-error");
                div.innerHTML = this.localize(message || "<p>{{ERROR}}</p>");
                this.setContent(slide, div, {
                    suffix: "error"
                });
            }
        },
        {
            /**
   * Create loading indicator inside given slide
   * @param {Object} slide - Carousel slide
   */ key: "showLoading",
            value: function showLoading(slide) {
                var _this = this;
                slide.state = "loading";
                slide.$el.classList.add("is-loading");
                var $spinner = slide.$el.querySelector(".fancybox__spinner");
                if ($spinner) return;
                $spinner = document.createElement("div");
                $spinner.classList.add("fancybox__spinner");
                $spinner.innerHTML = this.option("template.spinner");
                $spinner.addEventListener("click", function() {
                    if (!_this.Carousel.Panzoom.velocity) _this.close();
                });
                slide.$el.prepend($spinner);
            }
        },
        {
            /**
   * Remove loading indicator from given slide
   * @param {Object} slide - Carousel slide
   */ key: "hideLoading",
            value: function hideLoading(slide) {
                var $spinner = slide.$el && slide.$el.querySelector(".fancybox__spinner");
                if ($spinner) {
                    $spinner.remove();
                    slide.$el.classList.remove("is-loading");
                }
                if (slide.state === "loading") {
                    this.trigger("load", slide);
                    slide.state = "ready";
                }
            }
        },
        {
            /**
   * Slide carousel to next page
   */ key: "next",
            value: function next() {
                var carousel = this.Carousel;
                if (carousel && carousel.pages.length > 1) carousel.slideNext();
            }
        },
        {
            /**
   * Slide carousel to previous page
   */ key: "prev",
            value: function prev() {
                var carousel = this.Carousel;
                if (carousel && carousel.pages.length > 1) carousel.slidePrev();
            }
        },
        {
            /**
   * Slide carousel to selected page with optional parameters
   * Examples:
   *    Fancybox.getInstance().jumpTo(2);
   *    Fancybox.getInstance().jumpTo(3, {friction: 0})
   * @param  {...any} args - Arguments for Carousel `slideTo` method
   */ key: "jumpTo",
            value: function jumpTo() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this_Carousel;
                if (this.Carousel) (_this_Carousel = this.Carousel).slideTo.apply(_this_Carousel, (0, $b6a26340ba3e8c80$export$71511d61b312f219)(args));
            }
        },
        {
            /**
   * Check if current instance is trying to close or is already closed
   * @returns {Boolean}
   */ key: "isClosing",
            value: function isClosing() {
                return [
                    "closing",
                    "customClosing",
                    "destroy"
                ].includes(this.state);
            }
        },
        {
            /**
   * Check if the current instance is not blocked by another instance
   * @returns {Boolean}
   */ key: "isTopmost",
            value: function isTopmost() {
                return Fancybox.getInstance().id == this.id;
            }
        },
        {
            /**
   * Start closing the current instance
   * @param {Event} [event] - Optional click event
   */ key: "close",
            value: function close(event) {
                var _this = this;
                if (event) event.preventDefault();
                // First, stop further execution if this instance is already closing
                // (this can happen if, for example, user clicks close button multiple times really fast)
                if (this.isClosing()) return;
                // Allow callbacks and/or plugins to prevent closing
                if (this.trigger("shouldClose", event) === false) return;
                this.state = "closing";
                this.Carousel.Panzoom.destroy();
                this.detachEvents();
                this.trigger("closing", event);
                if (this.state === "destroy") return;
                // Trigger default CSS closing animation for backdrop and interface elements
                this.$container.setAttribute("aria-hidden", "true");
                this.$container.classList.add("is-closing");
                // Clear inactive slides
                var currentSlide = this.getSlide();
                this.Carousel.slides.forEach(function(slide) {
                    if (slide.$content && slide.index !== currentSlide.index) _this.Carousel.trigger("removeSlide", slide);
                });
                // Start default closing animation
                if (this.state === "closing") {
                    var hideClass = currentSlide.hideClass === undefined ? this.option("hideClass") : currentSlide.hideClass;
                    this.animateCSS(currentSlide.$content, hideClass, function() {
                        _this.destroy();
                    }, true);
                }
            }
        },
        {
            /**
   * Clean up after closing fancybox
   */ key: "destroy",
            value: function destroy() {
                if (this.state === "destroy") return;
                this.state = "destroy";
                this.trigger("destroy");
                var $trigger = this.option("placeFocusBack") ? this.option("triggerTarget", this.getSlide().$trigger) : null;
                // Destroy Carousel and then detach plugins;
                // * Note: this order allows plugins to receive `removeSlide` event
                this.Carousel.destroy();
                this.detachPlugins();
                this.Carousel = null;
                this.options = {};
                this.events = {};
                this.$container.remove();
                this.$container = this.$backdrop = this.$carousel = null;
                if ($trigger) (0, $eb0b16180e564216$export$5a51bc2ba3a0d25)($trigger);
                $df5a56240bf9e90a$var$instances["delete"](this.id);
                var nextInstance = Fancybox.getInstance();
                if (nextInstance) {
                    nextInstance.focus();
                    return;
                }
                document.documentElement.classList.remove("with-fancybox");
                document.body.classList.remove("is-using-mouse");
                this.revealScrollbar();
            }
        }
    ], [
        {
            key: "show",
            value: /**
   * Create new Fancybox instance with provided options
   * Example:
   *   Fancybox.show([{ src : 'https://lipsum.app/id/1/300x225' }]);
   * @param {Array} items - Gallery items
   * @param {Object} [options] - Optional custom options
   * @returns {Object} Fancybox instance
   */ function show(items) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return new Fancybox(items, options);
            }
        },
        {
            key: "fromEvent",
            value: /**
   * Starts Fancybox if event target matches any opener or target is `trigger element`
   * @param {Event} event - Click event
   * @param {Object} [options] - Optional custom options
   */ function fromEvent(event) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                //  Allow other scripts to prevent starting fancybox on click
                if (event.defaultPrevented) return;
                // Don't run if right-click
                if (event.button && event.button !== 0) return;
                // Ignore command/control + click
                if (event.ctrlKey || event.metaKey || event.shiftKey) return;
                var origTarget = event.composedPath()[0];
                var eventTarget = origTarget;
                // Support `trigger` element, e.g., start fancybox from different DOM element, for example,
                // to have one preview image for hidden image gallery
                var triggerGroupName;
                if (eventTarget.matches("[data-fancybox-trigger]") || (eventTarget = eventTarget.closest("[data-fancybox-trigger]"))) {
                    options.triggerTarget = eventTarget;
                    triggerGroupName = eventTarget && eventTarget.dataset && eventTarget.dataset.fancyboxTrigger;
                }
                if (triggerGroupName) {
                    var triggerItems = document.querySelectorAll('[data-fancybox="'.concat(triggerGroupName, '"]'));
                    var triggerIndex = parseInt(eventTarget.dataset.fancyboxIndex, 10) || 0;
                    eventTarget = triggerItems.length ? triggerItems[triggerIndex] : eventTarget;
                }
                // * Try to find matching openener
                var matchingOpener;
                var target;
                Array.from(Fancybox.openers.keys()).reverse().some(function(opener) {
                    target = eventTarget || origTarget;
                    var found = false;
                    try {
                        if (target instanceof Element && (typeof opener === "string" || opener instanceof String)) // Chain closest() to event.target to find and return the parent element,
                        // regardless if clicking on the child elements (icon, label, etc)
                        found = target.matches(opener) || (target = target.closest(opener));
                    } catch (error) {}
                    if (found) {
                        event.preventDefault();
                        matchingOpener = opener;
                        return true;
                    }
                    return false;
                });
                var rez = false;
                if (matchingOpener) {
                    options.event = event;
                    options.target = target;
                    target.origTarget = origTarget;
                    rez = Fancybox.fromOpener(matchingOpener, options);
                    // Check if the mouse is being used
                    // Waiting for better browser support for `:focus-visible` -
                    // https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo
                    var nextInstance = Fancybox.getInstance();
                    if (nextInstance && nextInstance.state === "ready" && event.detail) document.body.classList.add("is-using-mouse");
                }
                return rez;
            }
        },
        {
            key: "fromOpener",
            value: /**
   * Starts Fancybox using selector
   * @param {String} opener - Valid CSS selector string
   * @param {Object} [options] - Optional custom options
   */ function fromOpener(opener) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                // Callback function called once for each group element that
                // 1) converts data attributes to boolean or JSON
                // 2) removes values that could cause issues
                var mapCallback = function mapCallback(el) {
                    var falseValues = [
                        "false",
                        "0",
                        "no",
                        "null",
                        "undefined"
                    ];
                    var trueValues = [
                        "true",
                        "1",
                        "yes"
                    ];
                    var dataset = Object.assign({}, el.dataset);
                    var options = {};
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.entries(dataset)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = (0, $1933fb0d7df0f802$export$71511d61b312f219)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                            if (key === "fancybox") continue;
                            if (key === "width" || key === "height") options["_".concat(key)] = value;
                            else if (typeof value === "string" || value instanceof String) {
                                if (falseValues.indexOf(value) > -1) options[key] = false;
                                else if (trueValues.indexOf(options[key]) > -1) options[key] = true;
                                else try {
                                    options[key] = JSON.parse(value);
                                } catch (e) {
                                    options[key] = value;
                                }
                            } else options[key] = value;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    if (el instanceof Element) options.$trigger = el;
                    return options;
                };
                var items = [], index = options.startIndex || 0, target = options.target || null;
                // Get options
                // ===
                options = (0, $473ff96f0aaf0a3a$export$8b58be045bf06082)({}, options, Fancybox.openers.get(opener));
                // Get matching nodes
                // ===
                var groupAll = options.groupAll === undefined ? false : options.groupAll;
                var groupAttr = options.groupAttr === undefined ? "data-fancybox" : options.groupAttr;
                var groupValue = groupAttr && target ? target.getAttribute("".concat(groupAttr)) : "";
                if (!target || groupValue || groupAll) {
                    var $root = options.root || (target ? target.getRootNode() : document.body);
                    items = [].slice.call($root.querySelectorAll(opener));
                }
                if (target && !groupAll) {
                    if (groupValue) items = items.filter(function(el) {
                        return el.getAttribute("".concat(groupAttr)) === groupValue;
                    });
                    else items = [
                        target
                    ];
                }
                if (!items.length) return false;
                // Exit if current instance is triggered from the same element
                // ===
                var currentInstance = Fancybox.getInstance();
                if (currentInstance && items.indexOf(currentInstance.options.$trigger) > -1) return false;
                // Start Fancybox
                // ===
                // Get index of current item in the gallery
                index = target ? items.indexOf(target) : index;
                // Convert items in a format supported by fancybox
                items = items.map(mapCallback);
                // * Create new fancybox instance
                return new Fancybox(items, (0, $473ff96f0aaf0a3a$export$8b58be045bf06082)({}, options, {
                    startIndex: index,
                    $trigger: target
                }));
            }
        },
        {
            key: "bind",
            value: /**
   * Attach a click handler function that starts Fancybox to the selected items, as well as to all future matching elements.
   * @param {String} selector - Selector that should match trigger elements
   * @param {Object} [options] - Custom options
   */ function bind(selector) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                function attachClickEvent() {
                    document.body.addEventListener("click", Fancybox.fromEvent, false);
                }
                if (!(0, $041aa9e7dc769c90$export$71594e8a50f746f4)) return;
                if (!Fancybox.openers.size) {
                    if (/complete|interactive|loaded/.test(document.readyState)) attachClickEvent();
                    else document.addEventListener("DOMContentLoaded", attachClickEvent);
                }
                Fancybox.openers.set(selector, options);
            }
        },
        {
            key: "unbind",
            value: /**
   * Remove the click handler that was attached with `bind()`
   * @param {String} selector - A selector which should match the one originally passed to .bind()
   */ function unbind(selector) {
                Fancybox.openers["delete"](selector);
                if (!Fancybox.openers.size) Fancybox.destroy();
            }
        },
        {
            key: "destroy",
            value: /**
   * Immediately destroy all instances (without closing animation) and clean up all bindings..
   */ function destroy() {
                var fb;
                while(fb = Fancybox.getInstance())fb.destroy();
                Fancybox.openers = new Map();
                document.body.removeEventListener("click", Fancybox.fromEvent, false);
            }
        },
        {
            key: "getInstance",
            value: /**
   * Retrieve instance by identifier or the top most instance, if identifier is not provided
   * @param {String|Numeric} [id] - Optional instance identifier
   */ function getInstance(id) {
                if (id) return $df5a56240bf9e90a$var$instances.get(id);
                var instance = Array.from($df5a56240bf9e90a$var$instances.values()).reverse().find(function(instance) {
                    if (!instance.isClosing()) return instance;
                    return false;
                });
                return instance || null;
            }
        },
        {
            key: "close",
            value: /**
   * Close all or topmost currently active instance.
   * @param {boolean} [all] - All or only topmost active instance
   * @param {any} [arguments] - Optional data
   */ function close() {
                var all = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, args = arguments.length > 1 ? arguments[1] : void 0;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (all) try {
                    for(var _iterator = $df5a56240bf9e90a$var$instances.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var instance = _step.value;
                        instance.close(args);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                else {
                    var instance1 = Fancybox.getInstance();
                    if (instance1) instance1.close(args);
                }
            }
        },
        {
            key: "next",
            value: /**
   * Slide topmost currently active instance to next page
   */ function next() {
                var instance = Fancybox.getInstance();
                if (instance) instance.next();
            }
        },
        {
            key: "prev",
            value: /**
   * Slide topmost currently active instance to previous page
   */ function prev() {
                var instance = Fancybox.getInstance();
                if (instance) instance.prev();
            }
        }
    ]);
    return Fancybox;
}((0, $633001db0e20238e$export$ef88aa0d34c34520));
// Expose version
$df5a56240bf9e90a$export$cb45b08d97cdc4fd.version = "__VERSION__";
// Expose defaults
$df5a56240bf9e90a$export$cb45b08d97cdc4fd.defaults = $df5a56240bf9e90a$var$defaults;
// Expose openers
$df5a56240bf9e90a$export$cb45b08d97cdc4fd.openers = new Map();
// Add default plugins
$df5a56240bf9e90a$export$cb45b08d97cdc4fd.Plugins = (0, $363ed6cefe758d79$export$c203ca0aafe4939a);
// Auto init with default options
$df5a56240bf9e90a$export$cb45b08d97cdc4fd.bind("[data-fancybox]");
var $df5a56240bf9e90a$var$_iteratorNormalCompletion = true, $df5a56240bf9e90a$var$_didIteratorError = false, $df5a56240bf9e90a$var$_iteratorError = undefined;
try {
    // Prepare plugins
    for(var $df5a56240bf9e90a$var$_iterator = Object.entries($df5a56240bf9e90a$export$cb45b08d97cdc4fd.Plugins || {})[Symbol.iterator](), $df5a56240bf9e90a$var$_step; !($df5a56240bf9e90a$var$_iteratorNormalCompletion = ($df5a56240bf9e90a$var$_step = $df5a56240bf9e90a$var$_iterator.next()).done); $df5a56240bf9e90a$var$_iteratorNormalCompletion = true){
        var $df5a56240bf9e90a$var$_step_value = (0, $1933fb0d7df0f802$export$71511d61b312f219)($df5a56240bf9e90a$var$_step.value, 2), $df5a56240bf9e90a$var$key = $df5a56240bf9e90a$var$_step_value[0], $df5a56240bf9e90a$var$Plugin = $df5a56240bf9e90a$var$_step_value[1];
        if (typeof $df5a56240bf9e90a$var$Plugin.create === "function") $df5a56240bf9e90a$var$Plugin.create($df5a56240bf9e90a$export$cb45b08d97cdc4fd);
    }
} catch (err) {
    $df5a56240bf9e90a$var$_didIteratorError = true;
    $df5a56240bf9e90a$var$_iteratorError = err;
} finally{
    try {
        if (!$df5a56240bf9e90a$var$_iteratorNormalCompletion && $df5a56240bf9e90a$var$_iterator["return"] != null) {
            $df5a56240bf9e90a$var$_iterator["return"]();
        }
    } finally{
        if ($df5a56240bf9e90a$var$_didIteratorError) {
            throw $df5a56240bf9e90a$var$_iteratorError;
        }
    }
}


function $d535db0ade42c13c$export$f52e4068a3d581f5() {
    try {
        var globalHint = document.getElementById("typografie-hint");
        var hideGlobalHint = function() {
            if (globalHint && !globalHint.classList.contains("is-hidden")) globalHint.classList.add("is-hidden");
        };
        var sliders = document.querySelectorAll(".typografie-size-range");
        sliders.forEach(function(slider) {
            var id = slider.id || "";
            var targetId = id.replace("sizeRange-", "preview-line-");
            var line = document.getElementById(targetId);
            if (!line) return;
            var apply = function() {
                var value = parseFloat(slider.value);
                if (!Number.isFinite(value)) return;
                var isMobile = typeof window !== "undefined" && window.matchMedia && window.matchMedia("(max-width: 600px)").matches;
                // Schriftgröße
                line.style.fontSize = value + "em";
                // Defaults für große Größen: einspaltig, kein Umbruch
                line.style.columnCount = "1";
                line.style.whiteSpace = "nowrap";
                line.style.overflowWrap = "normal";
                line.style.wordWrap = "normal"; // Legacy alias
                line.style.lineHeight = "1"; // einheitenlos, multipliziert mit aktueller Schriftgröße
                line.style.height = "";
                // Für kleine Größen mehrspaltig und Umbruch aktivieren
                if (value < 1.5) {
                    // Mobile: stets einspaltig
                    line.style.columnCount = isMobile ? "1" : "3";
                    line.style.whiteSpace = "normal";
                    line.style.overflowWrap = "break-word";
                    line.style.wordWrap = "break-word";
                    line.style.lineHeight = "1.2"; // einheitenlos statt value*1.2em
                } else if (value < 3) {
                    line.style.columnCount = isMobile ? "1" : "2";
                    line.style.whiteSpace = "normal";
                    line.style.overflowWrap = "break-word";
                    line.style.wordWrap = "break-word";
                    line.style.lineHeight = "1.2";
                } else if (value < 4) {
                    // einspaltig, aber mit Umbruch
                    line.style.columnCount = "1";
                    line.style.whiteSpace = "normal";
                    line.style.overflowWrap = "break-word";
                    line.style.wordWrap = "break-word";
                    line.style.lineHeight = "1.2";
                }
            };
            slider.addEventListener("input", apply);
            slider.addEventListener("change", apply);
            // Erste Interaktion blendet den globalen Hinweis aus
            slider.addEventListener("input", hideGlobalHint);
            line.addEventListener("focus", hideGlobalHint);
            line.addEventListener("pointerdown", hideGlobalHint);
            line.addEventListener("keydown", hideGlobalHint);
            line.addEventListener("input", hideGlobalHint);
            // Bei Fenstergrößenwechsel Spalten neu berechnen
            window.addEventListener("resize", apply);
            window.addEventListener("orientationchange", apply);
            // Nur Plaintext einfügen (kein Rich-Text/HTML)
            line.addEventListener("paste", function(e) {
                try {
                    e.preventDefault();
                } catch (_) {}
                var clipboard = e.clipboardData || window.clipboardData;
                var text = clipboard ? clipboard.getData("text/plain") : "";
                // Insert plaintext an Cursorposition
                if (document.queryCommandSupported && document.queryCommandSupported("insertText")) {
                    document.execCommand("insertText", false, text);
                    return;
                }
                var sel = window.getSelection && window.getSelection();
                if (sel && sel.rangeCount) {
                    var range = sel.getRangeAt(0);
                    range.deleteContents();
                    range.insertNode(document.createTextNode(text));
                    range.collapse(false);
                    return;
                }
                line.textContent = (line.textContent || "") + text;
            });
            // Initialisieren
            apply();
        });
        // Nach Barba-Transition zur Hash-Ziel-ID scrollen (z. B. #preview-line-slug)
        var scrollToHash = function() {
            var raw = window.location.hash || "";
            if (!raw) return;
            var id = decodeURIComponent(raw.substring(1));
            var el = document.getElementById(id);
            if (!el) return;
            // kleinen Delay, damit Layout/Fonts stehen
            setTimeout(function() {
                try {
                    el.scrollIntoView({
                        behavior: "smooth",
                        block: "center"
                    });
                } catch (_) {
                    var r = el.getBoundingClientRect();
                    window.scrollTo({
                        top: window.scrollY + r.top - window.innerHeight / 2,
                        behavior: "smooth"
                    });
                }
            }, 60);
        };
        // Direkt nach Initialisierung versuchen
        requestAnimationFrame(scrollToHash);
        // Auch auf spätere Hash-Änderungen reagieren
        window.addEventListener("hashchange", scrollToHash);
    } catch (e) {
        console.warn("initTypografiePage error", e);
    }
}


var $7da8fd3b60376ace$var$customViewportCorrectionVariable = 'vh';
//Fix 100vh Problem:
var $7da8fd3b60376ace$var$setViewportProperty = function(doc) {
    var prevClientHeight;
    var customVar = '--' + ($7da8fd3b60376ace$var$customViewportCorrectionVariable || 'vh');
    var handleResize = function() {
        var clientHeight = doc.clientHeight;
        if (clientHeight === prevClientHeight) return;
        requestAnimationFrame(function updateViewportHeight() {
            doc.style.setProperty(customVar, clientHeight * 0.01 + 'px');
            prevClientHeight = clientHeight;
        });
    };
    handleResize();
    return handleResize;
};
window.addEventListener('resize', $7da8fd3b60376ace$var$setViewportProperty(document.documentElement));
window.addEventListener('orientationchange', $7da8fd3b60376ace$var$setViewportProperty(document.documentElement));


function $0ef703704a1ff525$var$syncIncomingAssets(html) {
    if (!html || typeof DOMParser === "undefined") return;
    var doc;
    try {
        doc = new DOMParser().parseFromString(html, "text/html");
    } catch (e) {
        return;
    }
    doc.querySelectorAll("style[id], link[rel='stylesheet'][id]").forEach(function(node) {
        var id = node.id;
        if (!id) return;
        var existing = document.getElementById(id);
        if (node.tagName === "STYLE") {
            var css = node.textContent || "";
            if (existing && existing.tagName === "STYLE") {
                if (existing.textContent !== css) existing.textContent = css;
                return;
            }
            var style = document.createElement("style");
            style.id = id;
            style.textContent = css;
            document.head.appendChild(style);
            return;
        }
        var href = node.getAttribute("href");
        if (!href || existing) return;
        var link = document.createElement("link");
        link.id = id;
        link.rel = "stylesheet";
        link.href = href;
        var media = node.getAttribute("media");
        if (media) link.media = media;
        document.head.appendChild(link);
    });
}
function $0ef703704a1ff525$var$autoplay_videos() {
    //Autoplaying Videos:
    document.querySelectorAll("video").forEach(function(vid) {
        var playPromise = vid.play();
        if (playPromise !== undefined) playPromise.then(function(_) {})["catch"](function(error) {
            console.log(error);
        });
    });
}
document.addEventListener("DOMContentLoaded", function() {
    //Darkmode in Systemeinstellungen oder Local Storage erkennen und übernehmen
    if (window.matchMedia("(prefers-color-scheme: dark)").matches || sessionStorage.getItem("darkmode") == "true") document.getElementsByTagName("html")[0].classList.add("darkmode");
    (0, (/*@__PURE__*/$parcel$interopDefault($eec3d7233e50cb35$exports))).init({
        timeout: 6000,
        //cacheIgnore: true,
        sync: true,
        prevent: function(param) {
            var el = param.el;
            if (!el) return false;
            return Boolean(el.closest("[data-barba-prevent], .wpml-ls-item, .wpml-ls-legacy-dropdown, .wpml-ls-statics-shortcode-item, .wpml-ls-legacy-list-horizontal, .language-switcher"));
        },
        transitions: [
            {
                once: function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $670431cece713cbd$export$71511d61b312f219)(function() {
                        return (0, $c201f6852eb68a0f$export$67ebef60e6f28a6)(this, function(_state) {
                            return [
                                2
                            ];
                        });
                    })();
                },
                enter: function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $670431cece713cbd$export$71511d61b312f219)(function() {
                        return (0, $c201f6852eb68a0f$export$67ebef60e6f28a6)(this, function(_state) {
                            document.getElementById("preloader").style.transform = "translateY(-120%)";
                            return [
                                2
                            ];
                        });
                    //document.getElementById('wrapD3Cube').classList.add('cube_translate')
                    })();
                },
                leave: function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $670431cece713cbd$export$71511d61b312f219)(function() {
                        var done;
                        return (0, $c201f6852eb68a0f$export$67ebef60e6f28a6)(this, function(_state) {
                            setTimeout(function() {
                                window.scrollTo(0, 0);
                            }, 500);
                            done = this.async();
                            document.getElementById("preloader").style.transform = "translateY(0)";
                            //document.getElementById('wrapD3Cube').classList.remove('cube_translate')
                            setTimeout(function() {
                                return done();
                            }, 900);
                            return [
                                2
                            ];
                        });
                    }).call(this);
                }
            }
        ],
        views: [
            {
                namespace: "page-typografie",
                beforeEnter: function() {},
                afterEnter: function() {
                    (0, $d535db0ade42c13c$export$f52e4068a3d581f5)();
                },
                afterLeave: function() {}
            },
            {
                namespace: "home",
                beforeEnter: function() {},
                afterEnter: function() {
                    $0ef703704a1ff525$var$autoplay_videos();
                },
                afterLeave: function() {}
            },
            {
                namespace: "single-author",
                beforeEnter: function() {},
                afterEnter: function() {
                    $0ef703704a1ff525$var$autoplay_videos();
                    var lebenslauf_toggler = document.getElementById("lebenslauf_toggler");
                    if (lebenslauf_toggler) lebenslauf_toggler.addEventListener("click", function() {
                        document.getElementById("kachel-student_single").classList.toggle("lebenslauf-out");
                    });
                },
                afterLeave: function() {}
            },
            {
                namespace: "single-projekt",
                beforeEnter: function() {},
                afterEnter: function() {
                    (0, $df5a56240bf9e90a$export$cb45b08d97cdc4fd).bind("[data-fancybox-href] img", {
                        caption: function caption(fancybox, carousel, slide) {
                            var p = slide.$trigger.parentElement.parentElement;
                            var t = slide.caption;
                            if (p.nodeName === "FIGURE" && p.getElementsByTagName("figcaption")[0]) t = p.getElementsByTagName("figcaption")[0].innerHTML;
                            return t;
                        },
                        groupAll: true,
                        on: {
                            ready: function() {}
                        }
                    });
                },
                afterLeave: function() {}
            }
        ]
    });
    if ("scrollRestoration" in history) history.scrollRestoration = "manual";
    (0, (/*@__PURE__*/$parcel$interopDefault($eec3d7233e50cb35$exports))).hooks.afterLeave(function() {
        document.body.classList.remove("menu_out");
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($eec3d7233e50cb35$exports))).hooks.beforeEnter(function(data) {
        $0ef703704a1ff525$var$syncIncomingAssets(data.next && data.next.html);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($eec3d7233e50cb35$exports))).hooks.enter(function(data) {
        var htmlTag = data.next.html.match(/<html[^>]*>/i);
        if (htmlTag) {
            var lang = htmlTag[0].match(/\slang=["']([^"']+)["']/i);
            if (lang) document.documentElement.setAttribute("lang", lang[1]);
            var dir = htmlTag[0].match(/\sdir=["']([^"']+)["']/i);
            if (dir) document.documentElement.setAttribute("dir", dir[1]);
        }
        var titleMatch = data.next.html.match(/<title[^>]*>([\s\S]*?)<\/title>/i);
        if (titleMatch) {
            var titleEl = document.createElement("textarea");
            titleEl.innerHTML = titleMatch[1];
            var title = titleEl.value.trim();
            if (title) document.title = title;
        }
        //Update body-classes
        var regexp = /\<body.*\sclass=["'](.+?)["'].*\>/gi, match = regexp.exec(data.next.html);
        if (!match || !match[1]) // If no body class, remove it
        document.body.setAttribute("class", "");
        else // Set the new body class
        document.body.setAttribute("class", match[1]);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($eec3d7233e50cb35$exports))).hooks.afterEnter(function() {
        document.querySelectorAll(".menu-button").forEach(function(menu_button) {
            menu_button.addEventListener("click", function() {
                document.body.classList.toggle("menu_out");
            });
        });
        document.querySelectorAll(".darkmode_switch").forEach(function(darkmode_switch) {
            darkmode_switch.addEventListener("click", function() {
                document.getElementsByTagName("html")[0].classList.toggle("darkmode");
                //In LocalStorage speichern
                document.getElementsByTagName("html")[0].classList.contains("darkmode") ? sessionStorage.setItem("darkmode", "true") : sessionStorage.setItem("darkmode", "false");
            });
        });
    });
    //Matomo
    (0, (/*@__PURE__*/$parcel$interopDefault($eec3d7233e50cb35$exports))).hooks.after(function() {
        _paq.push([
            "setCustomUrl",
            location.href
        ]);
        _paq.push([
            "setDocumentTitle",
            document.title
        ]);
        _paq.push([
            "trackPageView"
        ]);
    });
});

})();
//# sourceMappingURL=index.0316b08b.js.map
